export const Items = [ 
    {
        id: 1,
        tigerCode: 308127,
        name: "СТОЛ CE-TC060X60",
        brand: "CROM",
        size: "600x600x850",
        productCode: "CE-TC060X60",
        uri: "table_ce-tc060x60",
        category: "table"
       },
       {
        id: 2,
        tigerCode: 305650,
        name: "СТОЛ CO-TC060X60",
        brand: "COTTO",
        size: "600x600x850",
        productCode: "CO-TC060X60",
        uri: "table_co-tc060x60",
        category: "table"
       },
       {
        id: 3,
        tigerCode: "308134",
        name: "СТОЛ CE-TC060X70",
        brand: "CROM",
        size: "600x700x850",
        productCode: "CE-TC060X70",
        uri: "table_ce-tc060x70",
        category: "table"
       },
       {
        id: 4,
        tigerCode: 305657,
        name: "СТОЛ CO-TC060X70",
        brand: "COTTO",
        size: "600x700x850",
        productCode: "CO-TC060X70",
        uri: "table_co-tc060x70",
        category: "table"
       },
       {
        id: 5,
        tigerCode: 326027,
        name: "СТОЛ CE-TC070X60",
        brand: "CROM",
        size: "700x600x850",
        productCode: "CE-TC070X60",
        uri: "table_ce-tc070x60",
        category: "table"
       },
       {
        id: 6,
        tigerCode: 347064,
        name: "СТОЛ CO-TC070X60",
        brand: "COTTO",
        size: "700x600x850",
        productCode: "CO-TC070X60",
        uri: "table_co-tc070x60",
        category: "table"
       },
       {
        id: 7,
        tigerCode: 309408,
        name: "СТОЛ CE-TC070X70",
        brand: "CROM",
        size: "700x700x850",
        productCode: "CE-TC070X70",
        uri: "table_ce-tc070x70",
        category: "table"
       },
       {
        id: 8,
        tigerCode: 306850,
        name: "СТОЛ CO-TC070X70",
        brand: "COTTO",
        size: "700x700x850",
        productCode: "CO-TC070X70",
        uri: "table_co-tc070x70",
        category: "table"
       },
       {
        id: 9,
        tigerCode: "308128",
        name: "СТОЛ CE-TC080X60",
        brand: "CROM",
        size: "800x600x850",
        productCode: "CE-TC080X60",
        uri: "table_ce-tc080x60",
        category: "table"
       },
       {
        id: 10,
        tigerCode: 305651,
        name: "СТОЛ CO-TC080X60",
        brand: "COTTO",
        size: "800x600x850",
        productCode: "CO-TC080X60",
        uri: "table_co-tc080x60",
        category: "table"
       },
       {
        id: 11,
        tigerCode: "308135",
        name: "СТОЛ CE-TC080X70",
        brand: "CROM",
        size: "800x700x850",
        productCode: "CE-TC080X70",
        uri: "table_ce-tc080x70",
        category: "table"
       },
       {
        id: 12,
        tigerCode: 305658,
        name: "СТОЛ CO-TC080X70",
        brand: "COTTO",
        size: "800x700x850",
        productCode: "CO-TC080X70",
        uri: "table_co-tc080x70",
        category: "table"
       },
       {
        id: 13,
        tigerCode: 342739,
        name: "СТОЛ CE-TC090X60",
        brand: "CROM",
        size: "900x600x850",
        productCode: "CE-TC090X60",
        uri: "table_ce-tc090x60",
        category: "table"
       },
       {
        id: 14,
        tigerCode: 347065,
        name: "СТОЛ CO-TC090X60",
        brand: "COTTO",
        size: "900x600x850",
        productCode: "CO-TC090X60",
        uri: "table_co-tc090x60",
        category: "table"
       },
       {
        id: 15,
        tigerCode: 309495,
        name: "СТОЛ CE-TC090X70",
        brand: "CROM",
        size: "900x700x850",
        productCode: "CE-TC090X70",
        uri: "table_ce-tc090x70",
        category: "table"
       },
       {
        id: 16,
        tigerCode: 310971,
        name: "СТОЛ CO-TC090X70",
        brand: "COTTO",
        size: "900x700x850",
        productCode: "CO-TC090X70",
        uri: "table_co-tc090x70",
        category: "table"
       },
       {
        id: 17,
        tigerCode: "308129",
        name: "СТОЛ CE-TC0100X60",
        brand: "CROM",
        size: "1000x600x850",
        productCode: "CE-TC0100X60",
        uri: "table_ce-tc0100x60",
        category: "table"
       },
       {
        id: 18,
        tigerCode: 305652,
        name: "СТОЛ CO-TC0100X60",
        brand: "COTTO",
        size: "1000x600x850",
        productCode: "CO-TC0100X60",
        uri: "table_co-tc0100x60",
        category: "table"
       },
       {
        id: 19,
        tigerCode: "308136",
        name: "СТОЛ CE-TC0100X70",
        brand: "CROM",
        size: "1000x700x850",
        productCode: "CE-TC0100X70",
        uri: "table_ce-tc0100x70",
        category: "table"
       },
       {
        id: 20,
        tigerCode: 305659,
        name: "СТОЛ CO-TC0100X70",
        brand: "COTTO",
        size: "1000x700x850",
        productCode: "CO-TC0100X70",
        uri: "table_co-tc0100x70",
        category: "table"
       },
       {
        id: 21,
        tigerCode: 341219,
        name: "СТОЛ CE-TC0110X60",
        brand: "CROM",
        size: "1100x600x850",
        productCode: "CE-TC0110X60",
        uri: "table_ce-tc0110x60",
        category: "table"
       },
       {
        id: 22,
        tigerCode: 347066,
        name: "СТОЛ CO-TC0110X60",
        brand: "COTTO",
        size: "1100x600x850",
        productCode: "CO-TC0110X60",
        uri: "table_co-tc0110x60",
        category: "table"
       },
       {
        id: 23,
        tigerCode: 309315,
        name: "СТОЛ CE-TC0110X70",
        brand: "CROM",
        size: "1100x700x850",
        productCode: "CE-TC0110X70",
        uri: "table_ce-tc0110x70",
        category: "table"
       },
       {
        id: 24,
        tigerCode: 309806,
        name: "СТОЛ CO-TC0110X70",
        brand: "COTTO",
        size: "1100x700x850",
        productCode: "CO-TC0110X70",
        uri: "table_co-tc0110x70",
        category: "table"
       },
       {
        id: 25,
        tigerCode: "308130",
        name: "СТОЛ CE-TC0120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TC0120X60",
        uri: "table_ce-tc0120x60",
        category: "table"
       },
       {
        id: 26,
        tigerCode: 305653,
        name: "СТОЛ CO-TC0120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TC0120X60",
        uri: "table_co-tc0120x60",
        category: "table"
       },
       {
        id: 27,
        tigerCode: "308137",
        name: "СТОЛ CE-TC0120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TC0120X70",
        uri: "table_ce-tc0120x70",
        category: "table"
       },
       {
        id: 28,
        tigerCode: 305660,
        name: "СТОЛ CO-TC0120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TC0120X70",
        uri: "table_co-tc0120x70",
        category: "table"
       },
       {
        id: 29,
        tigerCode: 347068,
        name: "СТОЛ CE-TC0130X60",
        brand: "CROM",
        size: "1300x600x850",
        productCode: "CE-TC0130X60",
        uri: "table_ce-tc0130x60",
        category: "table"
       },
       {
        id: 30,
        tigerCode: 347067,
        name: "СТОЛ CO-TC0130X60",
        brand: "COTTO",
        size: "1300x600x850",
        productCode: "CO-TC0130X60",
        uri: "table_co-tc0130x60",
        category: "table"
       },
       {
        id: 31,
        tigerCode: 347071,
        name: "СТОЛ CE-TC0130X70",
        brand: "CROM",
        size: "1300x700x850",
        productCode: "CE-TC0130X70",
        uri: "table_ce-tc0130x70",
        category: "table"
       },
       {
        id: 32,
        tigerCode: 347070,
        name: "СТОЛ CO-TC0130X70",
        brand: "COTTO",
        size: "1300x700x850",
        productCode: "CO-TC0130X70",
        uri: "table_co-tc0130x70",
        category: "table"
       },
       {
        id: 33,
        tigerCode: "308131",
        name: "СТОЛ CE-TC0140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TC0140X60",
        uri: "table_ce-tc0140x60",
        category: "table"
       },
       {
        id: 34,
        tigerCode: 305654,
        name: "СТОЛ CO-TC0140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TC0140X60",
        uri: "table_co-tc0140x60",
        category: "table"
       },
       {
        id: 35,
        tigerCode: "308138",
        name: "СТОЛ CE-TC0140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TC0140X70",
        uri: "table_ce-tc0140x70",
        category: "table"
       },
       {
        id: 36,
        tigerCode: 305661,
        name: "СТОЛ CO-TC0140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TC0140X70",
        uri: "table_co-tc0140x70",
        category: "table"
       },
       {
        id: 37,
        tigerCode: 342733,
        name: "СТОЛ CE-TC0150X60",
        brand: "CROM",
        size: "1500x600x850",
        productCode: "CE-TC0150X60",
        uri: "table_ce-tc0150x60",
        category: "table"
       },
       {
        id: 38,
        tigerCode: 309667,
        name: "СТОЛ CO-TC0150X60",
        brand: "COTTO",
        size: "1500x600x850",
        productCode: "CO-TC0150X60",
        uri: "table_co-tc0150x60",
        category: "table"
       },
       {
        id: 39,
        tigerCode: 342734,
        name: "СТОЛ CE-TC0150X70",
        brand: "CROM",
        size: "1500x700x850",
        productCode: "CE-TC0150X70",
        uri: "table_ce-tc0150x70",
        category: "table"
       },
       {
        id: 40,
        tigerCode: 310357,
        name: "СТОЛ CO-TC0150X70",
        brand: "COTTO",
        size: "1500x700x850",
        productCode: "CO-TC0150X70",
        uri: "table_co-tc0150x70",
        category: "table"
       },
       {
        id: 41,
        tigerCode: "308132",
        name: "СТОЛ CE-TC0160X60",
        brand: "CROM",
        size: "1600x600x850",
        productCode: "CE-TC0160X60",
        uri: "table_ce-tc0160x60",
        category: "table"
       },
       {
        id: 42,
        tigerCode: 305655,
        name: "СТОЛ CO-TC0160X60",
        brand: "COTTO",
        size: "1600x600x850",
        productCode: "CO-TC0160X60",
        uri: "table_co-tc0160x60",
        category: "table"
       },
       {
        id: 43,
        tigerCode: "308139",
        name: "СТОЛ CE-TC0160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TC0160X70",
        uri: "table_ce-tc0160x70",
        category: "table"
       },
       {
        id: 44,
        tigerCode: 305662,
        name: "СТОЛ CO-TC0160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TC0160X70",
        uri: "table_co-tc0160x70",
        category: "table"
       },
       {
        id: 45,
        tigerCode: 342735,
        name: "СТОЛ CE-TC0170X60",
        brand: "CROM",
        size: "1700x600x850",
        productCode: "CE-TC0170X60",
        uri: "table_ce-tc0170x60",
        category: "table"
       },
       {
        id: 46,
        tigerCode: 347069,
        name: "СТОЛ CO-TC0170X60",
        brand: "COTTO",
        size: "1700x600x850",
        productCode: "CO-TC0170X60",
        uri: "table_co-tc0170x60",
        category: "table"
       },
       {
        id: 47,
        tigerCode: 340294,
        name: "СТОЛ CE-TC0170X70",
        brand: "CROM",
        size: "1700x700x850",
        productCode: "CE-TC0170X70",
        uri: "table_ce-tc0170x70",
        category: "table"
       },
       {
        id: 48,
        tigerCode: 347072,
        name: "СТОЛ CO-TC0170X70",
        brand: "COTTO",
        size: "1700x700x850",
        productCode: "CO-TC0170X70",
        uri: "table_co-tc0170x70",
        category: "table"
       },
       {
        id: 49,
        tigerCode: "308133",
        name: "СТОЛ CE-TC0180X60",
        brand: "CROM",
        size: "1800x600x850",
        productCode: "CE-TC0180X60",
        uri: "table_ce-tc0180x60",
        category: "table"
       },
       {
        id: 50,
        tigerCode: 305656,
        name: "СТОЛ CO-TC0180X60",
        brand: "COTTO",
        size: "1800x600x850",
        productCode: "CO-TC0180X60",
        uri: "table_co-tc0180x60",
        category: "table"
       },
       {
        id: 51,
        tigerCode: "308140",
        name: "СТОЛ CE-TC0180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TC0180X70",
        uri: "table_ce-tc0180x70",
        category: "table"
       },
       {
        id: 52,
        tigerCode: 305663,
        name: "СТОЛ CO-TC0180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TC0180X70",
        uri: "table_co-tc0180x70",
        category: "table"
       },
       {
        id: 53,
        tigerCode: "308141",
        name: "СТОЛ 1 ПОЛКА CE-TC1100X60",
        brand: "CROM",
        size: "1000x600x850",
        productCode: "CE-TC1100X60",
        uri: "table_with_1_shelf_ce-tc1100x60",
        category: "table_with_1_shelf"
       },
       {
        id: 54,
        tigerCode: 305664,
        name: "СТОЛ 1 ПОЛКА CO-TC1100X60",
        brand: "COTTO",
        size: "1000x600x850",
        productCode: "CO-TC1100X60",
        uri: "table_with_1_shelf_co-tc1100x60",
        category: "table_with_1_shelf"
       },
       {
        id: 55,
        tigerCode: "308146",
        name: "СТОЛ 1 ПОЛКА CE-TC1100X70",
        brand: "CROM",
        size: "1000x700x850",
        productCode: "CE-TC1100X70",
        uri: "table_with_1_shelf_ce-tc1100x70",
        category: "table_with_1_shelf"
       },
       {
        id: 56,
        tigerCode: 305669,
        name: "СТОЛ 1 ПОЛКА CO-TC1100X70",
        brand: "COTTO",
        size: "1000x700x850",
        productCode: "CO-TC1100X70",
        uri: "table_with_1_shelf_co-tc1100x70",
        category: "table_with_1_shelf"
       },
       {
        id: 57,
        tigerCode: 347073,
        name: "СТОЛ 1 ПОЛКА CE-TC1110X60",
        brand: "CROM",
        size: "1100x600x850",
        productCode: "CE-TC1110X60",
        uri: "table_with_1_shelf_ce-tc1110x60",
        category: "table_with_1_shelf"
       },
       {
        id: 58,
        tigerCode: 311098,
        name: "СТОЛ 1 ПОЛКА CO-TC1110X60",
        brand: "COTTO",
        size: "1100x600x850",
        productCode: "CO-TC1110X60",
        uri: "table_with_1_shelf_co-tc1110x60",
        category: "table_with_1_shelf"
       },
       {
        id: 59,
        tigerCode: 309405,
        name: "СТОЛ 1 ПОЛКА CE-TC1110X70",
        brand: "CROM",
        size: "1100x700x850",
        productCode: "CE-TC1110X70",
        uri: "table_with_1_shelf_ce-tc1110x70",
        category: "table_with_1_shelf"
       },
       {
        id: 60,
        tigerCode: 303996,
        name: "СТОЛ 1 ПОЛКА CO-TC1110X70",
        brand: "COTTO",
        size: "1100x700x850",
        productCode: "CO-TC1110X70",
        uri: "table_with_1_shelf_co-tc1110x70",
        category: "table_with_1_shelf"
       },
       {
        id: 61,
        tigerCode: "308142",
        name: "СТОЛ 1 ПОЛКА CE-TC1120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TC1120X60",
        uri: "table_with_1_shelf_ce-tc1120x60",
        category: "table_with_1_shelf"
       },
       {
        id: 62,
        tigerCode: 305665,
        name: "СТОЛ 1 ПОЛКА CO-TC1120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TC1120X60",
        uri: "table_with_1_shelf_co-tc1120x60",
        category: "table_with_1_shelf"
       },
       {
        id: 63,
        tigerCode: "308147",
        name: "СТОЛ 1 ПОЛКА CE-TC1120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TC1120X70",
        uri: "table_with_1_shelf_ce-tc1120x70",
        category: "table_with_1_shelf"
       },
       {
        id: 64,
        tigerCode: 305670,
        name: "СТОЛ 1 ПОЛКА CO-TC1120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TC1120X70",
        uri: "table_with_1_shelf_co-tc1120x70",
        category: "table_with_1_shelf"
       },
       {
        id: 65,
        tigerCode: 347075,
        name: "СТОЛ 1 ПОЛКА CE-TC1130X60",
        brand: "CROM",
        size: "1300x600x850",
        productCode: "CE-TC1130X60",
        uri: "table_with_1_shelf_ce-tc1130x60",
        category: "table_with_1_shelf"
       },
       {
        id: 66,
        tigerCode: 347074,
        name: "СТОЛ 1 ПОЛКА CO-TC1130X60",
        brand: "COTTO",
        size: "1300x600x850",
        productCode: "CO-TC1130X60",
        uri: "table_with_1_shelf_co-tc1130x60",
        category: "table_with_1_shelf"
       },
       {
        id: 67,
        tigerCode: 309291,
        name: "СТОЛ 1 ПОЛКА CE-TC1130X70",
        brand: "CROM",
        size: "1300x700x850",
        productCode: "CE-TC1130X70",
        uri: "table_with_1_shelf_ce-tc1130x70",
        category: "table_with_1_shelf"
       },
       {
        id: 68,
        tigerCode: 311097,
        name: "СТОЛ 1 ПОЛКА CO-TC1130X70",
        brand: "COTTO",
        size: "1300x700x850",
        productCode: "CO-TC1130X70",
        uri: "table_with_1_shelf_co-tc1130x70",
        category: "table_with_1_shelf"
       },
       {
        id: 69,
        tigerCode: "308143",
        name: "СТОЛ 1 ПОЛКА CE-TC1140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TC1140X60",
        uri: "table_with_1_shelf_ce-tc1140x60",
        category: "table_with_1_shelf"
       },
       {
        id: 70,
        tigerCode: 305666,
        name: "СТОЛ 1 ПОЛКА CO-TC1140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TC1140X60",
        uri: "table_with_1_shelf_co-tc1140x60",
        category: "table_with_1_shelf"
       },
       {
        id: 71,
        tigerCode: "308148",
        name: "СТОЛ 1 ПОЛКА CE-TC1140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TC1140X70",
        uri: "table_with_1_shelf_ce-tc1140x70",
        category: "table_with_1_shelf"
       },
       {
        id: 72,
        tigerCode: 305671,
        name: "СТОЛ 1 ПОЛКА CO-TC1140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TC1140X70",
        uri: "table_with_1_shelf_co-tc1140x70",
        category: "table_with_1_shelf"
       },
       {
        id: 73,
        tigerCode: 318852,
        name: "СТОЛ 1 ПОЛКА CE-TC1150X60",
        brand: "CROM",
        size: "1500x600x850",
        productCode: "CE-TC1150X60",
        uri: "table_with_1_shelf_ce-tc1150x60",
        category: "table_with_1_shelf"
       },
       {
        id: 74,
        tigerCode: 347076,
        name: "СТОЛ 1 ПОЛКА CO-TC1150X60",
        brand: "COTTO",
        size: "1500x600x850",
        productCode: "CO-TC1150X60",
        uri: "table_with_1_shelf_co-tc1150x60",
        category: "table_with_1_shelf"
       },
       {
        id: 75,
        tigerCode: 312184,
        name: "СТОЛ 1 ПОЛКА CE-TC1150X70",
        brand: "CROM",
        size: "1500x700x850",
        productCode: "CE-TC1150X70",
        uri: "table_with_1_shelf_ce-tc1150x70",
        category: "table_with_1_shelf"
       },
       {
        id: 76,
        tigerCode: 311045,
        name: "СТОЛ 1 ПОЛКА CO-TC1150X70",
        brand: "COTTO",
        size: "1500x700x850",
        productCode: "CO-TC1150X70",
        uri: "table_with_1_shelf_co-tc1150x70",
        category: "table_with_1_shelf"
       },
       {
        id: 77,
        tigerCode: "308144",
        name: "СТОЛ 1 ПОЛКА CE-TC1160X60",
        brand: "CROM",
        size: "1600x600x850",
        productCode: "CE-TC1160X60",
        uri: "table_with_1_shelf_ce-tc1160x60",
        category: "table_with_1_shelf"
       },
       {
        id: 78,
        tigerCode: 305667,
        name: "СТОЛ 1 ПОЛКА CO-TC1160X60",
        brand: "COTTO",
        size: "1600x600x850",
        productCode: "CO-TC1160X60",
        uri: "table_with_1_shelf_co-tc1160x60",
        category: "table_with_1_shelf"
       },
       {
        id: 79,
        tigerCode: "308149",
        name: "СТОЛ 1 ПОЛКА CE-TC1160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TC1160X70",
        uri: "table_with_1_shelf_ce-tc1160x70",
        category: "table_with_1_shelf"
       },
       {
        id: 80,
        tigerCode: 305672,
        name: "СТОЛ 1 ПОЛКА CO-TC1160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TC1160X70",
        uri: "table_with_1_shelf_co-tc1160x70",
        category: "table_with_1_shelf"
       },
       {
        id: 81,
        tigerCode: 342741,
        name: "СТОЛ 1 ПОЛКА CE-TC1170X60",
        brand: "CROM",
        size: "1700x600x850",
        productCode: "CE-TC1170X60",
        uri: "table_with_1_shelf_ce-tc1170x60",
        category: "table_with_1_shelf"
       },
       {
        id: 82,
        tigerCode: 347077,
        name: "СТОЛ 1 ПОЛКА CO-TC1170X60",
        brand: "COTTO",
        size: "1700x600x850",
        productCode: "CO-TC1170X60",
        uri: "table_with_1_shelf_co-tc1170x60",
        category: "table_with_1_shelf"
       },
       {
        id: 83,
        tigerCode: 309292,
        name: "СТОЛ 1 ПОЛКА CE-TC1170X70",
        brand: "CROM",
        size: "1700x700x850",
        productCode: "CE-TC1170X70",
        uri: "table_with_1_shelf_ce-tc1170x70",
        category: "table_with_1_shelf"
       },
       {
        id: 84,
        tigerCode: 310491,
        name: "СТОЛ 1 ПОЛКА CO-TC1170X70",
        brand: "COTTO",
        size: "1700x700x850",
        productCode: "CO-TC1170X70",
        uri: "table_with_1_shelf_co-tc1170x70",
        category: "table_with_1_shelf"
       },
       {
        id: 85,
        tigerCode: "308145",
        name: "СТОЛ 1 ПОЛКА CE-TC1180X60",
        brand: "CROM",
        size: "1800x600x850",
        productCode: "CE-TC1180X60",
        uri: "table_with_1_shelf_ce-tc1180x60",
        category: "table_with_1_shelf"
       },
       {
        id: 86,
        tigerCode: 305668,
        name: "СТОЛ 1 ПОЛКА CO-TC1180X60",
        brand: "COTTO",
        size: "1800x600x850",
        productCode: "CO-TC1180X60",
        uri: "table_with_1_shelf_co-tc1180x60",
        category: "table_with_1_shelf"
       },
       {
        id: 87,
        tigerCode: "308150",
        name: "СТОЛ 1 ПОЛКА CE-TC1180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TC1180X70",
        uri: "table_with_1_shelf_ce-tc1180x70",
        category: "table_with_1_shelf"
       },
       {
        id: 88,
        tigerCode: 305673,
        name: "СТОЛ 1 ПОЛКА CO-TC1180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TC1180X70",
        uri: "table_with_1_shelf_co-tc1180x70",
        category: "table_with_1_shelf"
       },
       {
        id: 89,
        tigerCode: "308151",
        name: "СТОЛ 2 ПОЛКИ CE-TC2100X60",
        brand: "CROM",
        size: "1000x600x850",
        productCode: "CE-TC2100X60",
        uri: "table_with_2_shelfs_ce-tc2100x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 90,
        tigerCode: 305674,
        name: "СТОЛ 2 ПОЛКИ CO-TC2100X60",
        brand: "COTTO",
        size: "1000x600x850",
        productCode: "CO-TC2100X60",
        uri: "table_with_2_shelfs_co-tc2100x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 91,
        tigerCode: "308156",
        name: "СТОЛ 2 ПОЛКИ CE-TC2100X70",
        brand: "CROM",
        size: "1000x700x850",
        productCode: "CE-TC2100X70",
        uri: "table_with_2_shelfs_ce-tc2100x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 92,
        tigerCode: 305679,
        name: "СТОЛ 2 ПОЛКИ CO-TC2100X70",
        brand: "COTTO",
        size: "1000x700x850",
        productCode: "CO-TC2100X70",
        uri: "table_with_2_shelfs_co-tc2100x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 93,
        tigerCode: 347079,
        name: "СТОЛ 2 ПОЛКИ CE-TC2110X60",
        brand: "CROM",
        size: "1100x600x850",
        productCode: "CE-TC2110X60",
        uri: "table_with_2_shelfs_ce-tc2110x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 94,
        tigerCode: 347078,
        name: "СТОЛ 2 ПОЛКИ CO-TC2110X60",
        brand: "COTTO",
        size: "1100x600x850",
        productCode: "CO-TC2110X60",
        uri: "table_with_2_shelfs_co-tc2110x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 95,
        tigerCode: 347087,
        name: "СТОЛ 2 ПОЛКИ CE-TC2110X70",
        brand: "CROM",
        size: "1100x700x850",
        productCode: "CE-TC2110X70",
        uri: "table_with_2_shelfs_ce-tc2110x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 96,
        tigerCode: 347086,
        name: "СТОЛ 2 ПОЛКИ CO-TC2110X70",
        brand: "COTTO",
        size: "1100x700x850",
        productCode: "CO-TC2110X70",
        uri: "table_with_2_shelfs_co-tc2110x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 97,
        tigerCode: "308152",
        name: "СТОЛ 2 ПОЛКИ CE-TC2120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TC2120X60",
        uri: "table_with_2_shelfs_ce-tc2120x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 98,
        tigerCode: 305675,
        name: "СТОЛ 2 ПОЛКИ CO-TC2120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TC2120X60",
        uri: "table_with_2_shelfs_co-tc2120x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 99,
        tigerCode: "308157",
        name: "СТОЛ 2 ПОЛКИ CE-TC2120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TC2120X70",
        uri: "table_with_2_shelfs_ce-tc2120x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 100,
        tigerCode: 305680,
        name: "СТОЛ 2 ПОЛКИ CO-TC2120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TC2120X70",
        uri: "table_with_2_shelfs_co-tc2120x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 101,
        tigerCode: 347081,
        name: "СТОЛ 2 ПОЛКИ CE-TC2130X60",
        brand: "CROM",
        size: "1300x600x850",
        productCode: "CE-TC2130X60",
        uri: "table_with_2_shelfs_ce-tc2130x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 102,
        tigerCode: 347080,
        name: "СТОЛ 2 ПОЛКИ CO-TC2130X60",
        brand: "COTTO",
        size: "1300x600x850",
        productCode: "CO-TC2130X60",
        uri: "table_with_2_shelfs_co-tc2130x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 103,
        tigerCode: 347089,
        name: "СТОЛ 2 ПОЛКИ CE-TC2130X70",
        brand: "CROM",
        size: "1300x700x850",
        productCode: "CE-TC2130X70",
        uri: "table_with_2_shelfs_ce-tc2130x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 104,
        tigerCode: 347088,
        name: "СТОЛ 2 ПОЛКИ CO-TC2130X70",
        brand: "COTTO",
        size: "1300x700x850",
        productCode: "CO-TC2130X70",
        uri: "table_with_2_shelfs_co-tc2130x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 105,
        tigerCode: "308153",
        name: "СТОЛ 2 ПОЛКИ CE-TC2140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TC2140X60",
        uri: "table_with_2_shelfs_ce-tc2140x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 106,
        tigerCode: 305676,
        name: "СТОЛ 2 ПОЛКИ CO-TC2140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TC2140X60",
        uri: "table_with_2_shelfs_co-tc2140x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 107,
        tigerCode: "308158",
        name: "СТОЛ 2 ПОЛКИ CE-TC2140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TC2140X70",
        uri: "table_with_2_shelfs_ce-tc2140x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 108,
        tigerCode: 305681,
        name: "СТОЛ 2 ПОЛКИ CO-TC2140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TC2140X70",
        uri: "table_with_2_shelfs_co-tc2140x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 109,
        tigerCode: 347083,
        name: "СТОЛ 2 ПОЛКИ CE-TC2150X60",
        brand: "CROM",
        size: "1500x600x850",
        productCode: "CE-TC2150X60",
        uri: "table_with_2_shelfs_ce-tc2150x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 110,
        tigerCode: 347082,
        name: "СТОЛ 2 ПОЛКИ CO-TC2150X60",
        brand: "COTTO",
        size: "1500x600x850",
        productCode: "CO-TC2150X60",
        uri: "table_with_2_shelfs_co-tc2150x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 111,
        tigerCode: 346372,
        name: "СТОЛ 2 ПОЛКИ CE-TC2150X70",
        brand: "CROM",
        size: "1500x700x850",
        productCode: "CE-TC2150X70",
        uri: "table_with_2_shelfs_ce-tc2150x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 112,
        tigerCode: 347090,
        name: "СТОЛ 2 ПОЛКИ CO-TC2150X70",
        brand: "COTTO",
        size: "1500x700x850",
        productCode: "CO-TC2150X70",
        uri: "table_with_2_shelfs_co-tc2150x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 113,
        tigerCode: "308154",
        name: "СТОЛ 2 ПОЛКИ CE-TC2160X60",
        brand: "CROM",
        size: "1600x600x850",
        productCode: "CE-TC2160X60",
        uri: "table_with_2_shelfs_ce-tc2160x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 114,
        tigerCode: 305677,
        name: "СТОЛ 2 ПОЛКИ CO-TC2160X60",
        brand: "COTTO",
        size: "1600x600x850",
        productCode: "CO-TC2160X60",
        uri: "table_with_2_shelfs_co-tc2160x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 115,
        tigerCode: "308159",
        name: "СТОЛ 2 ПОЛКИ CE-TC2160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TC2160X70",
        uri: "table_with_2_shelfs_ce-tc2160x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 116,
        tigerCode: 305682,
        name: "СТОЛ 2 ПОЛКИ CO-TC2160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TC2160X70",
        uri: "table_with_2_shelfs_co-tc2160x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 117,
        tigerCode: 347085,
        name: "СТОЛ 2 ПОЛКИ CE-TC2170X60",
        brand: "CROM",
        size: "1700x600x850",
        productCode: "CE-TC2170X60",
        uri: "table_with_2_shelfs_ce-tc2170x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 118,
        tigerCode: 347084,
        name: "СТОЛ 2 ПОЛКИ CO-TC2170X60",
        brand: "COTTO",
        size: "1700x600x850",
        productCode: "CO-TC2170X60",
        uri: "table_with_2_shelfs_co-tc2170x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 119,
        tigerCode: 309498,
        name: "СТОЛ 2 ПОЛКИ CE-TC2170X70",
        brand: "CROM",
        size: "1700x700x850",
        productCode: "CE-TC2170X70",
        uri: "table_with_2_shelfs_ce-tc2170x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 120,
        tigerCode: 347091,
        name: "СТОЛ 2 ПОЛКИ CO-TC2170X70",
        brand: "COTTO",
        size: "1700x700x850",
        productCode: "CO-TC2170X70",
        uri: "table_with_2_shelfs_co-tc2170x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 121,
        tigerCode: "308155",
        name: "СТОЛ 2 ПОЛКИ CE-TC2180X60",
        brand: "CROM",
        size: "1800x600x850",
        productCode: "CE-TC2180X60",
        uri: "table_with_2_shelfs_ce-tc2180x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 122,
        tigerCode: 305678,
        name: "СТОЛ 2 ПОЛКИ CO-TC2180X60",
        brand: "COTTO",
        size: "1800x600x850",
        productCode: "CO-TC2180X60",
        uri: "table_with_2_shelfs_co-tc2180x60",
        category: "table_with_2_shelfs"
       },
       {
        id: 123,
        tigerCode: "308160",
        name: "СТОЛ 2 ПОЛКИ CE-TC2180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TC2180X70",
        uri: "table_with_2_shelfs_ce-tc2180x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 124,
        tigerCode: 305683,
        name: "СТОЛ 2 ПОЛКИ CO-TC2180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TC2180X70",
        uri: "table_with_2_shelfs_co-tc2180x70",
        category: "table_with_2_shelfs"
       },
       {
        id: 125,
        tigerCode: "308161",
        name: "СТОЛ 1 ЯЩИК CE-TC3100X60",
        brand: "CROM",
        size: "1000x600x850",
        productCode: "CE-TC3100X60",
        uri: "table_with_1_drawer_ce-tc3100x60",
        category: "table_with_1_drawer"
       },
       {
        id: 126,
        tigerCode: 305684,
        name: "СТОЛ 1 ЯЩИК CO-TC3100X60",
        brand: "COTTO",
        size: "1000x600x850",
        productCode: "CO-TC3100X60",
        uri: "table_with_1_drawer_co-tc3100x60",
        category: "table_with_1_drawer"
       },
       {
        id: 127,
        tigerCode: "308166",
        name: "СТОЛ 1 ЯЩИК CE-TC3100X70",
        brand: "CROM",
        size: "1000x700x850",
        productCode: "CE-TC3100X70",
        uri: "table_with_1_drawer_ce-tc3100x70",
        category: "table_with_1_drawer"
       },
       {
        id: 128,
        tigerCode: 305689,
        name: "СТОЛ 1 ЯЩИК CO-TC3100X70",
        brand: "COTTO",
        size: "1000x700x850",
        productCode: "CO-TC3100X70",
        uri: "table_with_1_drawer_co-tc3100x70",
        category: "table_with_1_drawer"
       },
       {
        id: 129,
        tigerCode: 347093,
        name: "СТОЛ 1 ЯЩИК CE-TC3110X60",
        brand: "CROM",
        size: "1100x600x850",
        productCode: "CE-TC3110X60",
        uri: "table_with_1_drawer_ce-tc3110x60",
        category: "table_with_1_drawer"
       },
       {
        id: 130,
        tigerCode: 347092,
        name: "СТОЛ 1 ЯЩИК CO-TC3110X60",
        brand: "COTTO",
        size: "1100x600x850",
        productCode: "CO-TC3110X60",
        uri: "table_with_1_drawer_co-tc3110x60",
        category: "table_with_1_drawer"
       },
       {
        id: 131,
        tigerCode: 347126,
        name: "СТОЛ 1 ЯЩИК CE-TC3110X70",
        brand: "CROM",
        size: "1100x700x850",
        productCode: "CE-TC3110X70",
        uri: "table_with_1_drawer_ce-tc3110x70",
        category: "table_with_1_drawer"
       },
       {
        id: 132,
        tigerCode: 347125,
        name: "СТОЛ 1 ЯЩИК CO-TC3110X70",
        brand: "COTTO",
        size: "1100x700x850",
        productCode: "CO-TC3110X70",
        uri: "table_with_1_drawer_co-tc3110x70",
        category: "table_with_1_drawer"
       },
       {
        id: 133,
        tigerCode: "308162",
        name: "СТОЛ 1 ЯЩИК CE-TC3120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TC3120X60",
        uri: "table_with_1_drawer_ce-tc3120x60",
        category: "table_with_1_drawer"
       },
       {
        id: 134,
        tigerCode: 305685,
        name: "СТОЛ 1 ЯЩИК CO-TC3120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TC3120X60",
        uri: "table_with_1_drawer_co-tc3120x60",
        category: "table_with_1_drawer"
       },
       {
        id: 135,
        tigerCode: "308167",
        name: "СТОЛ 1 ЯЩИК CE-TC3120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TC3120X70",
        uri: "table_with_1_drawer_ce-tc3120x70",
        category: "table_with_1_drawer"
       },
       {
        id: 136,
        tigerCode: 305690,
        name: "СТОЛ 1 ЯЩИК CO-TC3120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TC3120X70",
        uri: "table_with_1_drawer_co-tc3120x70",
        category: "table_with_1_drawer"
       },
       {
        id: 137,
        tigerCode: 347095,
        name: "СТОЛ 1 ЯЩИК CE-TC3130X60",
        brand: "CROM",
        size: "1300x600x850",
        productCode: "CE-TC3130X60",
        uri: "table_with_1_drawer_ce-tc3130x60",
        category: "table_with_1_drawer"
       },
       {
        id: 138,
        tigerCode: 347094,
        name: "СТОЛ 1 ЯЩИК CO-TC3130X60",
        brand: "COTTO",
        size: "1300x600x850",
        productCode: "CO-TC3130X60",
        uri: "table_with_1_drawer_co-tc3130x60",
        category: "table_with_1_drawer"
       },
       {
        id: 139,
        tigerCode: 347128,
        name: "СТОЛ 1 ЯЩИК CE-TC3130X70",
        brand: "CROM",
        size: "1300x700x850",
        productCode: "CE-TC3130X70",
        uri: "table_with_1_drawer_ce-tc3130x70",
        category: "table_with_1_drawer"
       },
       {
        id: 140,
        tigerCode: 347127,
        name: "СТОЛ 1 ЯЩИК CO-TC3130X70",
        brand: "COTTO",
        size: "1300x700x850",
        productCode: "CO-TC3130X70",
        uri: "table_with_1_drawer_co-tc3130x70",
        category: "table_with_1_drawer"
       },
       {
        id: 141,
        tigerCode: "308163",
        name: "СТОЛ 1 ЯЩИК CE-TC3140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TC3140X60",
        uri: "table_with_1_drawer_ce-tc3140x60",
        category: "table_with_1_drawer"
       },
       {
        id: 142,
        tigerCode: 305686,
        name: "СТОЛ 1 ЯЩИК CO-TC3140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TC3140X60",
        uri: "table_with_1_drawer_co-tc3140x60",
        category: "table_with_1_drawer"
       },
       {
        id: 143,
        tigerCode: "308168",
        name: "СТОЛ 1 ЯЩИК CE-TC3140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TC3140X70",
        uri: "table_with_1_drawer_ce-tc3140x70",
        category: "table_with_1_drawer"
       },
       {
        id: 144,
        tigerCode: 305691,
        name: "СТОЛ 1 ЯЩИК CO-TC3140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TC3140X70",
        uri: "table_with_1_drawer_co-tc3140x70",
        category: "table_with_1_drawer"
       },
       {
        id: 145,
        tigerCode: 347096,
        name: "СТОЛ 1 ЯЩИК CE-TC3150X60",
        brand: "CROM",
        size: "1500x600x850",
        productCode: "CE-TC3150X60",
        uri: "table_with_1_drawer_ce-tc3150x60",
        category: "table_with_1_drawer"
       },
       {
        id: 146,
        tigerCode: 309844,
        name: "СТОЛ 1 ЯЩИК CO-TC3150X60",
        brand: "COTTO",
        size: "1500x600x850",
        productCode: "CO-TC3150X60",
        uri: "table_with_1_drawer_co-tc3150x60",
        category: "table_with_1_drawer"
       },
       {
        id: 147,
        tigerCode: 347130,
        name: "СТОЛ 1 ЯЩИК CE-TC3150X70",
        brand: "CROM",
        size: "1500x700x850",
        productCode: "CE-TC3150X70",
        uri: "table_with_1_drawer_ce-tc3150x70",
        category: "table_with_1_drawer"
       },
       {
        id: 148,
        tigerCode: 347129,
        name: "СТОЛ 1 ЯЩИК CO-TC3150X70",
        brand: "COTTO",
        size: "1500x700x850",
        productCode: "CO-TC3150X70",
        uri: "table_with_1_drawer_co-tc3150x70",
        category: "table_with_1_drawer"
       },
       {
        id: 149,
        tigerCode: "308164",
        name: "СТОЛ 1 ЯЩИК CE-TC3160X60",
        brand: "CROM",
        size: "1600x600x850",
        productCode: "CE-TC3160X60",
        uri: "table_with_1_drawer_ce-tc3160x60",
        category: "table_with_1_drawer"
       },
       {
        id: 150,
        tigerCode: 305687,
        name: "СТОЛ 1 ЯЩИК CO-TC3160X60",
        brand: "COTTO",
        size: "1600x600x850",
        productCode: "CO-TC3160X60",
        uri: "table_with_1_drawer_co-tc3160x60",
        category: "table_with_1_drawer"
       },
       {
        id: 151,
        tigerCode: "308169",
        name: "СТОЛ 1 ЯЩИК CE-TC3160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TC3160X70",
        uri: "table_with_1_drawer_ce-tc3160x70",
        category: "table_with_1_drawer"
       },
       {
        id: 152,
        tigerCode: 305692,
        name: "СТОЛ 1 ЯЩИК CO-TC3160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TC3160X70",
        uri: "table_with_1_drawer_co-tc3160x70",
        category: "table_with_1_drawer"
       },
       {
        id: 153,
        tigerCode: 347098,
        name: "СТОЛ 1 ЯЩИК CE-TC3170X60",
        brand: "CROM",
        size: "1700x600x850",
        productCode: "CE-TC3170X60",
        uri: "table_with_1_drawer_ce-tc3170x60",
        category: "table_with_1_drawer"
       },
       {
        id: 154,
        tigerCode: 347097,
        name: "СТОЛ 1 ЯЩИК CO-TC3170X60",
        brand: "COTTO",
        size: "1700x600x850",
        productCode: "CO-TC3170X60",
        uri: "table_with_1_drawer_co-tc3170x60",
        category: "table_with_1_drawer"
       },
       {
        id: 155,
        tigerCode: 347132,
        name: "СТОЛ 1 ЯЩИК CE-TC3170X70",
        brand: "CROM",
        size: "1700x700x850",
        productCode: "CE-TC3170X70",
        uri: "table_with_1_drawer_ce-tc3170x70",
        category: "table_with_1_drawer"
       },
       {
        id: 156,
        tigerCode: 347131,
        name: "СТОЛ 1 ЯЩИК CO-TC3170X70",
        brand: "COTTO",
        size: "1700x700x850",
        productCode: "CO-TC3170X70",
        uri: "table_with_1_drawer_co-tc3170x70",
        category: "table_with_1_drawer"
       },
       {
        id: 157,
        tigerCode: "308165",
        name: "СТОЛ 1 ЯЩИК CE-TC3180X60",
        brand: "CROM",
        size: "1800x600x850",
        productCode: "CE-TC3180X60",
        uri: "table_with_1_drawer_ce-tc3180x60",
        category: "table_with_1_drawer"
       },
       {
        id: 158,
        tigerCode: 305688,
        name: "СТОЛ 1 ЯЩИК CO-TC3180X60",
        brand: "COTTO",
        size: "1800x600x850",
        productCode: "CO-TC3180X60",
        uri: "table_with_1_drawer_co-tc3180x60",
        category: "table_with_1_drawer"
       },
       {
        id: 159,
        tigerCode: "308170",
        name: "СТОЛ 1 ЯЩИК CE-TC3180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TC3180X70",
        uri: "table_with_1_drawer_ce-tc3180x70",
        category: "table_with_1_drawer"
       },
       {
        id: 160,
        tigerCode: 305693,
        name: "СТОЛ 1 ЯЩИК CO-TC3180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TC3180X70",
        uri: "table_with_1_drawer_co-tc3180x70",
        category: "table_with_1_drawer"
       },
       {
        id: 161,
        tigerCode: "308171",
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CE-TC4140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TC4140X60",
        uri: "table_with_drawer_block_ce-tc4140x60",
        category: "table_with_drawer_block"
       },
       {
        id: 162,
        tigerCode: 305694,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CO-TC4140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TC4140X60",
        uri: "table_with_drawer_block_co-tc4140x60",
        category: "table_with_drawer_block"
       },
       {
        id: 163,
        tigerCode: "308173",
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CE-TC4140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TC4140X70",
        uri: "table_with_drawer_block_ce-tc4140x70",
        category: "table_with_drawer_block"
       },
       {
        id: 164,
        tigerCode: 305696,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CO-TC4140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TC4140X70",
        uri: "table_with_drawer_block_co-tc4140x70",
        category: "table_with_drawer_block"
       },
       {
        id: 165,
        tigerCode: "308172",
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CE-TC4160X60",
        brand: "CROM",
        size: "1600x600x850",
        productCode: "CE-TC4160X60",
        uri: "table_with_drawer_block_ce-tc4160x60",
        category: "table_with_drawer_block"
       },
       {
        id: 166,
        tigerCode: 305695,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CO-TC4160X60",
        brand: "COTTO",
        size: "1600x600x850",
        productCode: "CO-TC4160X60",
        uri: "table_with_drawer_block_co-tc4160x60",
        category: "table_with_drawer_block"
       },
       {
        id: 167,
        tigerCode: "308174",
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CE-TC4160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TC4160X70",
        uri: "table_with_drawer_block_ce-tc4160x70",
        category: "table_with_drawer_block"
       },
       {
        id: 168,
        tigerCode: 305697,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CO-TC4160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TC4160X70",
        uri: "table_with_drawer_block_co-tc4160x70",
        category: "table_with_drawer_block"
       },
       {
        id: 169,
        tigerCode: 347108,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CE-TC4180X60",
        brand: "CROM",
        size: "1800x600x850",
        productCode: "CE-TC4180X60",
        uri: "table_with_drawer_block_ce-tc4180x60",
        category: "table_with_drawer_block"
       },
       {
        id: 170,
        tigerCode: 347107,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CO-TC4180X60",
        brand: "COTTO",
        size: "1800x600x850",
        productCode: "CO-TC4180X60",
        uri: "table_with_drawer_block_co-tc4180x60",
        category: "table_with_drawer_block"
       },
       {
        id: 171,
        tigerCode: 347110,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CE-TC4180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TC4180X70",
        uri: "table_with_drawer_block_ce-tc4180x70",
        category: "table_with_drawer_block"
       },
       {
        id: 172,
        tigerCode: 347109,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CO-TC4180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TC4180X70",
        uri: "table_with_drawer_block_co-tc4180x70",
        category: "table_with_drawer_block"
       },
       {
        id: 173,
        tigerCode: 347112,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CE-TC550X60",
        brand: "CROM",
        size: "500x600x850",
        productCode: "CE-TC550X60",
        uri: "table_with_drawer_block_ce-tc550x60",
        category: "table_with_drawer_block"
       },
       {
        id: 174,
        tigerCode: 347111,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CO-TC550X60",
        brand: "COTTO",
        size: "500x600x850",
        productCode: "CO-TC550X60",
        uri: "table_with_drawer_block_co-tc550x60",
        category: "table_with_drawer_block"
       },
       {
        id: 175,
        tigerCode: 347114,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CE-TC550X70",
        brand: "CROM",
        size: "500x700x850",
        productCode: "CE-TC550X70",
        uri: "table_with_drawer_block_ce-tc550x70",
        category: "table_with_drawer_block"
       },
       {
        id: 176,
        tigerCode: 347113,
        name: "СТОЛ С БЛОКОМ ЯЩИКОВ CO-TC550X70",
        brand: "COTTO",
        size: "500x700x850",
        productCode: "CO-TC550X70",
        uri: "table_with_drawer_block_co-tc550x70",
        category: "table_with_drawer_block"
       },
       {
        id: 177,
        tigerCode: 322707,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TCDS120X60",
        uri: "table_with_sliding_cupboard_ce-tcds120x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 178,
        tigerCode: 347115,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TCDS120X60",
        uri: "table_with_sliding_cupboard_co-tcds120x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 179,
        tigerCode: 326845,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TCDS120X70",
        uri: "table_with_sliding_cupboard_ce-tcds120x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 180,
        tigerCode: 303995,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TCDS120X70",
        uri: "table_with_sliding_cupboard_co-tcds120x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 181,
        tigerCode: 324041,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS130X60",
        brand: "CROM",
        size: "1300x600x850",
        productCode: "CE-TCDS130X60",
        uri: "table_with_sliding_cupboard_ce-tcds130x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 182,
        tigerCode: 312374,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS130X60",
        brand: "COTTO",
        size: "1300x600x850",
        productCode: "CO-TCDS130X60",
        uri: "table_with_sliding_cupboard_co-tcds130x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 183,
        tigerCode: 341215,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS130X70",
        brand: "CROM",
        size: "1300x700x850",
        productCode: "CE-TCDS130X70",
        uri: "table_with_sliding_cupboard_ce-tcds130x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 184,
        tigerCode: 307810,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS130X70",
        brand: "COTTO",
        size: "1300x700x850",
        productCode: "CO-TCDS130X70",
        uri: "table_with_sliding_cupboard_co-tcds130x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 185,
        tigerCode: "308175",
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TCDS140X60",
        uri: "table_with_sliding_cupboard_ce-tcds140x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 186,
        tigerCode: 305698,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TCDS140X60",
        uri: "table_with_sliding_cupboard_co-tcds140x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 187,
        tigerCode: "308178",
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TCDS140X70",
        uri: "table_with_sliding_cupboard_ce-tcds140x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 188,
        tigerCode: 305701,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TCDS140X70",
        uri: "table_with_sliding_cupboard_co-tcds140x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 189,
        tigerCode: 310784,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS150X60",
        brand: "CROM",
        size: "1500x600x850",
        productCode: "CE-TCDS150X60",
        uri: "table_with_sliding_cupboard_ce-tcds150x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 190,
        tigerCode: 317970,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS150X60",
        brand: "COTTO",
        size: "1500x600x850",
        productCode: "CO-TCDS150X60",
        uri: "table_with_sliding_cupboard_co-tcds150x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 191,
        tigerCode: 328746,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS150X70",
        brand: "CROM",
        size: "1500x700x850",
        productCode: "CE-TCDS150X70",
        uri: "table_with_sliding_cupboard_ce-tcds150x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 192,
        tigerCode: 317976,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS150X70",
        brand: "COTTO",
        size: "1500x700x850",
        productCode: "CO-TCDS150X70",
        uri: "table_with_sliding_cupboard_co-tcds150x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 193,
        tigerCode: "308176",
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS160X60",
        brand: "CROM",
        size: "1600x600x850",
        productCode: "CE-TCDS160X60",
        uri: "table_with_sliding_cupboard_ce-tcds160x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 194,
        tigerCode: 305699,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS160X60",
        brand: "COTTO",
        size: "1600x600x850",
        productCode: "CO-TCDS160X60",
        uri: "table_with_sliding_cupboard_co-tcds160x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 195,
        tigerCode: "308179",
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TCDS160X70",
        uri: "table_with_sliding_cupboard_ce-tcds160x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 196,
        tigerCode: 305702,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TCDS160X70",
        uri: "table_with_sliding_cupboard_co-tcds160x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 197,
        tigerCode: 347117,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS170X60",
        brand: "CROM",
        size: "1700x600x850",
        productCode: "CE-TCDS170X60",
        uri: "table_with_sliding_cupboard_ce-tcds170x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 198,
        tigerCode: 347116,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS170X60",
        brand: "COTTO",
        size: "1700x600x850",
        productCode: "CO-TCDS170X60",
        uri: "table_with_sliding_cupboard_co-tcds170x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 199,
        tigerCode: 347119,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS170X70",
        brand: "CROM",
        size: "1700x700x850",
        productCode: "CE-TCDS170X70",
        uri: "table_with_sliding_cupboard_ce-tcds170x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 200,
        tigerCode: 347118,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS170X70",
        brand: "COTTO",
        size: "1700x700x850",
        productCode: "CO-TCDS170X70",
        uri: "table_with_sliding_cupboard_co-tcds170x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 201,
        tigerCode: "308177",
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS180X60",
        brand: "CROM",
        size: "1800x600x850",
        productCode: "CE-TCDS180X60",
        uri: "table_with_sliding_cupboard_ce-tcds180x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 202,
        tigerCode: 305700,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS180X60",
        brand: "COTTO",
        size: "1800x600x850",
        productCode: "CO-TCDS180X60",
        uri: "table_with_sliding_cupboard_co-tcds180x60",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 203,
        tigerCode: "308180",
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CE-TCDS180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TCDS180X70",
        uri: "table_with_sliding_cupboard_ce-tcds180x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 204,
        tigerCode: 305703,
        name: "СТОЛ C РАЗДВИЖНЫМ ШКАФОM CO-TCDS180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TCDS180X70",
        uri: "table_with_sliding_cupboard_co-tcds180x70",
        category: "table_with_sliding_cupboard"
       },
       {
        id: 205,
        tigerCode: 308181,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC100X60",
        brand: "CROM",
        size: "1000x600x850",
        productCode: "CE-TCDC100X60",
        uri: "table_with_wing_cupboard_ce-tcdc100x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 206,
        tigerCode: 305704,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC100X60",
        brand: "COTTO",
        size: "1000x600x850",
        productCode: "CO-TCDC100X60",
        uri: "table_with_wing_cupboard_co-tcdc100x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 207,
        tigerCode: "308186",
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC100X70",
        brand: "CROM",
        size: "1000x700x850",
        productCode: "CE-TCDC100X70",
        uri: "table_with_wing_cupboard_ce-tcdc100x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 208,
        tigerCode: 305709,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC100X70",
        brand: "COTTO",
        size: "1000x700x850",
        productCode: "CO-TCDC100X70",
        uri: "table_with_wing_cupboard_co-tcdc100x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 209,
        tigerCode: 347124,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC110X60",
        brand: "CROM",
        size: "1100X600X850",
        productCode: "CE-TCDC110X60",
        uri: "table_with_wing_cupboard_ce-tcdc110x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 210,
        tigerCode: 310794,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC110X60",
        brand: "COTTO",
        size: "1100X600X850",
        productCode: "CO-TCDC110X60",
        uri: "table_with_wing_cupboard_co-tcdc110x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 211,
        tigerCode: 340378,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC110X70",
        brand: "CROM",
        size: "1100X700X850",
        productCode: "CE-TCDC110X70",
        uri: "table_with_wing_cupboard_ce-tcdc110x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 212,
        tigerCode: 347136,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC110X70",
        brand: "COTTO",
        size: "1100X700X850",
        productCode: "CO-TCDC110X60",
        uri: "table_with_wing_cupboard_co-tcdc110x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 213,
        tigerCode: "308182",
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TCDC120X60",
        uri: "table_with_wing_cupboard_ce-tcdc120x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 214,
        tigerCode: 305705,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TCDC120X60",
        uri: "table_with_wing_cupboard_co-tcdc120x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 215,
        tigerCode: "308187",
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TCDC120X70",
        uri: "table_with_wing_cupboard_ce-tcdc120x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 216,
        tigerCode: 305710,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TCDC120X70",
        uri: "table_with_wing_cupboard_co-tcdc120x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 217,
        tigerCode: 347121,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC60X60",
        brand: "CROM",
        size: "600X600X850",
        productCode: "CE-TCDC60X60",
        uri: "table_with_wing_cupboard_ce-tcdc60x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 218,
        tigerCode: 347120,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC60X60",
        brand: "COTTO",
        size: "600X600X850",
        productCode: "CO-TCDC60X60",
        uri: "table_with_wing_cupboard_co-tcdc60x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 219,
        tigerCode: 347134,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC60X70",
        brand: "CROM",
        size: "600X700X850",
        productCode: "CE-TCDC60X70",
        uri: "table_with_wing_cupboard_ce-tcdc60x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 220,
        tigerCode: 347133,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC60X70",
        brand: "COTTO",
        size: "600X700X850",
        productCode: "CO-TCDC60X70",
        uri: "table_with_wing_cupboard_co-tcdc60x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 221,
        tigerCode: 347123,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC70X60",
        brand: "CROM",
        size: "700X600X850",
        productCode: "CE-TCDC70X60",
        uri: "table_with_wing_cupboard_ce-tcdc70x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 222,
        tigerCode: 347122,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC70X60",
        brand: "COTTO",
        size: "700X600X850",
        productCode: "CO-TCDC70X60",
        uri: "table_with_wing_cupboard_co-tcdc70x60",
        category: "table_with_wing_cupboard"
       },
       {
        id: 223,
        tigerCode: 340373,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CE-TCDC70X70",
        brand: "CROM",
        size: "700X700X850",
        productCode: "CE-TCDC70X70",
        uri: "table_with_wing_cupboard_ce-tcdc70x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 224,
        tigerCode: 347135,
        name: "СТОЛ C РАСПАШНЫМ ШКАФОM CO-TCDC70X70",
        brand: "COTTO",
        size: "700X700X850",
        productCode: "CO-TCDC70X70",
        uri: "table_with_wing_cupboard_co-tcdc70x70",
        category: "table_with_wing_cupboard"
       },
       {
        id: 225,
        tigerCode: 316986,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CE-TCM120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TCM120X70",
        uri: "table_marble_top_ce-tcm120x70",
        category: "table_marble_top"
       },
       {
        id: 226,
        tigerCode: 317939,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CO-TCM120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TCM120X70",
        uri: "table_marble_top_co-tcm120x70",
        category: "table_marble_top"
       },
       {
        id: 227,
        tigerCode: 308191,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CE-TCM140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TCM140X70",
        uri: "table_marble_top_ce-tcm140x70",
        category: "table_marble_top"
       },
       {
        id: 228,
        tigerCode: 305714,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CO-TCM140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TCM140X70",
        uri: "table_marble_top_co-tcm140x70",
        category: "table_marble_top"
       },
       {
        id: 229,
        tigerCode: "308193",
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CE-TCM140X80",
        brand: "CROM",
        size: "1400x800x850",
        productCode: "CE-TCM140X80",
        uri: "table_marble_top_ce-tcm140x80",
        category: "table_marble_top"
       },
       {
        id: 230,
        tigerCode: 305716,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CO-TCM140X80",
        brand: "COTTO",
        size: "1400x800x850",
        productCode: "CO-TCM140X80",
        uri: "table_marble_top_co-tcm140x80",
        category: "table_marble_top"
       },
       {
        id: 231,
        tigerCode: 308192,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CE-TCM160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TCM160X70",
        uri: "table_marble_top_ce-tcm160x70",
        category: "table_marble_top"
       },
       {
        id: 232,
        tigerCode: 305715,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CO-TCM160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TCM160X70",
        uri: "table_marble_top_co-tcm160x70",
        category: "table_marble_top"
       },
       {
        id: 233,
        tigerCode: "308194",
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CE-TCM160X80",
        brand: "CROM",
        size: "1600x800x850",
        productCode: "CE-TCM160X80",
        uri: "table_marble_top_ce-tcm160x80",
        category: "table_marble_top"
       },
       {
        id: 234,
        tigerCode: 305717,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CO-TCM160X80",
        brand: "COTTO",
        size: "1600x800x850",
        productCode: "CO-TCM160X80",
        uri: "table_marble_top_co-tcm160x80",
        category: "table_marble_top"
       },
       {
        id: 235,
        tigerCode: 347138,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CE-TCM180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TCM180X70",
        uri: "table_marble_top_ce-tcm180x70",
        category: "table_marble_top"
       },
       {
        id: 236,
        tigerCode: 347137,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CO-TCM180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TCM180X70",
        uri: "table_marble_top_co-tcm180x70",
        category: "table_marble_top"
       },
       {
        id: 237,
        tigerCode: 318881,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CE-TCM200X70",
        brand: "CROM",
        size: "2000x700x850",
        productCode: "CE-TCM200X70",
        uri: "table_marble_top_ce-tcm200x70",
        category: "table_marble_top"
       },
       {
        id: 238,
        tigerCode: 347139,
        name: "СТОЛ ВЕРХ ИЗ МРАМОРА CO-TCM200X70",
        brand: "COTTO",
        size: "2000x700x850",
        productCode: "CO-TCM200X70",
        uri: "table_marble_top_co-tcm200x70",
        category: "table_marble_top"
       },
       {
        id: 239,
        tigerCode: 311958,
        name: "СТОЛ ВЕРХ ПЭ CE-TCP120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TCP120X70",
        uri: "table_pe_top_ce-tcp120x70",
        category: "table_pe_top"
       },
       {
        id: 240,
        tigerCode: 305722,
        name: "СТОЛ ВЕРХ ПЭ CO-TCP120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TCP120X70",
        uri: "table_pe_top_co-tcp120x70",
        category: "table_pe_top"
       },
       {
        id: 241,
        tigerCode: "308196",
        name: "СТОЛ ВЕРХ ПЭ CE-TCP140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TCP140X70",
        uri: "table_pe_top_ce-tcp140x70",
        category: "table_pe_top"
       },
       {
        id: 242,
        tigerCode: 305723,
        name: "СТОЛ ВЕРХ ПЭ CO-TCP140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TCP140X70",
        uri: "table_pe_top_co-tcp140x70",
        category: "table_pe_top"
       },
       {
        id: 243,
        tigerCode: "308197",
        name: "СТОЛ ВЕРХ ПЭ CE-TCP160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TCP160X70",
        uri: "table_pe_top_ce-tcp160x70",
        category: "table_pe_top"
       },
       {
        id: 244,
        tigerCode: 305724,
        name: "СТОЛ ВЕРХ ПЭ CO-TCP160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TCP160X70",
        uri: "table_pe_top_co-tcp160x70",
        category: "table_pe_top"
       },
       {
        id: 245,
        tigerCode: 310423,
        name: "СТОЛ ВЕРХ ПЭ CE-TCP180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TCP180X70",
        uri: "table_pe_top_ce-tcp180x70",
        category: "table_pe_top"
       },
       {
        id: 246,
        tigerCode: 305725,
        name: "СТОЛ ВЕРХ ПЭ CO-TCP180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TCP180X70",
        uri: "table_pe_top_co-tcp180x70",
        category: "table_pe_top"
       },
       {
        id: 247,
        tigerCode: 306036,
        name: "СТОЛ ВЕРХ ПЭ - 1 ЯЩИК CE-TCP3120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TCP3120X70",
        uri: "table_pe_top-1_drawer_ce-tcp3120x70",
        category: "table_pe_top-1_drawer"
       },
       {
        id: 248,
        tigerCode: 305726,
        name: "СТОЛ ВЕРХ ПЭ - 1 ЯЩИК CO-TCP3120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TCP3120X70",
        uri: "table_pe_top-1_drawer_co-tcp3120x70",
        category: "table_pe_top-1_drawer"
       },
       {
        id: 249,
        tigerCode: "308198",
        name: "СТОЛ ВЕРХ ПЭ - 1 ЯЩИК CE-TCP3140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TCP3140X70",
        uri: "table_pe_top-1_drawer_ce-tcp3140x70",
        category: "table_pe_top-1_drawer"
       },
       {
        id: 250,
        tigerCode: 305727,
        name: "СТОЛ ВЕРХ ПЭ - 1 ЯЩИК CO-TCP3140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TCP3140X70",
        uri: "table_pe_top-1_drawer_co-tcp3140x70",
        category: "table_pe_top-1_drawer"
       },
       {
        id: 251,
        tigerCode: "308199",
        name: "СТОЛ ВЕРХ ПЭ - 1 ЯЩИК CE-TCP3160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TCP3160X70",
        uri: "table_pe_top-1_drawer_ce-tcp3160x70",
        category: "table_pe_top-1_drawer"
       },
       {
        id: 252,
        tigerCode: 305728,
        name: "СТОЛ ВЕРХ ПЭ - 1 ЯЩИК CO-TCP3160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TCP3160X70",
        uri: "table_pe_top-1_drawer_co-tcp3160x70",
        category: "table_pe_top-1_drawer"
       },
       {
        id: 253,
        tigerCode: "308200",
        name: "СТОЛ ВЕРХ ПЭ - 1 ЯЩИК CE-TCP3180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TCP3180X70",
        uri: "table_pe_top-1_drawer_ce-tcp3180x70",
        category: "table_pe_top-1_drawer"
       },
       {
        id: 254,
        tigerCode: 305729,
        name: "СТОЛ ВЕРХ ПЭ - 1 ЯЩИК CO-TCP3180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TCP3180X70",
        uri: "table_pe_top-1_drawer_co-tcp3180x70",
        category: "table_pe_top-1_drawer"
       },
       {
        id: 255,
        tigerCode: 326070,
        name: "КОЛОДА ДЛЯ РУБКИ МЯСА ВЕРХ ПЭ CE-EKP60X60",
        brand: "CROM",
        size: "600x600x850",
        productCode: "CE-EKP60X60",
        uri: "chopping_block_pe_ce-ekp60x60",
        category: "chopping_block_pe"
       },
       {
        id: 256,
        tigerCode: 311115,
        name: "КОЛОДА ДЛЯ РУБКИ МЯСА ВЕРХ ПЭ CO-EKP60X60",
        brand: "COTTO",
        size: "600x600x850",
        productCode: "CO-EKP60X60",
        uri: "chopping_block_pe_co-ekp60x60",
        category: "chopping_block_pe"
       },
       {
        id: 257,
        tigerCode: "308201",
        name: "КОЛОДА ДЛЯ РУБКИ МЯСА ВЕРХ ПЭ CE-EKP70X70",
        brand: "CROM",
        size: "700x700x850",
        productCode: "CE-EKP70X70",
        uri: "chopping_block_pe_ce-ekp70x70",
        category: "chopping_block_pe"
       },
       {
        id: 258,
        tigerCode: 305730,
        name: "КОЛОДА ДЛЯ РУБКИ МЯСА ВЕРХ ПЭ CO-EKP70X70",
        brand: "COTTO",
        size: "700x700x850",
        productCode: "CO-EKP70X70",
        uri: "chopping_block_pe_co-ekp70x70",
        category: "chopping_block_pe"
       },
       {
        id: 259,
        tigerCode: 314333,
        name: "СТОЛ НА РОЛИКАХ CE-TCH100X60",
        brand: "CROM",
        size: "1000x600x850",
        productCode: "CE-TCH100X60",
        uri: "table_mobile_ce-tch100x60",
        category: "table_mobile"
       },
       {
        id: 260,
        tigerCode: 347141,
        name: "СТОЛ НА РОЛИКАХ CO-TCH100X60",
        brand: "COTTO",
        size: "1000x600x850",
        productCode: "CO-TCH100X60",
        uri: "table_mobile_co-tch100x60",
        category: "table_mobile"
       },
       {
        id: 261,
        tigerCode: 311668,
        name: "СТОЛ НА РОЛИКАХ CE-TCH100X70",
        brand: "CROM",
        size: "1000x700x850",
        productCode: "CE-TCH100X70",
        uri: "table_mobile_ce-tch100x70",
        category: "table_mobile"
       },
       {
        id: 262,
        tigerCode: 347160,
        name: "СТОЛ НА РОЛИКАХ CO-TCH100X70",
        brand: "COTTO",
        size: "1000x700x850",
        productCode: "CO-TCH100X70",
        uri: "table_mobile_co-tch100x70",
        category: "table_mobile"
       },
       {
        id: 263,
        tigerCode: 347142,
        name: "СТОЛ НА РОЛИКАХ CE-TCH110X60",
        brand: "CROM",
        size: "1100x600x850",
        productCode: "CE-TCH110X60",
        uri: "table_mobile_ce-tch110x60",
        category: "table_mobile"
       },
       {
        id: 264,
        tigerCode: 309795,
        name: "СТОЛ НА РОЛИКАХ CO-TCH110X60",
        brand: "COTTO",
        size: "1100x600x850",
        productCode: "CO-TCH110X60",
        uri: "table_mobile_co-tch110x60",
        category: "table_mobile"
       },
       {
        id: 265,
        tigerCode: 347162,
        name: "СТОЛ НА РОЛИКАХ CE-TCH110X70",
        brand: "CROM",
        size: "1100x700x850",
        productCode: "CE-TCH110X70",
        uri: "table_mobile_ce-tch110x70",
        category: "table_mobile"
       },
       {
        id: 266,
        tigerCode: 347161,
        name: "СТОЛ НА РОЛИКАХ CO-TCH110X70",
        brand: "COTTO",
        size: "1100x700x850",
        productCode: "CO-TCH110X70",
        uri: "table_mobile_co-tch110x70",
        category: "table_mobile"
       },
       {
        id: 267,
        tigerCode: "308202",
        name: "СТОЛ НА РОЛИКАХ CE-TCH120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TCH120X60",
        uri: "table_mobile_ce-tch120x60",
        category: "table_mobile"
       },
       {
        id: 268,
        tigerCode: 305731,
        name: "СТОЛ НА РОЛИКАХ CO-TCH120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TCH120X60",
        uri: "table_mobile_co-tch120x60",
        category: "table_mobile"
       },
       {
        id: 269,
        tigerCode: "308206",
        name: "СТОЛ НА РОЛИКАХ CE-TCH120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TCH120X70",
        uri: "table_mobile_ce-tch120x70",
        category: "table_mobile"
       },
       {
        id: 270,
        tigerCode: 305735,
        name: "СТОЛ НА РОЛИКАХ CO-TCH120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TCH120X70",
        uri: "table_mobile_co-tch120x70",
        category: "table_mobile"
       },
       {
        id: 271,
        tigerCode: 347144,
        name: "СТОЛ НА РОЛИКАХ CE-TCH130X60",
        brand: "CROM",
        size: "1300x600x850",
        productCode: "CE-TCH130X60",
        uri: "table_mobile_ce-tch130x60",
        category: "table_mobile"
       },
       {
        id: 272,
        tigerCode: 347143,
        name: "СТОЛ НА РОЛИКАХ CO-TCH130X60",
        brand: "COTTO",
        size: "1300x600x850",
        productCode: "CO-TCH130X60",
        uri: "table_mobile_co-tch130x60",
        category: "table_mobile"
       },
       {
        id: 273,
        tigerCode: 324036,
        name: "СТОЛ НА РОЛИКАХ CE-TCH130X70",
        brand: "CROM",
        size: "1300x700x850",
        productCode: "CE-TCH130X70",
        uri: "table_mobile_ce-tch130x70",
        category: "table_mobile"
       },
       {
        id: 274,
        tigerCode: 347163,
        name: "СТОЛ НА РОЛИКАХ CO-TCH130X70",
        brand: "COTTO",
        size: "1300x700x850",
        productCode: "CO-TCH130X70",
        uri: "table_mobile_co-tch130x70",
        category: "table_mobile"
       },
       {
        id: 275,
        tigerCode: "308203",
        name: "СТОЛ НА РОЛИКАХ CE-TCH140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TCH140X60",
        uri: "table_mobile_ce-tch140x60",
        category: "table_mobile"
       },
       {
        id: 276,
        tigerCode: 305732,
        name: "СТОЛ НА РОЛИКАХ CO-TCH140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TCH140X60",
        uri: "table_mobile_co-tch140x60",
        category: "table_mobile"
       },
       {
        id: 277,
        tigerCode: "308207",
        name: "СТОЛ НА РОЛИКАХ CE-TCH140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TCH140X70",
        uri: "table_mobile_ce-tch140x70",
        category: "table_mobile"
       },
       {
        id: 278,
        tigerCode: 305736,
        name: "СТОЛ НА РОЛИКАХ CO-TCH140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TCH140X70",
        uri: "table_mobile_co-tch140x70",
        category: "table_mobile"
       },
       {
        id: 279,
        tigerCode: 347146,
        name: "СТОЛ НА РОЛИКАХ CE-TCH150X60",
        brand: "CROM",
        size: "1500x600x850",
        productCode: "CE-TCH150X60",
        uri: "table_mobile_ce-tch150x60",
        category: "table_mobile"
       },
       {
        id: 280,
        tigerCode: 347145,
        name: "СТОЛ НА РОЛИКАХ CO-TCH150X60",
        brand: "COTTO",
        size: "1500x600x850",
        productCode: "CO-TCH150X60",
        uri: "table_mobile_co-tch150x60",
        category: "table_mobile"
       },
       {
        id: 281,
        tigerCode: 347165,
        name: "СТОЛ НА РОЛИКАХ CE-TCH150X70",
        brand: "CROM",
        size: "1500x700x850",
        productCode: "CE-TCH150X70",
        uri: "table_mobile_ce-tch150x70",
        category: "table_mobile"
       },
       {
        id: 282,
        tigerCode: 347164,
        name: "СТОЛ НА РОЛИКАХ CO-TCH150X70",
        brand: "COTTO",
        size: "1500x700x850",
        productCode: "CO-TCH150X70",
        uri: "table_mobile_co-tch150x70",
        category: "table_mobile"
       },
       {
        id: 283,
        tigerCode: "308204",
        name: "СТОЛ НА РОЛИКАХ CE-TCH160X60",
        brand: "CROM",
        size: "1600x600x850",
        productCode: "CE-TCH160X60",
        uri: "table_mobile_ce-tch160x60",
        category: "table_mobile"
       },
       {
        id: 284,
        tigerCode: 305733,
        name: "СТОЛ НА РОЛИКАХ CO-TCH160X60",
        brand: "COTTO",
        size: "1600x600x850",
        productCode: "CO-TCH160X60",
        uri: "table_mobile_co-tch160x60",
        category: "table_mobile"
       },
       {
        id: 285,
        tigerCode: "308208",
        name: "СТОЛ НА РОЛИКАХ CE-TCH160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TCH160X70",
        uri: "table_mobile_ce-tch160x70",
        category: "table_mobile"
       },
       {
        id: 286,
        tigerCode: 305737,
        name: "СТОЛ НА РОЛИКАХ CO-TCH160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TCH160X70",
        uri: "table_mobile_co-tch160x70",
        category: "table_mobile"
       },
       {
        id: 287,
        tigerCode: 347148,
        name: "СТОЛ НА РОЛИКАХ CE-TCH170X60",
        brand: "CROM",
        size: "1700x600x850",
        productCode: "CE-TCH170X60",
        uri: "table_mobile_ce-tch170x60",
        category: "table_mobile"
       },
       {
        id: 288,
        tigerCode: 347147,
        name: "СТОЛ НА РОЛИКАХ CO-TCH170X60",
        brand: "COTTO",
        size: "1700x600x850",
        productCode: "CO-TCH170X60",
        uri: "table_mobile_co-tch170x60",
        category: "table_mobile"
       },
       {
        id: 289,
        tigerCode: 347167,
        name: "СТОЛ НА РОЛИКАХ CE-TCH170X70",
        brand: "CROM",
        size: "1700x700x850",
        productCode: "CE-TCH170X70",
        uri: "table_mobile_ce-tch170x70",
        category: "table_mobile"
       },
       {
        id: 290,
        tigerCode: 347166,
        name: "СТОЛ НА РОЛИКАХ CO-TCH170X70",
        brand: "COTTO",
        size: "1700x700x850",
        productCode: "CO-TCH170X70",
        uri: "table_mobile_co-tch170x70",
        category: "table_mobile"
       },
       {
        id: 291,
        tigerCode: "308205",
        name: "СТОЛ НА РОЛИКАХ CE-TCH180X60",
        brand: "CROM",
        size: "1800x600x850",
        productCode: "CE-TCH180X60",
        uri: "table_mobile_ce-tch180x60",
        category: "table_mobile"
       },
       {
        id: 292,
        tigerCode: 305734,
        name: "СТОЛ НА РОЛИКАХ CO-TCH180X60",
        brand: "COTTO",
        size: "1800x600x850",
        productCode: "CO-TCH180X60",
        uri: "table_mobile_co-tch180x60",
        category: "table_mobile"
       },
       {
        id: 293,
        tigerCode: "308209",
        name: "СТОЛ НА РОЛИКАХ CE-TCH180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TCH180X70",
        uri: "table_mobile_ce-tch180x70",
        category: "table_mobile"
       },
       {
        id: 294,
        tigerCode: 305738,
        name: "СТОЛ НА РОЛИКАХ CO-TCH180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TCH180X70",
        uri: "table_mobile_co-tch180x70",
        category: "table_mobile"
       },
       {
        id: 295,
        tigerCode: 306669,
        name: "СТОЛ С 1 МОЙКОЙ И ДВЕРЬЮ CO-TTE-CK60X60",
        brand: "COTTO",
        size: "600x600x850",
        productCode: "CO-TTE-CK60X60",
        uri: "dish_pan_w-1_sink_and_door_co-tte-ck60x60",
        category: "dish_pan_w-1_sink_and_door"
       },
       {
        id: 296,
        tigerCode: 345003,
        name: "СТОЛ С 1 МОЙКОЙ И ДВЕРЬЮ CE-TTE-CK60X60",
        brand: "CROM",
        size: "600x600x850",
        productCode: "CE-TTE-CK60X60",
        uri: "dish_pan_w-1_sink_and_door_ce-tte-ck60x60",
        category: "dish_pan_w-1_sink_and_door"
       },
       {
        id: 297,
        tigerCode: 347170,
        name: "СТОЛ С 1 МОЙКОЙ И ДВЕРЬЮ CO-TTE-CK70X70",
        brand: "COTTO",
        size: "700x700x850",
        productCode: "CO-TTE-CK70X70",
        uri: "dish_pan_w-1_sink_and_door_co-tte-ck70x70",
        category: "dish_pan_w-1_sink_and_door"
       },
       {
        id: 298,
        tigerCode: 347171,
        name: "СТОЛ С 1 МОЙКОЙ И ДВЕРЬЮ CE-TTE-CK70X70",
        brand: "CROM",
        size: "700x700x850",
        productCode: "CE-TTE-CK70X70",
        uri: "dish_pan_w-1_sink_and_door_ce-tte-ck70x70",
        category: "dish_pan_w-1_sink_and_door"
       },
       {
        id: 299,
        tigerCode: "308210",
        name: "СТОЛ С 1 МОЙКОЙ CE-TTE60X60",
        brand: "CROM",
        size: "600x600x850",
        productCode: "CE-TTE60X60",
        uri: "dish_pan_with_1_sink_ce-tte60x60",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 300,
        tigerCode: 305739,
        name: "СТОЛ С 1 МОЙКОЙ CO-TTE60X60",
        brand: "COTTO",
        size: "600x600x850",
        productCode: "CO-TTE60X60",
        uri: "dish_pan_with_1_sink_co-tte60x60",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 301,
        tigerCode: "308214",
        name: "СТОЛ С 1 МОЙКОЙ CE-TTE70X70",
        brand: "CROM",
        size: "700x700x850",
        productCode: "CE-TTE70X70",
        uri: "dish_pan_with_1_sink_ce-tte70x70",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 302,
        tigerCode: 305743,
        name: "СТОЛ С 1 МОЙКОЙ CO-TTE70X70",
        brand: "COTTO",
        size: "700x700x850",
        productCode: "CO-TTE70X70",
        uri: "dish_pan_with_1_sink_co-tte70x70",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 303,
        tigerCode: "308211",
        name: "СТОЛ С 1 МОЙКОЙ CE-TTE120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TTE120X60",
        uri: "dish_pan_with_1_sink_ce-tte120x60",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 304,
        tigerCode: 305740,
        name: "СТОЛ С 1 МОЙКОЙ CO-TTE120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TTE120X60",
        uri: "dish_pan_with_1_sink_co-tte120x60",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 305,
        tigerCode: "308215",
        name: "СТОЛ С 1 МОЙКОЙ CE-TTE120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TTE120X70",
        uri: "dish_pan_with_1_sink_ce-tte120x70",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 306,
        tigerCode: 305744,
        name: "СТОЛ С 1 МОЙКОЙ CO-TTE120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TTE120X70",
        uri: "dish_pan_with_1_sink_co-tte120x70",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 307,
        tigerCode: "308212",
        name: "СТОЛ С 1 МОЙКОЙ CE-TTE140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TTE140X60",
        uri: "dish_pan_with_1_sink_ce-tte140x60",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 308,
        tigerCode: 305741,
        name: "СТОЛ С 1 МОЙКОЙ CO-TTE140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TTE140X60",
        uri: "dish_pan_with_1_sink_co-tte140x60",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 309,
        tigerCode: "308216",
        name: "СТОЛ С 1 МОЙКОЙ CE-TTE140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TTE140X70",
        uri: "dish_pan_with_1_sink_ce-tte140x70",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 310,
        tigerCode: 305745,
        name: "СТОЛ С 1 МОЙКОЙ CO-TTE140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TTE140X70",
        uri: "dish_pan_with_1_sink_co-tte140x70",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 311,
        tigerCode: "308213",
        name: "СТОЛ С 1 МОЙКОЙ CE-TTE160X60",
        brand: "CROM",
        size: "1600x600x850",
        productCode: "CE-TTE160X60",
        uri: "dish_pan_with_1_sink_ce-tte160x60",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 312,
        tigerCode: 305742,
        name: "СТОЛ С 1 МОЙКОЙ CO-TTE160X60",
        brand: "COTTO",
        size: "1600x600x850",
        productCode: "CO-TTE160X60",
        uri: "dish_pan_with_1_sink_co-tte160x60",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 313,
        tigerCode: "308217",
        name: "СТОЛ С 1 МОЙКОЙ CE-TTE160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TTE160X70",
        uri: "dish_pan_with_1_sink_ce-tte160x70",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 314,
        tigerCode: 305746,
        name: "СТОЛ С 1 МОЙКОЙ CO-TTE160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TTE160X70",
        uri: "dish_pan_with_1_sink_co-tte160x70",
        category: "dish_pan_with_1_sink"
       },
       {
        id: 315,
        tigerCode: "308218",
        name: "СТОЛ С 2 МОЙКАМИ CE-TCE120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TCE120X60",
        uri: "dish_pan_with_2_sinks_ce-tce120x60",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 316,
        tigerCode: 305747,
        name: "СТОЛ С 2 МОЙКАМИ CO-TCE120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TCE120X60",
        uri: "dish_pan_with_2_sinks_co-tce120x60",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 317,
        tigerCode: "308222",
        name: "СТОЛ С 2 МОЙКАМИ CE-TCE120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TCE120X70",
        uri: "dish_pan_with_2_sinks_ce-tce120x70",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 318,
        tigerCode: 305751,
        name: "СТОЛ С 2 МОЙКАМИ CO-TCE120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TCE120X70",
        uri: "dish_pan_with_2_sinks_co-tce120x70",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 319,
        tigerCode: "308219",
        name: "СТОЛ С 2 МОЙКАМИ CE-TCE140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TCE140X60",
        uri: "dish_pan_with_2_sinks_ce-tce140x60",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 320,
        tigerCode: 305748,
        name: "СТОЛ С 2 МОЙКАМИ CO-TCE140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TCE140X60",
        uri: "dish_pan_with_2_sinks_co-tce140x60",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 321,
        tigerCode: "308223",
        name: "СТОЛ С 2 МОЙКАМИ CE-TCE140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TCE140X70",
        uri: "dish_pan_with_2_sinks_ce-tce140x70",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 322,
        tigerCode: 305752,
        name: "СТОЛ С 2 МОЙКАМИ CO-TCE140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TCE140X70",
        uri: "dish_pan_with_2_sinks_co-tce140x70",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 323,
        tigerCode: "308220",
        name: "СТОЛ С 2 МОЙКАМИ CE-TCE160X60",
        brand: "CROM",
        size: "1600x600x850",
        productCode: "CE-TCE160X60",
        uri: "dish_pan_with_2_sinks_ce-tce160x60",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 324,
        tigerCode: 305749,
        name: "СТОЛ С 2 МОЙКАМИ CO-TCE160X60",
        brand: "COTTO",
        size: "1600x600x850",
        productCode: "CO-TCE160X60",
        uri: "dish_pan_with_2_sinks_co-tce160x60",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 325,
        tigerCode: "308224",
        name: "СТОЛ С 2 МОЙКАМИ CE-TCE160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TCE160X70",
        uri: "dish_pan_with_2_sinks_ce-tce160x70",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 326,
        tigerCode: 305753,
        name: "СТОЛ С 2 МОЙКАМИ CO-TCE160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TCE160X70",
        uri: "dish_pan_with_2_sinks_co-tce160x70",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 327,
        tigerCode: "308221",
        name: "СТОЛ С 2 МОЙКАМИ CE-TCE180X60",
        brand: "CROM",
        size: "1800x600x850",
        productCode: "CE-TCE180X60",
        uri: "dish_pan_with_2_sinks_ce-tce180x60",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 328,
        tigerCode: 305750,
        name: "СТОЛ С 2 МОЙКАМИ CO-TCE180X60",
        brand: "COTTO",
        size: "1800x600x850",
        productCode: "CO-TCE180X60",
        uri: "dish_pan_with_2_sinks_co-tce180x60",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 329,
        tigerCode: "308225",
        name: "СТОЛ С 2 МОЙКАМИ CE-TCE180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TCE180X70",
        uri: "dish_pan_with_2_sinks_ce-tce180x70",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 330,
        tigerCode: 305754,
        name: "СТОЛ С 2 МОЙКАМИ CO-TCE180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TCE180X70",
        uri: "dish_pan_with_2_sinks_co-tce180x70",
        category: "dish_pan_with_2_sinks"
       },
       {
        id: 331,
        tigerCode: "308226",
        name: "СТОЛ С 3 МОЙКАМИ CE-TUE180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TUE180X70",
        uri: "dish_pan_with_3_sinks_ce-tue180x70",
        category: "dish_pan_with_3_sinks"
       },
       {
        id: 332,
        tigerCode: 305755,
        name: "СТОЛ С 3 МОЙКАМИ CO-TUE180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TUE180X70",
        uri: "dish_pan_with_3_sinks_co-tue180x70",
        category: "dish_pan_with_3_sinks"
       },
       {
        id: 333,
        tigerCode: "308227",
        name: "ТЕХНИЧЕСКАЯ РАКОВИНА CE-ME50X58",
        brand: "CROM",
        size: "500x580x800",
        productCode: "CE-ME50X58",
        uri: "mop_sink_ce-me50x58",
        category: "mop_sink"
       },
       {
        id: 334,
        tigerCode: 305756,
        name: "ТЕХНИЧЕСКАЯ РАКОВИНА CO-ME50X58",
        brand: "COTTO",
        size: "500x580x800",
        productCode: "CO-ME50X58",
        uri: "mop_sink_co-me50x58",
        category: "mop_sink"
       },
       {
        id: 335,
        tigerCode: "308391",
        name: "РУКОМОЙНИК С КОЛЕННЫМ УПРАВЛЕНИЕМ CE-DKE50X40",
        brand: "CROM",
        size: "500X400X310",
        productCode: "CE-DKE50X40",
        uri: "hand_washing_unit_knee_controlled_ce-dke50x40",
        category: "hand_washing_unit_knee_controlled"
       },
       {
        id: 336,
        tigerCode: "308228",
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CE-TKY80X80",
        brand: "CROM",
        size: "800x800x630\/850",
        productCode: "CE-TKY80X80",
        uri: "pot_washing_unit_ce-tky80x80",
        category: "pot_washing_unit"
       },
       {
        id: 337,
        tigerCode: 305757,
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CO-TKY80X80",
        brand: "COTTO",
        size: "800x800x630\/850",
        productCode: "CO-TKY80X80",
        uri: "pot_washing_unit_co-tky80x80",
        category: "pot_washing_unit"
       },
       {
        id: 338,
        tigerCode: "308229",
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CE-TKY100X80",
        brand: "CROM",
        size: "1000x800x630\/850",
        productCode: "CE-TKY100X80",
        uri: "pot_washing_unit_ce-tky100x80",
        category: "pot_washing_unit"
       },
       {
        id: 339,
        tigerCode: 305758,
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CO-TKY100X80",
        brand: "COTTO",
        size: "1000x800x630\/850",
        productCode: "CO-TKY100X80",
        uri: "pot_washing_unit_co-tky100x80",
        category: "pot_washing_unit"
       },
       {
        id: 340,
        tigerCode: "308230",
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CE-TKY120X80",
        brand: "CROM",
        size: "1200x800x630\/850",
        productCode: "CE-TKY120X80",
        uri: "pot_washing_unit_ce-tky120x80",
        category: "pot_washing_unit"
       },
       {
        id: 341,
        tigerCode: 305759,
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CO-TKY120X80",
        brand: "COTTO",
        size: "1200x800x630\/850",
        productCode: "CO-TKY120X80",
        uri: "pot_washing_unit_co-tky120x80",
        category: "pot_washing_unit"
       },
       {
        id: 342,
        tigerCode: "308231",
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CE-TKY140X80",
        brand: "CROM",
        size: "1400x800x630\/850",
        productCode: "CE-TKY140X80",
        uri: "pot_washing_unit_ce-tky140x80",
        category: "pot_washing_unit"
       },
       {
        id: 343,
        tigerCode: 305760,
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CO-TKY140X80",
        brand: "COTTO",
        size: "1400x800x630\/850",
        productCode: "CO-TKY140X80",
        uri: "pot_washing_unit_co-tky140x80",
        category: "pot_washing_unit"
       },
       {
        id: 344,
        tigerCode: 347169,
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CE-TKY160X80",
        brand: "CROM",
        size: "1600x800x630\/850",
        productCode: "CE-TKY140X80",
        uri: "pot_washing_unit_ce-tky160x80",
        category: "pot_washing_unit"
       },
       {
        id: 345,
        tigerCode: 347168,
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CO-TKY160X80",
        brand: "COTTO",
        size: "1600x800x630\/850",
        productCode: "CO-TKY160X80",
        uri: "pot_washing_unit_co-tky160x80",
        category: "pot_washing_unit"
       },
       {
        id: 346,
        tigerCode: "308232",
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CE-TKY180X80",
        brand: "CROM",
        size: "1800x800x630\/850",
        productCode: "CE-TKY180X80",
        uri: "pot_washing_unit_ce-tky180x80",
        category: "pot_washing_unit"
       },
       {
        id: 347,
        tigerCode: 305761,
        name: "СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА CO-TKY180X80",
        brand: "COTTO",
        size: "1800x800x630\/850",
        productCode: "CO-TKY180X80",
        uri: "pot_washing_unit_co-tky180x80",
        category: "pot_washing_unit"
       },
       {
        id: 348,
        tigerCode: "308233",
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CE-TKG80X80",
        brand: "CROM",
        size: "800x800x630\/850",
        productCode: "CE-TKG80X80",
        uri: "loading_table_for_pot_washing_ce-tkg80x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 349,
        tigerCode: 305762,
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CO-TKG80X80",
        brand: "COTTO",
        size: "800x800x630\/850",
        productCode: "CO-TKG80X80",
        uri: "loading_table_for_pot_washing_co-tkg80x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 350,
        tigerCode: "308234",
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CE-TKG100X80",
        brand: "CROM",
        size: "1000x800x630\/850",
        productCode: "CE-TKG100X80",
        uri: "loading_table_for_pot_washing_ce-tkg100x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 351,
        tigerCode: 305763,
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CO-TKG100X80",
        brand: "COTTO",
        size: "1000x800x630\/850",
        productCode: "CO-TKG100X80",
        uri: "loading_table_for_pot_washing_co-tkg100x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 352,
        tigerCode: "308235",
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CE-TKG120X80",
        brand: "CROM",
        size: "1200x800x630\/850",
        productCode: "CE-TKG120X80",
        uri: "loading_table_for_pot_washing_ce-tkg120x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 353,
        tigerCode: 305764,
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CO-TKG120X80",
        brand: "COTTO",
        size: "1200x800x630\/850",
        productCode: "CO-TKG120X80",
        uri: "loading_table_for_pot_washing_co-tkg120x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 354,
        tigerCode: "308236",
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CE-TKG140X80",
        brand: "CROM",
        size: "1400x800x630\/850",
        productCode: "CE-TKG140X80",
        uri: "loading_table_for_pot_washing_ce-tkg140x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 355,
        tigerCode: 305765,
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CO-TKG140X80",
        brand: "COTTO",
        size: "1400x800x630\/850",
        productCode: "CO-TKG140X80",
        uri: "loading_table_for_pot_washing_co-tkg140x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 356,
        tigerCode: 347173,
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CE-TKG160X80",
        brand: "CROM",
        size: "1600x800x630\/850",
        productCode: "CE-TKG160X80",
        uri: "loading_table_for_pot_washing_ce-tkg160x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 357,
        tigerCode: 347172,
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CO-TKG160X80",
        brand: "COTTO",
        size: "1600x800x630\/850",
        productCode: "CO-TKG160X80",
        uri: "loading_table_for_pot_washing_co-tkg160x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 358,
        tigerCode: "308237",
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CE-TKG180X80",
        brand: "CROM",
        size: "1800x800x630\/850",
        productCode: "CE-TKG180X80",
        uri: "loading_table_for_pot_washing_ce-tkg180x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 359,
        tigerCode: 305766,
        name: "СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА CO-TKG180X80",
        brand: "COTTO",
        size: "1800x800x630\/850",
        productCode: "CO-TKG180X80",
        uri: "loading_table_for_pot_washing_co-tkg180x80",
        category: "loading_table_for_pot_washing"
       },
       {
        id: 360,
        tigerCode: 347175,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS-S100X75",
        brand: "CROM",
        size: "1000x750x850",
        productCode: "CE-TBS-S100X75",
        uri: "dish_sorting_table_ce-tbs-s100x75",
        category: "dish_sorting_table"
       },
       {
        id: 361,
        tigerCode: 347174,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ С БОРТИКОМ CO-TBS-S100X75",
        brand: "COTTO",
        size: "1000x750x850",
        productCode: "CO-TBS-S100X75",
        uri: "dish_sorting_table_w-board_co-tbs-s100x75",
        category: "dish_sorting_table_w-board"
       },
       {
        id: 362,
        tigerCode: 347177,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS-S120X75",
        brand: "CROM",
        size: "1200x750x850",
        productCode: "CE-TBS-S120X75",
        uri: "dish_sorting_table_ce-tbs-s120x75",
        category: "dish_sorting_table"
       },
       {
        id: 363,
        tigerCode: 347176,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ С БОРТИКОМ CO-TBS-S120X75",
        brand: "COTTO",
        size: "1200x750x850",
        productCode: "CO-TBS-S120X75",
        uri: "dish_sorting_table_w-board_co-tbs-s120x75",
        category: "dish_sorting_table_w-board"
       },
       {
        id: 364,
        tigerCode: 347178,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS-S140X75",
        brand: "CROM",
        size: "1400x750x850",
        productCode: "CE-TBS-S140X75",
        uri: "dish_sorting_table_ce-tbs-s140x75",
        category: "dish_sorting_table"
       },
       {
        id: 365,
        tigerCode: 346663,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ С БОРТИКОМ CO-TBS-S140X75",
        brand: "COTTO",
        size: "1400x750x850",
        productCode: "CO-TBS-S140X75",
        uri: "dish_sorting_table_w-board_co-tbs-s140x75",
        category: "dish_sorting_table_w-board"
       },
       {
        id: 366,
        tigerCode: 347180,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS-S160X75",
        brand: "CROM",
        size: "1600x750x850",
        productCode: "CE-TBS-S160X75",
        uri: "dish_sorting_table_ce-tbs-s160x75",
        category: "dish_sorting_table"
       },
       {
        id: 367,
        tigerCode: 347179,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ С БОРТИКОМ CO-TBS-S160X75",
        brand: "COTTO",
        size: "1600x750x850",
        productCode: "CO-TBS-S160X75",
        uri: "dish_sorting_table_w-board_co-tbs-s160x75",
        category: "dish_sorting_table_w-board"
       },
       {
        id: 368,
        tigerCode: 347182,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS-S180X75",
        brand: "CROM",
        size: "1800x750x850",
        productCode: "CE-TBS-S180X75",
        uri: "dish_sorting_table_ce-tbs-s180x75",
        category: "dish_sorting_table"
       },
       {
        id: 369,
        tigerCode: 347181,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ С БОРТИКОМ CO-TBS-S180X75",
        brand: "COTTO",
        size: "1800x750x850",
        productCode: "CO-TBS-S180X75",
        uri: "dish_sorting_table_w-board_co-tbs-s180x75",
        category: "dish_sorting_table_w-board"
       },
       {
        id: 370,
        tigerCode: 347184,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS-S200X75",
        brand: "CROM",
        size: "2000x750x850",
        productCode: "CE-TBS-S200X75",
        uri: "dish_sorting_table_ce-tbs-s200x75",
        category: "dish_sorting_table"
       },
       {
        id: 371,
        tigerCode: 347183,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ С БОРТИКОМ CO-TBS-S200X75",
        brand: "COTTO",
        size: "2000x750x850",
        productCode: "CO-TBS-S200X75",
        uri: "dish_sorting_table_w-board_co-tbs-s200x75",
        category: "dish_sorting_table_w-board"
       },
       {
        id: 372,
        tigerCode: 347186,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS-S210X75",
        brand: "CROM",
        size: "2100x750x850",
        productCode: "CE-TBS-S210X75",
        uri: "dish_sorting_table_ce-tbs-s210x75",
        category: "dish_sorting_table"
       },
       {
        id: 373,
        tigerCode: 347185,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ С БОРТИКОМ CO-TBS-S210X75",
        brand: "COTTO",
        size: "2100x750x850",
        productCode: "CO-TBS-S210X75",
        uri: "dish_sorting_table_w-board_co-tbs-s210x75",
        category: "dish_sorting_table_w-board"
       },
       {
        id: 374,
        tigerCode: 347188,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS-S220X75",
        brand: "CROM",
        size: "2200x750x850",
        productCode: "CE-TBS-S220X75",
        uri: "dish_sorting_table_ce-tbs-s220x75",
        category: "dish_sorting_table"
       },
       {
        id: 375,
        tigerCode: 347187,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ С БОРТИКОМ CO-TBS-S220X75",
        brand: "COTTO",
        size: "2200x750x850",
        productCode: "CO-TBS-S220X75",
        uri: "dish_sorting_table_w-board_co-tbs-s220x75",
        category: "dish_sorting_table_w-board"
       },
       {
        id: 376,
        tigerCode: "308241",
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS100X75",
        brand: "CROM",
        size: "1000x750x850",
        productCode: "CE-TBS100X75",
        uri: "dish_sorting_table_ce-tbs100x75",
        category: "dish_sorting_table"
       },
       {
        id: 377,
        tigerCode: 305770,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CO-TBS100X75",
        brand: "COTTO",
        size: "1000x750x850",
        productCode: "CO-TBS100X75",
        uri: "dish_sorting_table_co-tbs100x75",
        category: "dish_sorting_table"
       },
       {
        id: 378,
        tigerCode: "308242",
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS120X75",
        brand: "CROM",
        size: "1200x750x850",
        productCode: "CE-TBS120X75",
        uri: "dish_sorting_table_ce-tbs120x75",
        category: "dish_sorting_table"
       },
       {
        id: 379,
        tigerCode: 305771,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CO-TBS120X75",
        brand: "COTTO",
        size: "1200x750x850",
        productCode: "CO-TBS120X75",
        uri: "dish_sorting_table_co-tbs120x75",
        category: "dish_sorting_table"
       },
       {
        id: 380,
        tigerCode: "308243",
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS140X75",
        brand: "CROM",
        size: "1400x750x850",
        productCode: "CE-TBS140X75",
        uri: "dish_sorting_table_ce-tbs140x75",
        category: "dish_sorting_table"
       },
       {
        id: 381,
        tigerCode: 305772,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CO-TBS140X75",
        brand: "COTTO",
        size: "1400x750x850",
        productCode: "CO-TBS140X75",
        uri: "dish_sorting_table_co-tbs140x75",
        category: "dish_sorting_table"
       },
       {
        id: 382,
        tigerCode: "308244",
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS160X75",
        brand: "CROM",
        size: "1600x750x850",
        productCode: "CE-TBS160X75",
        uri: "dish_sorting_table_ce-tbs160x75",
        category: "dish_sorting_table"
       },
       {
        id: 383,
        tigerCode: 305773,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CO-TBS160X75",
        brand: "COTTO",
        size: "1600x750x850",
        productCode: "CO-TBS160X75",
        uri: "dish_sorting_table_co-tbs160x75",
        category: "dish_sorting_table"
       },
       {
        id: 384,
        tigerCode: "308245",
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS180X75",
        brand: "CROM",
        size: "1800x750x850",
        productCode: "CE-TBS180X75",
        uri: "dish_sorting_table_ce-tbs180x75",
        category: "dish_sorting_table"
       },
       {
        id: 385,
        tigerCode: 305774,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CO-TBS180X75",
        brand: "COTTO",
        size: "1800x750x850",
        productCode: "CO-TBS180X75",
        uri: "dish_sorting_table_co-tbs180x75",
        category: "dish_sorting_table"
       },
       {
        id: 386,
        tigerCode: "308246",
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS200X75",
        brand: "CROM",
        size: "2000x750x850",
        productCode: "CE-TBS200X75",
        uri: "dish_sorting_table_ce-tbs200x75",
        category: "dish_sorting_table"
       },
       {
        id: 387,
        tigerCode: 305775,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CO-TBS200X75",
        brand: "COTTO",
        size: "2000x750x850",
        productCode: "CO-TBS200X75",
        uri: "dish_sorting_table_co-tbs200x75",
        category: "dish_sorting_table"
       },
       {
        id: 388,
        tigerCode: "308247",
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS210X75",
        brand: "CROM",
        size: "2100x750x850",
        productCode: "CE-TBS210X75",
        uri: "dish_sorting_table_ce-tbs210x75",
        category: "dish_sorting_table"
       },
       {
        id: 389,
        tigerCode: 305776,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CO-TBS210X75",
        brand: "COTTO",
        size: "2100x750x850",
        productCode: "CO-TBS210X75",
        uri: "dish_sorting_table_co-tbs210x75",
        category: "dish_sorting_table"
       },
       {
        id: 390,
        tigerCode: "308248",
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CE-TBS220X75",
        brand: "CROM",
        size: "2200x750x850",
        productCode: "CE-TBS220X75",
        uri: "dish_sorting_table_ce-tbs220x75",
        category: "dish_sorting_table"
       },
       {
        id: 391,
        tigerCode: 305777,
        name: "СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ CO-TBS220X75",
        brand: "COTTO",
        size: "2200x750x850",
        productCode: "CO-TBS220X75",
        uri: "dish_sorting_table_co-tbs220x75",
        category: "dish_sorting_table"
       },
       {
        id: 392,
        tigerCode: "308249",
        name: "ПОЛКА ДЛЯ КОРЗИН CE-BR100X60",
        brand: "CROM",
        size: "1000x600x600",
        productCode: "CE-BR100X60",
        uri: "basket_shelf_ce-br100x60",
        category: "basket_shelf"
       },
       {
        id: 393,
        tigerCode: 305778,
        name: "ПОЛКА ДЛЯ КОРЗИН CO-BR100X60",
        brand: "COTTO",
        size: "1000x600x600",
        productCode: "CO-BR100X60",
        uri: "basket_shelf_co-br100x60",
        category: "basket_shelf"
       },
       {
        id: 394,
        tigerCode: "308250",
        name: "ПОЛКА ДЛЯ КОРЗИН CE-BR120X60",
        brand: "CROM",
        size: "1200x600x600",
        productCode: "CE-BR120X60",
        uri: "basket_shelf_ce-br120x60",
        category: "basket_shelf"
       },
       {
        id: 395,
        tigerCode: 305779,
        name: "ПОЛКА ДЛЯ КОРЗИН CO-BR120X60",
        brand: "COTTO",
        size: "1200x600x600",
        productCode: "CO-BR120X60",
        uri: "basket_shelf_co-br120x60",
        category: "basket_shelf"
       },
       {
        id: 396,
        tigerCode: "308251",
        name: "ПОЛКА ДЛЯ КОРЗИН CE-BR140X60",
        brand: "CROM",
        size: "1400x600x600",
        productCode: "CE-BR140X60",
        uri: "basket_shelf_ce-br140x60",
        category: "basket_shelf"
       },
       {
        id: 397,
        tigerCode: 305780,
        name: "ПОЛКА ДЛЯ КОРЗИН CO-BR140X60",
        brand: "COTTO",
        size: "1400x600x600",
        productCode: "CO-BR140X60",
        uri: "basket_shelf_co-br140x60",
        category: "basket_shelf"
       },
       {
        id: 398,
        tigerCode: "308252",
        name: "ПОЛКА ДЛЯ КОРЗИН CE-BR160X60",
        brand: "CROM",
        size: "1600x600x600",
        productCode: "CE-BR160X60",
        uri: "basket_shelf_ce-br160x60",
        category: "basket_shelf"
       },
       {
        id: 399,
        tigerCode: 305781,
        name: "ПОЛКА ДЛЯ КОРЗИН CO-BR160X60",
        brand: "COTTO",
        size: "1600x600x600",
        productCode: "CO-BR160X60",
        uri: "basket_shelf_co-br160x60",
        category: "basket_shelf"
       },
       {
        id: 400,
        tigerCode: "308253",
        name: "ПОЛКА ДЛЯ КОРЗИН CE-BR180X60",
        brand: "CROM",
        size: "1800x600x600",
        productCode: "CE-BR180X60",
        uri: "basket_shelf_ce-br180x60",
        category: "basket_shelf"
       },
       {
        id: 401,
        tigerCode: 305782,
        name: "ПОЛКА ДЛЯ КОРЗИН CO-BR180X60",
        brand: "COTTO",
        size: "1800x600x600",
        productCode: "CO-BR180X60",
        uri: "basket_shelf_co-br180x60",
        category: "basket_shelf"
       },
       {
        id: 402,
        tigerCode: "308254",
        name: "ПОЛКА ДЛЯ КОРЗИН CE-BR200X60",
        brand: "CROM",
        size: "2000x600x600",
        productCode: "CE-BR200X60",
        uri: "basket_shelf_ce-br200x60",
        category: "basket_shelf"
       },
       {
        id: 403,
        tigerCode: 305783,
        name: "ПОЛКА ДЛЯ КОРЗИН CO-BR200X60",
        brand: "COTTO",
        size: "2000x600x600",
        productCode: "CO-BR200X60",
        uri: "basket_shelf_co-br200x60",
        category: "basket_shelf"
       },
       {
        id: 404,
        tigerCode: "308255",
        name: "ПОЛКА ДЛЯ КОРЗИН CE-BR210X60",
        brand: "CROM",
        size: "2100x600x600",
        productCode: "CE-BR210X60",
        uri: "basket_shelf_ce-br210x60",
        category: "basket_shelf"
       },
       {
        id: 405,
        tigerCode: 305784,
        name: "ПОЛКА ДЛЯ КОРЗИН CO-BR210X60",
        brand: "COTTO",
        size: "2100x600x600",
        productCode: "CO-BR210X60",
        uri: "basket_shelf_co-br210x60",
        category: "basket_shelf"
       },
       {
        id: 406,
        tigerCode: "308256",
        name: "ПОЛКА ДЛЯ КОРЗИН CE-BR210X60",
        brand: "CROM",
        size: "2200x600x600",
        productCode: "CE-BR220X60",
        uri: "basket_shelf_ce-br220x60",
        category: "basket_shelf"
       },
       {
        id: 407,
        tigerCode: 305785,
        name: "ПОЛКА ДЛЯ КОРЗИН CO-BR220X60",
        brand: "COTTO",
        size: "2200x600x600",
        productCode: "CO-BR220X60",
        uri: "basket_shelf_co-br220x60",
        category: "basket_shelf"
       },
       {
        id: 408,
        tigerCode: "308257",
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CE-TBG100X75",
        brand: "CROM",
        size: "1000x750x850",
        productCode: "CE-TBG100X75",
        uri: "loading_table_for_diswasher_ce-tbg100x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 409,
        tigerCode: 305786,
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CO-TBG100X75",
        brand: "COTTO",
        size: "1000x750x850",
        productCode: "CO-TBG100X75",
        uri: "loading_table_for_diswasher_co-tbg100x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 410,
        tigerCode: "308258",
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CE-TBG120X75",
        brand: "CROM",
        size: "1200x750x850",
        productCode: "CE-TBG120X75",
        uri: "loading_table_for_diswasher_ce-tbg120x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 411,
        tigerCode: 305787,
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CO-TBG120X75",
        brand: "COTTO",
        size: "1200x750x850",
        productCode: "CO-TBG120X75",
        uri: "loading_table_for_diswasher_co-tbg120x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 412,
        tigerCode: "308259",
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CE-TBG140X75",
        brand: "CROM",
        size: "1400x750x850",
        productCode: "CE-TBG140X75",
        uri: "loading_table_for_diswasher_ce-tbg140x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 413,
        tigerCode: 305788,
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CO-TBG140X75",
        brand: "COTTO",
        size: "1400x750x850",
        productCode: "CO-TBG140X75",
        uri: "loading_table_for_diswasher_co-tbg140x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 414,
        tigerCode: "308260",
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CE-TBG160X75",
        brand: "CROM",
        size: "1600x750x850",
        productCode: "CE-TBG160X75",
        uri: "loading_table_for_diswasher_ce-tbg160x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 415,
        tigerCode: 305789,
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CO-TBG160X75",
        brand: "COTTO",
        size: "1600x750x850",
        productCode: "CO-TBG160X75",
        uri: "loading_table_for_diswasher_co-tbg160x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 416,
        tigerCode: "308261",
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CE-TBG180X75",
        brand: "CROM",
        size: "1800x750x850",
        productCode: "CE-TBG180X75",
        uri: "loading_table_for_diswasher_ce-tbg180x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 417,
        tigerCode: 305790,
        name: "СТОЛ ПОДАЧИ ПОСУДОМОЙКИ CO-TBG180X75",
        brand: "COTTO",
        size: "1800x750x850",
        productCode: "CO-TBG180X75",
        uri: "loading_table_for_diswasher_co-tbg180x75",
        category: "loading_table_for_diswasher"
       },
       {
        id: 418,
        tigerCode: "308265",
        name: "СТОЛ РАЗГРУЗКИ ПОСУДОМОЙКИ CE-TBC70X75",
        brand: "CROM",
        size: "700x750x850",
        productCode: "CE-TBC70X75",
        uri: "unloading_table_for_diswasher_ce-tbc70x75",
        category: "unloading_table_for_diswasher"
       },
       {
        id: 419,
        tigerCode: 305794,
        name: "СТОЛ РАЗГРУЗКИ ПОСУДОМОЙКИ CO-TBC70X75",
        brand: "COTTO",
        size: "700x750x850",
        productCode: "CO-TBC70X75",
        uri: "unloading_table_for_diswasher_co-tbc70x75",
        category: "unloading_table_for_diswasher"
       },
       {
        id: 420,
        tigerCode: "308266",
        name: "СТОЛ РАЗГРУЗКИ ПОСУДОМОЙКИ CE-TBC110X75",
        brand: "CROM",
        size: "1100x750x850",
        productCode: "CE-TBC110X75",
        uri: "unloading_table_for_diswasher_ce-tbc110x75",
        category: "unloading_table_for_diswasher"
       },
       {
        id: 421,
        tigerCode: 305795,
        name: "СТОЛ РАЗГРУЗКИ ПОСУДОМОЙКИ CO-TBC110X75",
        brand: "COTTO",
        size: "1100x750x850",
        productCode: "CO-TBC110X75",
        uri: "unloading_table_for_diswasher_co-tbc110x75",
        category: "unloading_table_for_diswasher"
       },
       {
        id: 422,
        tigerCode: "308267",
        name: "СТОЛ РАЗГРУЗКИ ПОСУДОМОЙКИ CE-TBC160X75",
        brand: "CROM",
        size: "1600x750x850",
        productCode: "CE-TBC160X75",
        uri: "unloading_table_for_diswasher_ce-tbc160x75",
        category: "unloading_table_for_diswasher"
       },
       {
        id: 423,
        tigerCode: 305796,
        name: "СТОЛ РАЗГРУЗКИ ПОСУДОМОЙКИ CO-TBC160X75",
        brand: "COTTO",
        size: "1600x750x850",
        productCode: "CO-TBC160X75",
        uri: "unloading_table_for_diswasher_co-tbc160x75",
        category: "unloading_table_for_diswasher"
       },
       {
        id: 424,
        tigerCode: "311266",
        name: "СТОЛ РАЗГРУЗКИ ПОСУДОМОЙКИ CE-TBC210X75",
        brand: "CROM",
        size: "2100x750x850",
        productCode: "CE-TBC210X75",
        uri: "unloading_table_for_diswasher_ce-tbc210x75",
        category: "unloading_table_for_diswasher"
       },
       {
        id: 425,
        tigerCode: 311213,
        name: "СТОЛ РАЗГРУЗКИ ПОСУДОМОЙКИ CO-TBC210X75",
        brand: "COTTO",
        size: "2100x750x850",
        productCode: "CO-TBC210X75",
        uri: "unloading_table_for_diswasher_co-tbc210x75",
        category: "unloading_table_for_diswasher"
       },
       {
        id: 426,
        tigerCode: "308268",
        name: "СТОЛ ДЛЯ МЫТЬЯ ОВОЩЕЙ CE-TSY120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TSY120X70",
        uri: "vegetable_washing_unit_ce-tsy120x70",
        category: "vegetable_washing_unit"
       },
       {
        id: 427,
        tigerCode: 305797,
        name: "СТОЛ ДЛЯ МЫТЬЯ ОВОЩЕЙ CO-TSY120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TSY120X70",
        uri: "vegetable_washing_unit_co-tsy120x70",
        category: "vegetable_washing_unit"
       },
       {
        id: 428,
        tigerCode: "308269",
        name: "СТОЛ ДЛЯ МЫТЬЯ ОВОЩЕЙ CE-TSY140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TSY140X70",
        uri: "vegetable_washing_unit_ce-tsy140x70",
        category: "vegetable_washing_unit"
       },
       {
        id: 429,
        tigerCode: 305798,
        name: "СТОЛ ДЛЯ МЫТЬЯ ОВОЩЕЙ CO-TSY140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TSY140X70",
        uri: "vegetable_washing_unit_co-tsy140x70",
        category: "vegetable_washing_unit"
       },
       {
        id: 430,
        tigerCode: "308270",
        name: "СТОЛ ДЛЯ МЫТЬЯ ОВОЩЕЙ CE-TSY160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TSY160X70",
        uri: "vegetable_washing_unit_ce-tsy160x70",
        category: "vegetable_washing_unit"
       },
       {
        id: 431,
        tigerCode: 305799,
        name: "СТОЛ ДЛЯ МЫТЬЯ ОВОЩЕЙ CO-TSY160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TSY160X70",
        uri: "vegetable_washing_unit_co-tsy160x70",
        category: "vegetable_washing_unit"
       },
       {
        id: 432,
        tigerCode: "308271",
        name: "СТОЛ ДЛЯ МЫТЬЯ ОВОЩЕЙ CE-TSY180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TSY180X70",
        uri: "vegetable_washing_unit_ce-tsy180x70",
        category: "vegetable_washing_unit"
       },
       {
        id: 433,
        tigerCode: 305800,
        name: "СТОЛ ДЛЯ МЫТЬЯ ОВОЩЕЙ CO-TSY180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TSY180X70",
        uri: "vegetable_washing_unit_co-tsy180x70",
        category: "vegetable_washing_unit"
       },
       {
        id: 434,
        tigerCode: "308272",
        name: "СТОЛ ДЛЯ ОБРАБОТКИ РЫБЫ CE-TBH120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TBH120X70",
        uri: "fish_preparation_unit_ce-tbh120x70",
        category: "fish_preparation_unit"
       },
       {
        id: 435,
        tigerCode: 305801,
        name: "СТОЛ ДЛЯ ОБРАБОТКИ РЫБЫ CO-TBH120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TBH120X70",
        uri: "fish_preparation_unit_co-tbh120x70",
        category: "fish_preparation_unit"
       },
       {
        id: 436,
        tigerCode: "308273",
        name: "СТОЛ ДЛЯ ОБРАБОТКИ РЫБЫ CE-TBH140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TBH140X70",
        uri: "fish_preparation_unit_ce-tbh140x70",
        category: "fish_preparation_unit"
       },
       {
        id: 437,
        tigerCode: 305802,
        name: "СТОЛ ДЛЯ ОБРАБОТКИ РЫБЫ CO-TBH140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TBH140X70",
        uri: "fish_preparation_unit_co-tbh140x70",
        category: "fish_preparation_unit"
       },
       {
        id: 438,
        tigerCode: "308274",
        name: "СТОЛ ДЛЯ ОБРАБОТКИ РЫБЫ CE-TBH160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TBH160X70",
        uri: "fish_preparation_unit_ce-tbh160x70",
        category: "fish_preparation_unit"
       },
       {
        id: 439,
        tigerCode: 305803,
        name: "СТОЛ ДЛЯ ОБРАБОТКИ РЫБЫ CO-TBH160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TBH160X70",
        uri: "fish_preparation_unit_co-tbh160x70",
        category: "fish_preparation_unit"
       },
       {
        id: 440,
        tigerCode: "308275",
        name: "СТОЛ ДЛЯ ОБРАБОТКИ РЫБЫ CE-TBH180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TBH180X70",
        uri: "fish_preparation_unit_ce-tbh180x70",
        category: "fish_preparation_unit"
       },
       {
        id: 441,
        tigerCode: 305804,
        name: "СТОЛ ДЛЯ ОБРАБОТКИ РЫБЫ CO-TBH180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TBH180X70",
        uri: "fish_preparation_unit_co-tbh180x70",
        category: "fish_preparation_unit"
       },
       {
        id: 442,
        tigerCode: 347194,
        name: "ШКАФ НАСТЕННЫЙ C РАСПАШНЫМИ ДВЕРЬМИ CE-DDCP70X40",
        brand: "CROM",
        size: "700x400x700",
        productCode: "CE-DDCP70X40",
        uri: "wall_cabinet_with_wing_cupboard_ce-ddcp70x40",
        category: "wall_cabinet_with_wing_cupboard"
       },
       {
        id: 443,
        tigerCode: 347193,
        name: "ШКАФ НАСТЕННЫЙ C РАСПАШНЫМИ ДВЕРЬМИ CO-DDCP70X40",
        brand: "COTTO",
        size: "700x400x700",
        productCode: "CO-DDCP70X40",
        uri: "wall_cabinet_with_wing_cupboard_co-ddcp70x40",
        category: "wall_cabinet_with_wing_cupboard"
       },
       {
        id: 444,
        tigerCode: "308276",
        name: "ШКАФ НАСТЕННЫЙ CE-DD100X40",
        brand: "CROM",
        size: "1000x400x600",
        productCode: "CE-DD100X40",
        uri: "wall_cabinet_ce-dd100x40",
        category: "wall_cabinet"
       },
       {
        id: 445,
        tigerCode: 305805,
        name: "ШКАФ НАСТЕННЫЙ CO-DD100X40",
        brand: "COTTO",
        size: "1000x400x600",
        productCode: "CO-DD100X40",
        uri: "wall_cabinet_co-dd100x40",
        category: "wall_cabinet"
       },
       {
        id: 446,
        tigerCode: 324051,
        name: "ШКАФ НАСТЕННЫЙ CE-DD110X40",
        brand: "CROM",
        size: "1100x400x600",
        productCode: "CE-DD110X40",
        uri: "wall_cabinet_ce-dd110x40",
        category: "wall_cabinet"
       },
       {
        id: 447,
        tigerCode: 317985,
        name: "ШКАФ НАСТЕННЫЙ CO-DD110X40",
        brand: "COTTO",
        size: "1100x400x600",
        productCode: "CO-DD110X40",
        uri: "wall_cabinet_co-dd110x40",
        category: "wall_cabinet"
       },
       {
        id: 448,
        tigerCode: "308277",
        name: "ШКАФ НАСТЕННЫЙ CE-DD120X40",
        brand: "CROM",
        size: "1200x400x600",
        productCode: "CE-DD120X40",
        uri: "wall_cabinet_ce-dd120x40",
        category: "wall_cabinet"
       },
       {
        id: 449,
        tigerCode: 305806,
        name: "ШКАФ НАСТЕННЫЙ CO-DD120X40",
        brand: "COTTO",
        size: "1200x400x600",
        productCode: "CO-DD120X40",
        uri: "wall_cabinet_co-dd120x40",
        category: "wall_cabinet"
       },
       {
        id: 450,
        tigerCode: 347195,
        name: "ШКАФ НАСТЕННЫЙ CE-DD130X40",
        brand: "CROM",
        size: "1300x400x600",
        productCode: "CE-DD130X40",
        uri: "wall_cabinet_ce-dd130x40",
        category: "wall_cabinet"
       },
       {
        id: 451,
        tigerCode: 306856,
        name: "ШКАФ НАСТЕННЫЙ CO-DD130X40",
        brand: "COTTO",
        size: "1300x400x600",
        productCode: "CO-DD130X40",
        uri: "wall_cabinet_co-dd130x40",
        category: "wall_cabinet"
       },
       {
        id: 452,
        tigerCode: "308278",
        name: "ШКАФ НАСТЕННЫЙ CE-DD140X40",
        brand: "CROM",
        size: "1400x400x600",
        productCode: "CE-DD140X40",
        uri: "wall_cabinet_ce-dd140x40",
        category: "wall_cabinet"
       },
       {
        id: 453,
        tigerCode: 305807,
        name: "ШКАФ НАСТЕННЫЙ CO-DD140X40",
        brand: "COTTO",
        size: "1400x400x600",
        productCode: "CO-DD140X40",
        uri: "wall_cabinet_co-dd140x40",
        category: "wall_cabinet"
       },
       {
        id: 454,
        tigerCode: 347197,
        name: "ШКАФ НАСТЕННЫЙ CE-DD150X40",
        brand: "CROM",
        size: "1500x400x600",
        productCode: "CE-DD150X40",
        uri: "wall_cabinet_ce-dd150x40",
        category: "wall_cabinet"
       },
       {
        id: 455,
        tigerCode: 347196,
        name: "ШКАФ НАСТЕННЫЙ CO-DD150X40",
        brand: "COTTO",
        size: "1500x400x600",
        productCode: "CO-DD150X40",
        uri: "wall_cabinet_co-dd150x40",
        category: "wall_cabinet"
       },
       {
        id: 456,
        tigerCode: "308279",
        name: "ШКАФ НАСТЕННЫЙ CE-DD160X40",
        brand: "CROM",
        size: "1600x400x600",
        productCode: "CE-DD160X40",
        uri: "wall_cabinet_ce-dd160x40",
        category: "wall_cabinet"
       },
       {
        id: 457,
        tigerCode: 305808,
        name: "ШКАФ НАСТЕННЫЙ CO-DD160X40",
        brand: "COTTO",
        size: "1600x400x600",
        productCode: "CO-DD160X40",
        uri: "wall_cabinet_co-dd160x40",
        category: "wall_cabinet"
       },
       {
        id: 458,
        tigerCode: 347199,
        name: "ШКАФ НАСТЕННЫЙ CE-DD170X40",
        brand: "CROM",
        size: "1700x400x600",
        productCode: "CE-DD170X40",
        uri: "wall_cabinet_ce-dd170x40",
        category: "wall_cabinet"
       },
       {
        id: 459,
        tigerCode: 347198,
        name: "ШКАФ НАСТЕННЫЙ CO-DD170X40",
        brand: "COTTO",
        size: "1700x400x600",
        productCode: "CO-DD170X40",
        uri: "wall_cabinet_co-dd170x40",
        category: "wall_cabinet"
       },
       {
        id: 460,
        tigerCode: "308280",
        name: "ШКАФ НАСТЕННЫЙ CE-DD180X40",
        brand: "CROM",
        size: "1800x400x600",
        productCode: "CE-DD180X40",
        uri: "wall_cabinet_ce-dd180x40",
        category: "wall_cabinet"
       },
       {
        id: 461,
        tigerCode: 305809,
        name: "ШКАФ НАСТЕННЫЙ CO-DD180X40",
        brand: "COTTO",
        size: "1800x400x600",
        productCode: "CO-DD180X40",
        uri: "wall_cabinet_co-dd180x40",
        category: "wall_cabinet"
       },
       {
        id: 462,
        tigerCode: 347200,
        name: "ШКАФ НАСТЕННЫЙ CE-DD190X40",
        brand: "CROM",
        size: "1900x400x600",
        productCode: "CE-DD190X40",
        uri: "wall_cabinet_ce-dd190x40",
        category: "wall_cabinet"
       },
       {
        id: 463,
        tigerCode: 306861,
        name: "ШКАФ НАСТЕННЫЙ CO-DD190X40",
        brand: "COTTO",
        size: "1900x400x600",
        productCode: "CO-DD190X40",
        uri: "wall_cabinet_co-dd190x40",
        category: "wall_cabinet"
       },
       {
        id: 464,
        tigerCode: "308281",
        name: "ШКАФ НАСТЕННЫЙ CE-DD200X40",
        brand: "CROM",
        size: "2000x400x600",
        productCode: "CE-DD200X40",
        uri: "wall_cabinet_ce-dd200x40",
        category: "wall_cabinet"
       },
       {
        id: 465,
        tigerCode: 305810,
        name: "ШКАФ НАСТЕННЫЙ CO-DD200X40",
        brand: "COTTO",
        size: "2000x400x600",
        productCode: "CO-DD200X40",
        uri: "wall_cabinet_co-dd200x40",
        category: "wall_cabinet"
       },
       {
        id: 466,
        tigerCode: "308282",
        name: "ПОЛКА НАСТЕННАЯ CE-DR100X30",
        brand: "CROM",
        size: "1000x300x40",
        productCode: "CE-DR100X30",
        uri: "wall_shelf_ce-dr100x30",
        category: "wall_shelf"
       },
       {
        id: 467,
        tigerCode: 305811,
        name: "ПОЛКА НАСТЕННАЯ CO-DR100X30",
        brand: "COTTO",
        size: "1000x300x40",
        productCode: "CO-DR100X30",
        uri: "wall_shelf_co-dr100x30",
        category: "wall_shelf"
       },
       {
        id: 468,
        tigerCode: 309316,
        name: "ПОЛКА НАСТЕННАЯ CE-DR110X30",
        brand: "CROM",
        size: "1100x300x40",
        productCode: "CE-DR110X30",
        uri: "wall_shelf_ce-dr110x30",
        category: "wall_shelf"
       },
       {
        id: 469,
        tigerCode: 309780,
        name: "ПОЛКА НАСТЕННАЯ CO-DR110X30",
        brand: "COTTO",
        size: "1100x300x40",
        productCode: "CO-DR110X30",
        uri: "wall_shelf_co-dr110x30",
        category: "wall_shelf"
       },
       {
        id: 470,
        tigerCode: "308283",
        name: "ПОЛКА НАСТЕННАЯ CE-DR120X30",
        brand: "CROM",
        size: "1200x300x40",
        productCode: "CE-DR120X30",
        uri: "wall_shelf_ce-dr120x30",
        category: "wall_shelf"
       },
       {
        id: 471,
        tigerCode: 305812,
        name: "ПОЛКА НАСТЕННАЯ CO-DR120X30",
        brand: "COTTO",
        size: "1200x300x40",
        productCode: "CO-DR120X30",
        uri: "wall_shelf_co-dr120x30",
        category: "wall_shelf"
       },
       {
        id: 472,
        tigerCode: 309503,
        name: "ПОЛКА НАСТЕННАЯ CE-DR130X30",
        brand: "CROM",
        size: "1300x300x40",
        productCode: "CE-DR130X30",
        uri: "wall_shelf_ce-dr130x30",
        category: "wall_shelf"
       },
       {
        id: 473,
        tigerCode: 309781,
        name: "ПОЛКА НАСТЕННАЯ CO-DR130X30",
        brand: "COTTO",
        size: "1300x300x40",
        productCode: "CO-DR130X30",
        uri: "wall_shelf_co-dr130x30",
        category: "wall_shelf"
       },
       {
        id: 474,
        tigerCode: "308284",
        name: "ПОЛКА НАСТЕННАЯ CE-DR140X30",
        brand: "CROM",
        size: "1400x300x40",
        productCode: "CE-DR140X30",
        uri: "wall_shelf_ce-dr140x30",
        category: "wall_shelf"
       },
       {
        id: 475,
        tigerCode: 305813,
        name: "ПОЛКА НАСТЕННАЯ CO-DR140X30",
        brand: "COTTO",
        size: "1400x300x40",
        productCode: "CO-DR140X30",
        uri: "wall_shelf_co-dr140x30",
        category: "wall_shelf"
       },
       {
        id: 476,
        tigerCode: 315250,
        name: "ПОЛКА НАСТЕННАЯ CE-DR150X30",
        brand: "CROM",
        size: "1500x300x40",
        productCode: "CE-DR150X30",
        uri: "wall_shelf_ce-dr150x30",
        category: "wall_shelf"
       },
       {
        id: 477,
        tigerCode: 310960,
        name: "ПОЛКА НАСТЕННАЯ CO-DR150X30",
        brand: "COTTO",
        size: "1500x300x40",
        productCode: "CO-DR150X30",
        uri: "wall_shelf_co-dr150x30",
        category: "wall_shelf"
       },
       {
        id: 478,
        tigerCode: "308285",
        name: "ПОЛКА НАСТЕННАЯ CE-DR160X30",
        brand: "CROM",
        size: "1600x300x40",
        productCode: "CE-DR160X30",
        uri: "wall_shelf_ce-dr160x30",
        category: "wall_shelf"
       },
       {
        id: 479,
        tigerCode: 305814,
        name: "ПОЛКА НАСТЕННАЯ CO-DR160X30",
        brand: "COTTO",
        size: "1600x300x40",
        productCode: "CO-DR160X30",
        uri: "wall_shelf_co-dr160x30",
        category: "wall_shelf"
       },
       {
        id: 480,
        tigerCode: 309502,
        name: "ПОЛКА НАСТЕННАЯ CE-DR170X30",
        brand: "CROM",
        size: "1700x300x40",
        productCode: "CE-DR170X30",
        uri: "wall_shelf_ce-dr170x30",
        category: "wall_shelf"
       },
       {
        id: 481,
        tigerCode: 310496,
        name: "ПОЛКА НАСТЕННАЯ CO-DR170X30",
        brand: "COTTO",
        size: "1700x300x40",
        productCode: "CO-DR170X30",
        uri: "wall_shelf_co-dr170x30",
        category: "wall_shelf"
       },
       {
        id: 482,
        tigerCode: "308286",
        name: "ПОЛКА НАСТЕННАЯ CE-DR180X30",
        brand: "CROM",
        size: "1800x300x40",
        productCode: "CE-DR180X30",
        uri: "wall_shelf_ce-dr180x30",
        category: "wall_shelf"
       },
       {
        id: 483,
        tigerCode: 305815,
        name: "ПОЛКА НАСТЕННАЯ CO-DR180X30",
        brand: "COTTO",
        size: "1800x300x40",
        productCode: "CO-DR180X30",
        uri: "wall_shelf_co-dr180x30",
        category: "wall_shelf"
       },
       {
        id: 484,
        tigerCode: 309501,
        name: "ПОЛКА НАСТЕННАЯ CE-DR190X30",
        brand: "CROM",
        size: "1900x300x40",
        productCode: "CE-DR190X30",
        uri: "wall_shelf_ce-dr190x30",
        category: "wall_shelf"
       },
       {
        id: 485,
        tigerCode: 306879,
        name: "ПОЛКА НАСТЕННАЯ CO-DR190X30",
        brand: "COTTO",
        size: "1900x300x40",
        productCode: "CO-DR190X30",
        uri: "wall_shelf_co-dr190x30",
        category: "wall_shelf"
       },
       {
        id: 486,
        tigerCode: "308287",
        name: "ПОЛКА НАСТЕННАЯ CE-DR200X30",
        brand: "CROM",
        size: "2000x300x40",
        productCode: "CE-DR200X30",
        uri: "wall_shelf_ce-dr200x30",
        category: "wall_shelf"
       },
       {
        id: 487,
        tigerCode: 305816,
        name: "ПОЛКА НАСТЕННАЯ CO-DR200X30",
        brand: "COTTO",
        size: "2000x300x40",
        productCode: "CO-DR200X30",
        uri: "wall_shelf_co-dr200x30",
        category: "wall_shelf"
       },
       {
        id: 488,
        tigerCode: 347202,
        name: "СТОЛ ПРЕМИКС CE-TBP60X60",
        brand: "CROM",
        size: "600x600x850",
        productCode: "CE-TBP60X60",
        uri: "premix_unit_ce-tbp60x60",
        category: "premix_unit"
       },
       {
        id: 489,
        tigerCode: 347201,
        name: "СТОЛ ПРЕМИКС CO-TBP60X60",
        brand: "COTTO",
        size: "600x600x850",
        productCode: "CO-TBP60X60",
        uri: "premix_unit_co-tbp60x60",
        category: "premix_unit"
       },
       {
        id: 490,
        tigerCode: "308288",
        name: "СТОЛ ПРЕМИКС CE-TBP120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TBP120X60",
        uri: "premix_unit_ce-tbp120x60",
        category: "premix_unit"
       },
       {
        id: 491,
        tigerCode: 305817,
        name: "СТОЛ ПРЕМИКС CO-TBP120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TBP120X60",
        uri: "premix_unit_co-tbp120x60",
        category: "premix_unit"
       },
       {
        id: 492,
        tigerCode: "308289",
        name: "СТОЛ ПРЕМИКС CE-TBP180X60",
        brand: "CROM",
        size: "1800x600x850",
        productCode: "CE-TBP180X60",
        uri: "premix_unit_ce-tbp180x60",
        category: "premix_unit"
       },
       {
        id: 493,
        tigerCode: 305818,
        name: "СТОЛ ПРЕМИКС CO-TBP180X60",
        brand: "COTTO",
        size: "1800x600x850",
        productCode: "CO-TBP180X60",
        uri: "premix_unit_co-tbp180x60",
        category: "premix_unit"
       },
       {
        id: 494,
        tigerCode: "308290",
        name: "СTOЛ ДЛЯ ПРИГОТОВЛЕНИЯ КОКТЕЙЛЯ CE-TBK120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TBK120X60",
        uri: "coctail_preparation_unit_ce-tbk120x60",
        category: "coctail_preparation_unit"
       },
       {
        id: 495,
        tigerCode: 305819,
        name: "СTOЛ ДЛЯ ПРИГОТОВЛЕНИЯ КОКТЕЙЛЯ CO-TBK120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TBK120X60",
        uri: "coctail_preparation_unit_co-tbk120x60",
        category: "coctail_preparation_unit"
       },
       {
        id: 496,
        tigerCode: "308291",
        name: "СTOЛ ДЛЯ ПРИГОТОВЛЕНИЯ КОКТЕЙЛЯ CE-TBK140X60",
        brand: "CROM",
        size: "1400x600x850",
        productCode: "CE-TBK140X60",
        uri: "coctail_preparation_unit_ce-tbk140x60",
        category: "coctail_preparation_unit"
       },
       {
        id: 497,
        tigerCode: 305820,
        name: "СTOЛ ДЛЯ ПРИГОТОВЛЕНИЯ КОКТЕЙЛЯ CO-TBK140X60",
        brand: "COTTO",
        size: "1400x600x850",
        productCode: "CO-TBK140X60",
        uri: "coctail_preparation_unit_co-tbk140x60",
        category: "coctail_preparation_unit"
       },
       {
        id: 498,
        tigerCode: "308297",
        name: "СTOЛ ДЛЯ ПРИГОТОВЛЕНИЯ КОФЕ CE-TBC100X60",
        brand: "CROM",
        size: "1000x600x850",
        productCode: "CE-TBC100X60",
        uri: "coffee_preparation_unit_ce-tbc100x60",
        category: "coctail_preparation_unit"
       },
       {
        id: 499,
        tigerCode: 305826,
        name: "СTOЛ ДЛЯ ПРИГОТОВЛЕНИЯ КОФЕ CO-TBC100X60",
        brand: "COTTO",
        size: "1000x600x850",
        productCode: "CO-TBC100X60",
        uri: "coffee_preparation_unit_co-tbc100x60",
        category: "coctail_preparation_unit"
       },
       {
        id: 500,
        tigerCode: "308298",
        name: "СTOЛ ДЛЯ ПРИГОТОВЛЕНИЯ КОФЕ CE-TBC120X60",
        brand: "CROM",
        size: "1200x600x850",
        productCode: "CE-TBC120X60",
        uri: "coffee_preparation_unit_ce-tbc120x60",
        category: "coctail_preparation_unit"
       },
       {
        id: 501,
        tigerCode: 305827,
        name: "СTOЛ ДЛЯ ПРИГОТОВЛЕНИЯ КОФЕ CO-TBC120X60",
        brand: "COTTO",
        size: "1200x600x850",
        productCode: "CO-TBC120X60",
        uri: "coffee_preparation_unit_co-tbc120x60",
        category: "coctail_preparation_unit"
       },
       {
        id: 502,
        tigerCode: 346730,
        name: "ШКАФ CE-DM60X60",
        brand: "CROM",
        size: "600x600x1600",
        productCode: "CE-DM60X60",
        uri: "cupboard_ce-dm60x60",
        category: "cupboard"
       },
       {
        id: 503,
        tigerCode: 347203,
        name: "ШКАФ CO-DM60X60",
        brand: "COTTO",
        size: "600x600x1600",
        productCode: "CO-DM60X60",
        uri: "cupboard_co-dm60x60",
        category: "cupboard"
       },
       {
        id: 504,
        tigerCode: 346902,
        name: "ШКАФ CE-DM100X60",
        brand: "CROM",
        size: "1000x600x1600",
        productCode: "CE-DM100X60",
        uri: "cupboard_ce-dm100x60",
        category: "cupboard"
       },
       {
        id: 505,
        tigerCode: 347204,
        name: "ШКАФ CO-DM100X60",
        brand: "COTTO",
        size: "1000x600x1600",
        productCode: "CO-DM100X60",
        uri: "cupboard_co-dm100x60",
        category: "cupboard"
       },
       {
        id: 506,
        tigerCode: "308299",
        name: "ШКАФ CE-DM120X60",
        brand: "CROM",
        size: "1200x600x1600",
        productCode: "CE-DM120X60",
        uri: "cupboard_ce-dm120x60",
        category: "cupboard"
       },
       {
        id: 507,
        tigerCode: 305828,
        name: "ШКАФ CO-DM120X60",
        brand: "COTTO",
        size: "1200x600x1600",
        productCode: "CO-DM120X60",
        uri: "cupboard_co-dm120x60",
        category: "cupboard"
       },
       {
        id: 508,
        tigerCode: 347207,
        name: "СТЕЛЛАЖ CE-IR80X40",
        brand: "CROM",
        size: "800x400x1530",
        productCode: "CE-IR80X40",
        uri: "shelving_unit_ce-ir80x40",
        category: "shelving_unit"
       },
       {
        id: 509,
        tigerCode: 347205,
        name: "СТЕЛЛАЖ CO-IR80X40",
        brand: "COTTO",
        size: "800x400x1530",
        productCode: "CO-IR80X40",
        uri: "shelving_unit_co-ir80x40",
        category: "shelving_unit"
       },
       {
        id: 510,
        tigerCode: 343382,
        name: "СТЕЛЛАЖ CE-IR80X50",
        brand: "CROM",
        size: "800x500x1530",
        productCode: "CE-IR80X50",
        uri: "shelving_unit_ce-ir80x50",
        category: "shelving_unit"
       },
       {
        id: 511,
        tigerCode: 347217,
        name: "СТЕЛЛАЖ CO-IR80X50",
        brand: "COTTO",
        size: "800x500x1530",
        productCode: "CO-IR80X50",
        uri: "shelving_unit_co-ir80x50",
        category: "shelving_unit"
       },
       {
        id: 512,
        tigerCode: 344241,
        name: "СТЕЛЛАЖ CE-IR90X40",
        brand: "CROM",
        size: "900x400x1530",
        productCode: "CE-IR90X40",
        uri: "shelving_unit_ce-ir90x40",
        category: "shelving_unit"
       },
       {
        id: 513,
        tigerCode: 347206,
        name: "СТЕЛЛАЖ CO-IR90X40",
        brand: "COTTO",
        size: "900x400x1530",
        productCode: "CO-IR90X40",
        uri: "shelving_unit_co-ir90x40",
        category: "shelving_unit"
       },
       {
        id: 514,
        tigerCode: 346728,
        name: "СТЕЛЛАЖ CE-IR90X50",
        brand: "CROM",
        size: "900x500x1530",
        productCode: "CE-IR90X50",
        uri: "shelving_unit_ce-ir90x50",
        category: "shelving_unit"
       },
       {
        id: 515,
        tigerCode: 347218,
        name: "СТЕЛЛАЖ CO-IR90X50",
        brand: "COTTO",
        size: "900x500x1530",
        productCode: "CO-IR90X50",
        uri: "shelving_unit_co-ir90x50",
        category: "shelving_unit"
       },
       {
        id: 516,
        tigerCode: "308300",
        name: "СТЕЛЛАЖ CE-IR100X40",
        brand: "CROM",
        size: "1000x400x1530",
        productCode: "CE-IR100X40",
        uri: "shelving_unit_ce-ir100x40",
        category: "shelving_unit"
       },
       {
        id: 517,
        tigerCode: 305829,
        name: "СТЕЛЛАЖ CO-IR100X40",
        brand: "COTTO",
        size: "1000x400x1530",
        productCode: "CO-IR100X40",
        uri: "shelving_unit_co-ir100x40",
        category: "shelving_unit"
       },
       {
        id: 518,
        tigerCode: "308304",
        name: "СТЕЛЛАЖ CE-IR100X50",
        brand: "CROM",
        size: "1000x500x1530",
        productCode: "CE-IR100X50",
        uri: "shelving_unit_ce-ir100x50",
        category: "shelving_unit"
       },
       {
        id: 519,
        tigerCode: 305833,
        name: "СТЕЛЛАЖ CO-IR100X50",
        brand: "COTTO",
        size: "1000x500x1530",
        productCode: "CO-IR100X50",
        uri: "shelving_unit_co-ir100x50",
        category: "shelving_unit"
       },
       {
        id: 520,
        tigerCode: 347209,
        name: "СТЕЛЛАЖ CE-IR110X40",
        brand: "CROM",
        size: "1100x400x1530",
        productCode: "CE-IR110X40",
        uri: "shelving_unit_ce-ir110x40",
        category: "shelving_unit"
       },
       {
        id: 521,
        tigerCode: 347208,
        name: "СТЕЛЛАЖ CO-IR110X40",
        brand: "COTTO",
        size: "1100x400x1530",
        productCode: "CO-IR110X40",
        uri: "shelving_unit_co-ir110x40",
        category: "shelving_unit"
       },
       {
        id: 522,
        tigerCode: 344195,
        name: "СТЕЛЛАЖ CE-IR110X50",
        brand: "CROM",
        size: "1100x500x1530",
        productCode: "CE-IR110X50",
        uri: "shelving_unit_ce-ir110x50",
        category: "shelving_unit"
       },
       {
        id: 523,
        tigerCode: 347219,
        name: "СТЕЛЛАЖ CO-IR110X50",
        brand: "COTTO",
        size: "1100x500x1530",
        productCode: "CO-IR110X50",
        uri: "shelving_unit_co-ir110x50",
        category: "shelving_unit"
       },
       {
        id: 524,
        tigerCode: "308301",
        name: "СТЕЛЛАЖ CE-IR120X40",
        brand: "CROM",
        size: "1200x400x1530",
        productCode: "CE-IR120X40",
        uri: "shelving_unit_ce-ir120x40",
        category: "shelving_unit"
       },
       {
        id: 525,
        tigerCode: 305830,
        name: "СТЕЛЛАЖ CO-IR120X40",
        brand: "COTTO",
        size: "1200x400x1530",
        productCode: "CO-IR120X40",
        uri: "shelving_unit_co-ir120x40",
        category: "shelving_unit"
       },
       {
        id: 526,
        tigerCode: "308305",
        name: "СТЕЛЛАЖ CE-IR120X50",
        brand: "CROM",
        size: "1200x500x1530",
        productCode: "CE-IR120X50",
        uri: "shelving_unit_ce-ir120x50",
        category: "shelving_unit"
       },
       {
        id: 527,
        tigerCode: 305834,
        name: "СТЕЛЛАЖ CO-IR120X50",
        brand: "COTTO",
        size: "1200x500x1530",
        productCode: "CO-IR120X50",
        uri: "shelving_unit_co-ir120x50",
        category: "shelving_unit"
       },
       {
        id: 528,
        tigerCode: 347211,
        name: "СТЕЛЛАЖ CE-IR130X40",
        brand: "CROM",
        size: "1300x400x1530",
        productCode: "CE-IR130X40",
        uri: "shelving_unit_ce-ir130x40",
        category: "shelving_unit"
       },
       {
        id: 529,
        tigerCode: 347210,
        name: "СТЕЛЛАЖ CO-IR130X40",
        brand: "COTTO",
        size: "1300x400x1530",
        productCode: "CO-IR130X40",
        uri: "shelving_unit_co-ir130x40",
        category: "shelving_unit"
       },
       {
        id: 530,
        tigerCode: 313593,
        name: "СТЕЛЛАЖ CE-IR130X50",
        brand: "CROM",
        size: "1300x500x1530",
        productCode: "CE-IR130X50",
        uri: "shelving_unit_ce-ir130x50",
        category: "shelving_unit"
       },
       {
        id: 531,
        tigerCode: 347220,
        name: "СТЕЛЛАЖ CO-IR130X50",
        brand: "COTTO",
        size: "1300x500x1530",
        productCode: "CO-IR130X50",
        uri: "shelving_unit_co-ir130x50",
        category: "shelving_unit"
       },
       {
        id: 532,
        tigerCode: "308302",
        name: "СТЕЛЛАЖ CE-IR140X40",
        brand: "CROM",
        size: "1400x400x1530",
        productCode: "CE-IR140X40",
        uri: "shelving_unit_ce-ir140x40",
        category: "shelving_unit"
       },
       {
        id: 533,
        tigerCode: 305831,
        name: "СТЕЛЛАЖ CO-IR140X40",
        brand: "COTTO",
        size: "1400x400x1530",
        productCode: "CO-IR140X40",
        uri: "shelving_unit_co-ir140x40",
        category: "shelving_unit"
       },
       {
        id: 534,
        tigerCode: "308306",
        name: "СТЕЛЛАЖ CE-IR140X50",
        brand: "CROM",
        size: "1400x500x1530",
        productCode: "CE-IR140X50",
        uri: "shelving_unit_ce-ir140x50",
        category: "shelving_unit"
       },
       {
        id: 535,
        tigerCode: 305835,
        name: "СТЕЛЛАЖ CO-IR140X50",
        brand: "COTTO",
        size: "1400x500x1530",
        productCode: "CO-IR140X50",
        uri: "shelving_unit_co-ir140x50",
        category: "shelving_unit"
       },
       {
        id: 536,
        tigerCode: 347213,
        name: "СТЕЛЛАЖ CE-IR150X40",
        brand: "CROM",
        size: "1500x400x1530",
        productCode: "CE-IR150X40",
        uri: "shelving_unit_ce-ir150x40",
        category: "shelving_unit"
       },
       {
        id: 537,
        tigerCode: 347212,
        name: "СТЕЛЛАЖ CO-IR150X40",
        brand: "COTTO",
        size: "1500x400x1530",
        productCode: "CO-IR150X40",
        uri: "shelving_unit_co-ir150x40",
        category: "shelving_unit"
       },
       {
        id: 538,
        tigerCode: 313446,
        name: "СТЕЛЛАЖ CE-IR150X50",
        brand: "CROM",
        size: "1500x500x1530",
        productCode: "CE-IR150X50",
        uri: "shelving_unit_ce-ir150x50",
        category: "shelving_unit"
       },
       {
        id: 539,
        tigerCode: 347221,
        name: "СТЕЛЛАЖ CO-IR150X50",
        brand: "COTTO",
        size: "1500x500x1530",
        productCode: "CO-IR150X50",
        uri: "shelving_unit_co-ir150x50",
        category: "shelving_unit"
       },
       {
        id: 540,
        tigerCode: "308303",
        name: "СТЕЛЛАЖ CE-IR160X40",
        brand: "CROM",
        size: "1600x400x1530",
        productCode: "CE-IR160X40",
        uri: "shelving_unit_ce-ir160x40",
        category: "shelving_unit"
       },
       {
        id: 541,
        tigerCode: 305832,
        name: "СТЕЛЛАЖ CO-IR160X40",
        brand: "COTTO",
        size: "1600x400x1530",
        productCode: "CO-IR160X40",
        uri: "shelving_unit_co-ir160x40",
        category: "shelving_unit"
       },
       {
        id: 542,
        tigerCode: "308307",
        name: "СТЕЛЛАЖ CE-IR160X50",
        brand: "CROM",
        size: "1600x500x1530",
        productCode: "CE-IR160X50",
        uri: "shelving_unit_ce-ir160x50",
        category: "shelving_unit"
       },
       {
        id: 543,
        tigerCode: 305836,
        name: "СТЕЛЛАЖ CO-IR160X50",
        brand: "COTTO",
        size: "1600x500x1530",
        productCode: "CO-IR160X50",
        uri: "shelving_unit_co-ir160x50",
        category: "shelving_unit"
       },
       {
        id: 544,
        tigerCode: 347215,
        name: "СТЕЛЛАЖ CE-IR170X40",
        brand: "CROM",
        size: "1700x400x1530",
        productCode: "CE-IR170X40",
        uri: "shelving_unit_ce-ir170x40",
        category: "shelving_unit"
       },
       {
        id: 545,
        tigerCode: 347214,
        name: "СТЕЛЛАЖ CO-IR170X40",
        brand: "COTTO",
        size: "1700x400x1530",
        productCode: "CO-IR170X40",
        uri: "shelving_unit_co-ir170x40",
        category: "shelving_unit"
       },
       {
        id: 546,
        tigerCode: 306604,
        name: "СТЕЛЛАЖ CE-IR170X50",
        brand: "CROM",
        size: "1700x500x1530",
        productCode: "CE-IR170X50",
        uri: "shelving_unit_ce-ir170x50",
        category: "shelving_unit"
       },
       {
        id: 547,
        tigerCode: 347222,
        name: "СТЕЛЛАЖ CO-IR170X50",
        brand: "COTTO",
        size: "1700x500x1530",
        productCode: "CO-IR170X50",
        uri: "shelving_unit_co-ir170x50",
        category: "shelving_unit"
       },
       {
        id: 548,
        tigerCode: 346000,
        name: "СТЕЛЛАЖ CE-IR180X40",
        brand: "CROM",
        size: "1800x400x1530",
        productCode: "CE-IR180X40",
        uri: "shelving_unit_ce-ir180x40",
        category: "shelving_unit"
       },
       {
        id: 549,
        tigerCode: 347216,
        name: "СТЕЛЛАЖ CO-IR180X40",
        brand: "COTTO",
        size: "1800x400x1530",
        productCode: "CO-IR180X40",
        uri: "shelving_unit_co-ir180x40",
        category: "shelving_unit"
       },
       {
        id: 550,
        tigerCode: 306607,
        name: "СТЕЛЛАЖ CE-IR180X50",
        brand: "CROM",
        size: "1800x500x1530",
        productCode: "CE-IR180X50",
        uri: "shelving_unit_ce-ir180x50",
        category: "shelving_unit"
       },
       {
        id: 551,
        tigerCode: 347223,
        name: "СТЕЛЛАЖ CO-IR180X50",
        brand: "COTTO",
        size: "1800x500x1530",
        productCode: "CO-IR180X50",
        uri: "shelving_unit_co-ir180x50",
        category: "shelving_unit"
       },
       {
        id: 552,
        tigerCode: 347228,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CE-IRK100X60",
        brand: "CROM",
        size: "1000x600x1530",
        productCode: "CE-IRK100X60",
        uri: "shelving_unit_for_pots_ce-irk100x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 553,
        tigerCode: 347227,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CO-IRK100X60",
        brand: "COTTO",
        size: "1000x600x1530",
        productCode: "CO-IRK100X60",
        uri: "shelving_unit_for_pots_co-irk100x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 554,
        tigerCode: 347230,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CE-IRK110X60",
        brand: "CROM",
        size: "1100x600x1530",
        productCode: "CE-IRK110X60",
        uri: "shelving_unit_for_pots_ce-irk110x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 555,
        tigerCode: 347229,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CO-IRK110X60",
        brand: "COTTO",
        size: "1100x600x1530",
        productCode: "CO-IRK110X60",
        uri: "shelving_unit_for_pots_co-irk110x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 556,
        tigerCode: 346701,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CE-IRK120X60",
        brand: "CROM",
        size: "1200x600x1530",
        productCode: "CE-IRK120X60",
        uri: "shelving_unit_for_pots_ce-irk120x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 557,
        tigerCode: 346697,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CO-IRK120X60",
        brand: "COTTO",
        size: "1200x600x1530",
        productCode: "CO-IRK120X60",
        uri: "shelving_unit_for_pots_co-irk120x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 558,
        tigerCode: 347232,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CE-IRK130X60",
        brand: "CROM",
        size: "1300x600x1530",
        productCode: "CE-IRK130X60",
        uri: "shelving_unit_for_pots_ce-irk130x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 559,
        tigerCode: 347231,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CO-IRK130X60",
        brand: "COTTO",
        size: "1300x600x1530",
        productCode: "CO-IRK130X60",
        uri: "shelving_unit_for_pots_co-irk130x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 560,
        tigerCode: 346702,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CE-IRK140X60",
        brand: "CROM",
        size: "1400x600x1530",
        productCode: "CE-IRK140X60",
        uri: "shelving_unit_for_pots_ce-irk140x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 561,
        tigerCode: 346698,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CO-IRK140X60",
        brand: "COTTO",
        size: "1400x600x1530",
        productCode: "CO-IRK140X60",
        uri: "shelving_unit_for_pots_co-irk140x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 562,
        tigerCode: 346554,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CE-IRK150X60",
        brand: "CROM",
        size: "1500x600x1530",
        productCode: "CE-IRK150X60",
        uri: "shelving_unit_for_pots_ce-irk150x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 563,
        tigerCode: 347233,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CO-IRK150X60",
        brand: "COTTO",
        size: "1500x600x1530",
        productCode: "CO-IRK150X60",
        uri: "shelving_unit_for_pots_co-irk150x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 564,
        tigerCode: 346703,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CE-IRK160X60",
        brand: "CROM",
        size: "1600x600x1530",
        productCode: "CE-IRK160X60",
        uri: "shelving_unit_for_pots_ce-irk160x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 565,
        tigerCode: 346699,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CO-IRK160X60",
        brand: "COTTO",
        size: "1600x600x1530",
        productCode: "CO-IRK160X60",
        uri: "shelving_unit_for_pots_co-irk160x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 566,
        tigerCode: 347235,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CE-IRK170X60",
        brand: "CROM",
        size: "1700x600x1530",
        productCode: "CE-IRK170X60",
        uri: "shelving_unit_for_pots_ce-irk170x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 567,
        tigerCode: 347234,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CO-IRK170X60",
        brand: "COTTO",
        size: "1700x600x1530",
        productCode: "CO-IRK170X60",
        uri: "shelving_unit_for_pots_co-irk170x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 568,
        tigerCode: 346704,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CE-IRK180X60",
        brand: "CROM",
        size: "1800x600x1530",
        productCode: "CE-IRK180X60",
        uri: "shelving_unit_for_pots_ce-irk180x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 569,
        tigerCode: 346700,
        name: "СТЕЛЛАЖ ДЛЯ КАЗАНА CO-IRK180X60",
        brand: "COTTO",
        size: "1800x600x1530",
        productCode: "CO-IRK180X60",
        uri: "shelving_unit_for_pots_co-irk180x60",
        category: "shelving_unit_for_pots"
       },
       {
        id: 570,
        tigerCode: 311543,
        name: "ПОДТОВАРНИК CE-ST5080",
        brand: "CROM",
        size: "800x500x300",
        productCode: "CE-ST5080",
        uri: "storage_table_ce-st5080",
        category: "storage_table"
       },
       {
        id: 571,
        tigerCode: 311516,
        name: "ПОДТОВАРНИК CO-ST5080",
        brand: "COTTO",
        size: "800x500x300",
        productCode: "CO-ST5080",
        uri: "storage_table_co-st5080",
        category: "storage_table"
       },
       {
        id: 572,
        tigerCode: "308312",
        name: "ПОДТОВАРНИК CE-ST50100",
        brand: "CROM",
        size: "1000x500x300",
        productCode: "CE-ST50100",
        uri: "storage_table_ce-st50100",
        category: "storage_table"
       },
       {
        id: 573,
        tigerCode: 305841,
        name: "ПОДТОВАРНИК CO-ST50100",
        brand: "COTTO",
        size: "1000x500x300",
        productCode: "CO-ST50100",
        uri: "storage_table_co-st50100",
        category: "storage_table"
       },
       {
        id: 574,
        tigerCode: 311544,
        name: "ПОДТОВАРНИК CE-ST50120",
        brand: "CROM",
        size: "1200x500x300",
        productCode: "CE-ST50120",
        uri: "storage_table_ce-st50120",
        category: "storage_table"
       },
       {
        id: 575,
        tigerCode: 311517,
        name: "ПОДТОВАРНИК CO-ST50120",
        brand: "COTTO",
        size: "1200x500x300",
        productCode: "CO-ST50120",
        uri: "storage_table_co-st50120",
        category: "storage_table"
       },
       {
        id: 576,
        tigerCode: 311545,
        name: "ПОДТОВАРНИК CE-ST50140",
        brand: "CROM",
        size: "1400x500x300",
        productCode: "CE-ST50140",
        uri: "storage_table_ce-st50140",
        category: "storage_table"
       },
       {
        id: 577,
        tigerCode: 311518,
        name: "ПОДТОВАРНИК CO-ST50140",
        brand: "COTTO",
        size: "1400x500x300",
        productCode: "CO-ST50140",
        uri: "storage_table_co-st50140",
        category: "storage_table"
       },
       {
        id: 578,
        tigerCode: 311546,
        name: "ПОДТОВАРНИК CE-ST50160",
        brand: "CROM",
        size: "1600x500x300",
        productCode: "CE-ST50160",
        uri: "storage_table_ce-st50160",
        category: "storage_table"
       },
       {
        id: 579,
        tigerCode: 311519,
        name: "ПОДТОВАРНИК CO-ST50160",
        brand: "COTTO",
        size: "1600x500x300",
        productCode: "CO-ST50160",
        uri: "storage_table_co-st50160",
        category: "storage_table"
       },
       {
        id: 580,
        tigerCode: 311547,
        name: "ПОДТОВАРНИК CE-ST50180",
        brand: "CROM",
        size: "1800x500x300",
        productCode: "CE-ST50180",
        uri: "storage_table_ce-st50180",
        category: "storage_table"
       },
       {
        id: 581,
        tigerCode: 311520,
        name: "ПОДТОВАРНИК CO-ST50180",
        brand: "COTTO",
        size: "1800x500x300",
        productCode: "CO-ST50180",
        uri: "storage_table_co-st50180",
        category: "storage_table"
       },
       {
        id: 582,
        tigerCode: "308316",
        name: "ТЕЛЕЖКА ДЛЯ ТАРЕЛОК CE-ATA100X2",
        brand: "CROM",
        size: "980x520x750",
        productCode: "CE-ATA100X2",
        uri: "plate_trolley_ce-ata100x2",
        category: "plate_trolley"
       },
       {
        id: 583,
        tigerCode: 305845,
        name: "ТЕЛЕЖКА ДЛЯ ТАРЕЛОК CO-ATA100X2",
        brand: "COTTO",
        size: "980x520x750",
        productCode: "CO-ATA100X2",
        uri: "plate_trolley_co-ata100x2",
        category: "plate_trolley"
       },
       {
        id: 584,
        tigerCode: "308317",
        name: "ТЕЛЕЖКА ДЛЯ ТАРЕЛОК CE-ATA102X2",
        brand: "CROM",
        size: "980x820x750",
        productCode: "CE-ATA102X2",
        uri: "plate_trolley_ce-ata102x2",
        category: "plate_trolley"
       },
       {
        id: 585,
        tigerCode: 305846,
        name: "ТЕЛЕЖКА ДЛЯ ТАРЕЛОК CO-ATA102X2",
        brand: "COTTO",
        size: "980x820x750",
        productCode: "CO-ATA102X2",
        uri: "plate_trolley_co-ata102x2",
        category: "plate_trolley"
       },
       {
        id: 586,
        tigerCode: "308318",
        name: "ТЕЛЕЖКА ДЛЯ КАЗАНА CE-AKA90X60",
        brand: "CROM",
        size: "900x600x500\/900",
        productCode: "CE-AKA90X60",
        uri: "pot_trolley_ce-aka90x60",
        category: "plate_trolley"
       },
       {
        id: 587,
        tigerCode: 305847,
        name: "ТЕЛЕЖКА ДЛЯ КАЗАНА CO-AKA90X60",
        brand: "COTTO",
        size: "900x600x500\/900",
        productCode: "CO-AKA90X60",
        uri: "pot_trolley_co-aka90x60",
        category: "plate_trolley"
       },
       {
        id: 588,
        tigerCode: "308319",
        name: "ТЕЛЕЖКА СЕРВИСНАЯ 2-УР. CE-ASI55X86X2",
        brand: "CROM",
        size: "550x860x900",
        productCode: "CE-ASI55X86X2",
        uri: "service_trolley_2_tier_ce-asi55x86x2",
        category: "service_trolley_2_tier"
       },
       {
        id: 589,
        tigerCode: 305851,
        name: "ТЕЛЕЖКА СЕРВИСНАЯ 2-УР. CO-ASI55X86X2",
        brand: "COTTO",
        size: "550x860x900",
        productCode: "CO-ASI55X86X2",
        uri: "service_trolley_2_tier_co-asi55x86x2",
        category: "service_trolley_2_tier"
       },
       {
        id: 590,
        tigerCode: "308320",
        name: "ТЕЛЕЖКА СЕРВИСНАЯ 3-УР. CE-ASU55X86X3",
        brand: "CROM",
        size: "550x860x900",
        productCode: "CE-ASU55X86X3",
        uri: "service_trolley_3_tier_ce-asu55x86x3",
        category: "service_trolley_3_tier"
       },
       {
        id: 591,
        tigerCode: 305852,
        name: "ТЕЛЕЖКА СЕРВИСНАЯ 3-УР. CO-ASU55X86X3",
        brand: "COTTO",
        size: "550x860x900",
        productCode: "CO-ASU55X86X3",
        uri: "service_trolley_3_tier_co-asu55x86x3",
        category: "service_trolley_3_tier"
       },
       {
        id: 592,
        tigerCode: "308321",
        name: "ТЕЛЕЖКА ДЛЯ ПЛАТФОРМЫ CE-AMA80X60",
        brand: "CROM",
        size: "800x600x200\/900",
        productCode: "CE-AMA80X60",
        uri: "platform_trolley_ce-ama80x60",
        category: "platform_trolley"
       },
       {
        id: 593,
        tigerCode: 305853,
        name: "ТЕЛЕЖКА ДЛЯ ПЛАТФОРМЫ CO-AMA80X60",
        brand: "COTTO",
        size: "800x600x200\/900",
        productCode: "CO-AMA80X60",
        uri: "platform_trolley_co-ama80x60",
        category: "platform_trolley"
       },
       {
        id: 594,
        tigerCode: 308324,
        name: "ТЕЛЕЖКА ДЛЯ ГАСТРОЕМКОСТЕЙ 1-1 CE-AGN1-1X16",
        brand: "CROM",
        size: "383X530X1650",
        productCode: "CE-AGN1-1X16",
        uri: "gn_tray_trolley_1-1_ce-agn1-1x16",
        category: "gn_tray_trolley_1-1_c"
       },
       {
        id: 595,
        tigerCode: 305857,
        name: "ТЕЛЕЖКА ДЛЯ ГАСТРОЕМКОСТЕЙ 1-1 CO-AGN1-1X16",
        brand: "COTTO",
        size: "383X530X1650",
        productCode: "CO-AGN1-1X16",
        uri: "gn_tray_trolley_1-1_co-agn1-1x16",
        category: "gn_tray_trolley_1-1_c"
       },
       {
        id: 596,
        tigerCode: 347237,
        name: "ТЕЛЕЖКА ДЛЯ ГАСТРОЕМКОСТЕЙ 1-1 CE-AGN1-1X32",
        brand: "CROM",
        size: "741X530X1650",
        productCode: "CE-AGN1-1X32",
        uri: "gn_tray_trolley_1-1_ce-agn1-1x32",
        category: "gn_tray_trolley_1-1_c"
       },
       {
        id: 597,
        tigerCode: 347236,
        name: "ТЕЛЕЖКА ДЛЯ ГАСТРОЕМКОСТЕЙ 1-1 CO-AGN1-1X32",
        brand: "COTTO",
        size: "741X530X1650",
        productCode: "CO-AGN1-1X32",
        uri: "gn_tray_trolley_1-1_co-agn1-1x32",
        category: "gn_tray_trolley_1-1_c"
       },
       {
        id: 598,
        tigerCode: 308325,
        name: "ТЕЛЕЖКА ДЛЯ ГАСТРОЕМКОСТЕЙ 2-1 CO-AGN2-1X16",
        brand: "CROM",
        size: "588X650X1650",
        productCode: "CE-AGN2-1X16",
        uri: "gn_tray_trolley_2-1_co-agn2-1x16",
        category: "gn_tray_trolley_2-1_c"
       },
       {
        id: 599,
        tigerCode: 305858,
        name: "ТЕЛЕЖКА ДЛЯ ГАСТРОЕМКОСТЕЙ 2-1 CO-AGN2-1X16",
        brand: "COTTO",
        size: "588X650X1650",
        productCode: "CO-AGN2-1X16",
        uri: "gn_tray_trolley_2-1_co-agn2-1x16",
        category: "gn_tray_trolley_2-1_c"
       },
       {
        id: 600,
        tigerCode: 308326,
        name: "ТЕЛЕЖКА ДЛЯ ПОДНОСОВ CE-ATT37X53X17",
        brand: "CROM",
        size: "428X530X1700",
        productCode: "CE-ATT37X53X17",
        uri: "tray_trolley_ce-att37x53x17",
        category: "tray_trolley"
       },
       {
        id: 601,
        tigerCode: 305859,
        name: "ТЕЛЕЖКА ДЛЯ ПОДНОСОВ CO-ATT37X53X17",
        brand: "COTTO",
        size: "428X530X1700",
        productCode: "CO-ATT37X53X17",
        uri: "tray_trolley_co-att37x53x17",
        category: "tray_trolley"
       },
       {
        id: 602,
        tigerCode: 347239,
        name: "ТЕЛЕЖКА ДЛЯ ПОДНОСОВ CE-ATT37X53X34",
        brand: "CROM",
        size: "831X530X1700",
        productCode: "CE-ATT37X53X34",
        uri: "tray_trolley_ce-att37x53x34",
        category: "tray_trolley"
       },
       {
        id: 603,
        tigerCode: 347238,
        name: "ТЕЛЕЖКА ДЛЯ ПОДНОСОВ CO-ATT37X53X34",
        brand: "COTTO",
        size: "831X530X1700",
        productCode: "CO-ATT37X53X34",
        uri: "tray_trolley_co-att37x53x34",
        category: "tray_trolley"
       },
       {
        id: 604,
        tigerCode: 308327,
        name: "ТЕЛЕЖКА ДЛЯ ПОДНОСОВ CE-ATT40X60X14",
        brand: "CROM",
        size: "458X600X1650",
        productCode: "CE-ATT40X60X14",
        uri: "tray_trolley_ce-att40x60x14",
        category: "tray_trolley"
       },
       {
        id: 605,
        tigerCode: 305860,
        name: "ТЕЛЕЖКА ДЛЯ ПОДНОСОВ CO-ATT40X60X14",
        brand: "COTTO",
        size: "458X600X1650",
        productCode: "CO-ATT40X60X14",
        uri: "tray_trolley_co-att40x60x14",
        category: "tray_trolley"
       },
       {
        id: 606,
        tigerCode: "308328",
        name: "ТЕЛЕЖКА ДЛЯ ПОДНОСОВ CE-ATT40X60X28",
        brand: "CROM",
        size: "891X600X1650",
        productCode: "CE-ATT40X60X28",
        uri: "tray_trolley_ce-att40x60x28",
        category: "tray_trolley"
       },
       {
        id: 607,
        tigerCode: 305861,
        name: "ТЕЛЕЖКА ДЛЯ ПОДНОСОВ CO-ATT40X60X28",
        brand: "COTTO",
        size: "891X600X1650",
        productCode: "CO-ATT40X60X28",
        uri: "tray_trolley_co-att40x60x28",
        category: "tray_trolley"
       },
       {
        id: 608,
        tigerCode: "308329",
        name: "ПРИЛАВОК ДЛЯ СТОЛОВЫХ ПРИБОРОВ CE-SKU70X70",
        brand: "CROM",
        size: "700x700x1250",
        productCode: "CE-SKU70X70",
        uri: "utensil_dispencer_ce-sku70x70",
        category: "utensil_dispencer"
       },
       {
        id: 609,
        tigerCode: 305862,
        name: "ПРИЛАВОК ДЛЯ СТОЛОВЫХ ПРИБОРОВ CO-SKU70X70",
        brand: "COTTO",
        size: "700x700x1250",
        productCode: "CO-SKU70X70",
        uri: "utensil_dispencer_co-sku70x70",
        category: "utensil_dispencer"
       },
       {
        id: 610,
        tigerCode: "308330",
        name: "ЛИНИЯ СЕРВИСА ПЕРВЫХ БЛЮД CE-SCO100X70",
        brand: "CROM",
        size: "1000x700x850\/1300",
        productCode: "CE-SCO100X70",
        uri: "soup_service_unit_ce-sco100x70",
        category: "soup_service_unit"
       },
       {
        id: 611,
        tigerCode: "305863",
        name: "ЛИНИЯ СЕРВИСА ПЕРВЫХ БЛЮД CO-SCO100X70",
        brand: "COTTO",
        size: "1000x700x850\/1300",
        productCode: "CO-SCO100X70",
        uri: "soup_service_unit_co-sco100x70",
        category: "soup_service_unit"
       },
       {
        id: 612,
        tigerCode: 347241,
        name: "ЛИНИЯ ГОРЯЧЕГО СЕРВИСА CE-SSI-GN-1-1X2-100",
        brand: "CROM",
        size: "1000x700x850\/1300",
        productCode: "CE-SSI-GN-1-1X2-100",
        uri: "hot_service_unit_ce-ssi-gn-1-1x2-100",
        category: "hot_service_unit"
       },
       {
        id: 613,
        tigerCode: 347240,
        name: "ЛИНИЯ ГОРЯЧЕГО СЕРВИСА CO-SSI-GN-1-1X2-100",
        brand: "COTTO",
        size: "1000x700x850\/1300",
        productCode: "CO-SSI-GN-1-1X2-100",
        uri: "hot_service_unit_co-ssi-gn-1-1x2-100",
        category: "hot_service_unit"
       },
       {
        id: 614,
        tigerCode: 311548,
        name: "ЛИНИЯ ГОРЯЧЕГО СЕРВИСА CE-SSI-GN-1-1X3-120",
        brand: "CROM",
        size: "1200x700x850\/1300",
        productCode: "CE-SSI-GN-1-1X3-120",
        uri: "hot_service_unit_ce-ssi-gn-1-1x3-120",
        category: "hot_service_unit"
       },
       {
        id: 615,
        tigerCode: 311521,
        name: "ЛИНИЯ ГОРЯЧЕГО СЕРВИСА CO-SSI-GN-1-1X3-120",
        brand: "COTTO",
        size: "1200x700x850\/1300",
        productCode: "CO-SSI-GN-1-1X3-120",
        uri: "hot_service_unit_co-ssi-gn-1-1x3-120",
        category: "hot_service_unit"
       },
       {
        id: 616,
        tigerCode: "308331",
        name: "ЛИНИЯ ГОРЯЧЕГО СЕРВИСА CE-SSI-GN-1-1X4-150",
        brand: "CROM",
        size: "1500x700x850\/1300",
        productCode: "CE-SSI-GN-1-1X4-150",
        uri: "hot_service_unit_ce-ssi-gn-1-1x4-150",
        category: "hot_service_unit"
       },
       {
        id: 617,
        tigerCode: 305864,
        name: "ЛИНИЯ ГОРЯЧЕГО СЕРВИСА CO-SSI-GN-1-1X4-150",
        brand: "COTTO",
        size: "1500x700x850\/1300",
        productCode: "CO-SSI-GN-1-1X4-150",
        uri: "hot_service_unit_co-ssi-gn-1-1x4-150",
        category: "hot_service_unit"
       },
       {
        id: 618,
        tigerCode: "308332",
        name: "ЛИНИЯ ГОРЯЧЕГО СЕРВИСА CE-SSI-GN-1-1X5-180",
        brand: "CROM",
        size: "1800x700x850\/1300",
        productCode: "CE-SSI-GN-1-1X5-180",
        uri: "hot_service_unit_ce-ssi-gn-1-1x5-180",
        category: "hot_service_unit"
       },
       {
        id: 619,
        tigerCode: 305865,
        name: "ЛИНИЯ ГОРЯЧЕГО СЕРВИСА CO-SSI-GN-1-1X5-180",
        brand: "COTTO",
        size: "1800x700x850\/1300",
        productCode: "CO-SSI-GN-1-1X5-180",
        uri: "hot_service_unit_co-ssi-gn-1-1x5-180",
        category: "hot_service_unit"
       },
       {
        id: 620,
        tigerCode: 311551,
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CE-SSO-GN-1-1X3-120",
        brand: "CROM",
        size: "1200x700x850\/1300",
        productCode: "CE-SSO-GN-1-1X3-120",
        uri: "cold_service_unit_ce-sso-gn-1-1x3-120",
        category: "cold_service_unit"
       },
       {
        id: 621,
        tigerCode: 311524,
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CO-SSO-GN-1-1X3-120",
        brand: "COTTO",
        size: "1200x700x850\/1300",
        productCode: "CO-SSO-GN-1-1X3-120",
        uri: "cold_service_unit_co-sso-gn-1-1x3-120",
        category: "cold_service_unit"
       },
       {
        id: 622,
        tigerCode: "308336",
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CE-SSO-GN-1-1X4-150",
        brand: "CROM",
        size: "1500x700x850\/1300",
        productCode: "CE-SSO-GN-1-1X4-150",
        uri: "cold_service_unit_ce-sso-gn-1-1x4-150",
        category: "cold_service_unit"
       },
       {
        id: 623,
        tigerCode: 305869,
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CO-SSO-GN-1-1X4-150",
        brand: "COTTO",
        size: "1500x700x850\/1300",
        productCode: "CO-SSO-GN-1-1X4-150",
        uri: "cold_service_unit_co-sso-gn-1-1x4-150",
        category: "cold_service_unit"
       },
       {
        id: 624,
        tigerCode: "308337",
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CE-SSO-GN-1-1X5-180",
        brand: "CROM",
        size: "1800x700x850\/1350",
        productCode: "CE-SSO-GN-1-1X5-180",
        uri: "cold_service_unit_ce-sso-gn-1-1x5-180",
        category: "cold_service_unit"
       },
       {
        id: 625,
        tigerCode: 305870,
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CO-SSO-GN-1-1X5-180",
        brand: "COTTO",
        size: "1800x700x850\/1350",
        productCode: "CO-SSO-GN-1-1X5-180",
        uri: "cold_service_unit_co-sso-gn-1-1x5-180",
        category: "cold_service_unit"
       },
       {
        id: 626,
        tigerCode: "308339",
        name: "НЕЙТРАЛЬНАЯ СЕРВИСНАЯ ЛИНИЯ CE-SNO120X70",
        brand: "CROM",
        size: "1200x700x850\/1300",
        productCode: "CE-SNO120X70",
        uri: "neutral_service_unit_ce-sno120x70",
        category: "neutral_service_unit"
       },
       {
        id: 627,
        tigerCode: 305872,
        name: "НЕЙТРАЛЬНАЯ СЕРВИСНАЯ ЛИНИЯ CO-SNO120X70",
        brand: "COTTO",
        size: "1200x700x850\/1300",
        productCode: "CO-SNO120X70",
        uri: "neutral_service_unit_co-sno120x70",
        category: "neutral_service_unit"
       },
       {
        id: 628,
        tigerCode: "308340",
        name: "НЕЙТРАЛЬНАЯ СЕРВИСНАЯ ЛИНИЯ CE-SNO140X70",
        brand: "CROM",
        size: "1400x700x850\/1300",
        productCode: "CE-SNO140X70",
        uri: "neutral_service_unit_ce-sno140x70",
        category: "neutral_service_unit"
       },
       {
        id: 629,
        tigerCode: 305873,
        name: "НЕЙТРАЛЬНАЯ СЕРВИСНАЯ ЛИНИЯ CO-SNO140X70",
        brand: "COTTO",
        size: "1400x700x850\/1300",
        productCode: "CO-SNO140X70",
        uri: "neutral_service_unit_co-sno140x70",
        category: "neutral_service_unit"
       },
       {
        id: 630,
        tigerCode: "308341",
        name: "НЕЙТРАЛЬНАЯ СЕРВИСНАЯ ЛИНИЯ CE-SNO160X70",
        brand: "CROM",
        size: "1600x700x850\/1300",
        productCode: "CE-SNO160X70",
        uri: "neutral_service_unit_ce-sno160x70",
        category: "neutral_service_unit"
       },
       {
        id: 631,
        tigerCode: 305874,
        name: "НЕЙТРАЛЬНАЯ СЕРВИСНАЯ ЛИНИЯ CO-SNO160X70",
        brand: "COTTO",
        size: "1600x700x850\/1300",
        productCode: "CO-SNO160X70",
        uri: "neutral_service_unit_co-sno160x70",
        category: "neutral_service_unit"
       },
       {
        id: 632,
        tigerCode: 311554,
        name: "СТОЛ НЕЙТРАЛЬНОЙ СЕРВИСНОЙ ЛИНИИ CE-SNOT120X70",
        brand: "CROM",
        size: "1200x700x850\/1300",
        productCode: "CE-SNOT120X70",
        uri: "neutral_service_unit_table_ce-snot120x70",
        category: "neutral_service_unit_table"
       },
       {
        id: 633,
        tigerCode: 311527,
        name: "СТОЛ НЕЙТРАЛЬНОЙ СЕРВИСНОЙ ЛИНИИ CO-SNOT120X70",
        brand: "COTTO",
        size: "1200x700x850\/1300",
        productCode: "CO-SNOT120X70",
        uri: "neutral_service_unit_table_co-snot120x70",
        category: "neutral_service_unit_table"
       },
       {
        id: 634,
        tigerCode: 311555,
        name: "СТОЛ НЕЙТРАЛЬНОЙ СЕРВИСНОЙ ЛИНИИ CE-SNOT140X70",
        brand: "CROM",
        size: "1400x700x850\/1300",
        productCode: "CE-SNOT140X70",
        uri: "neutral_service_unit_table_ce-snot140x70",
        category: "neutral_service_unit_table"
       },
       {
        id: 635,
        tigerCode: 311528,
        name: "СТОЛ НЕЙТРАЛЬНОЙ СЕРВИСНОЙ ЛИНИИ CO-SNOT140X70",
        brand: "COTTO",
        size: "1400x700x850\/1300",
        productCode: "CO-SNOT140X70",
        uri: "neutral_service_unit_table_co-snot140x70",
        category: "neutral_service_unit_table"
       },
       {
        id: 636,
        tigerCode: 311556,
        name: "СТОЛ НЕЙТРАЛЬНОЙ СЕРВИСНОЙ ЛИНИИ CE-SNOT160X70",
        brand: "CROM",
        size: "1600x700x850\/1300",
        productCode: "CE-SNOT160X70",
        uri: "neutral_service_unit_table_ce-snot160x70",
        category: "neutral_service_unit_table"
       },
       {
        id: 637,
        tigerCode: 311529,
        name: "СТОЛ НЕЙТРАЛЬНОЙ СЕРВИСНОЙ ЛИНИИ CO-SNOT160X70",
        brand: "COTTO",
        size: "1600x700x850\/1300",
        productCode: "CO-SNOT160X70",
        uri: "neutral_service_unit_table_co-snot160x70",
        category: "neutral_service_unit_table"
       },
       {
        id: 638,
        tigerCode: 308342,
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CE-SST120X70",
        brand: "CROM",
        size: "1200x700x850\/1615",
        productCode: "CE-SST120X70",
        uri: "refrigerated_show_case_ce-sst120x70",
        category: "refrigerated_show_case"
       },
       {
        id: 639,
        tigerCode: 305875,
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CO-SST120X70",
        brand: "COTTO",
        size: "1200x700x850\/1615",
        productCode: "CO-SST120X70",
        uri: "refrigerated_show_case_co-sst120x70",
        category: "refrigerated_show_case"
       },
       {
        id: 640,
        tigerCode: "308343",
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CE-SST140X70",
        brand: "CROM",
        size: "1400x700x850\/1615",
        productCode: "CE-SST140X70",
        uri: "refrigerated_show_case_ce-sst140x70",
        category: "refrigerated_show_case"
       },
       {
        id: 641,
        tigerCode: 305876,
        name: "ЛИНИЯ ХОЛОДНОГО СЕРВИСА CO-SST140X70",
        brand: "COTTO",
        size: "1400x700x850\/1615",
        productCode: "CO-SST140X70",
        uri: "refrigerated_show_case_co-sst140x70",
        category: "refrigerated_show_case"
       },
       {
        id: 642,
        tigerCode: "308346",
        name: "КАССИРНАЯ ЛИНИЯ CE-SKA140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-SKA140X70",
        uri: "cashier_unit_ce-ska140x70",
        category: "cashier_unit"
       },
       {
        id: 643,
        tigerCode: 305879,
        name: "КАССИРНАЯ ЛИНИЯ CO-SKA140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-SKA140X70",
        uri: "cashier_unit_co-ska140x70",
        category: "cashier_unit"
       },
       {
        id: 644,
        tigerCode: "308347",
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CE-TSD120X70",
        brand: "CROM",
        size: "1200x700x850",
        productCode: "CE-TSD120X70",
        uri: "table_with_hot_cupboard_ce-tsd120x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 645,
        tigerCode: 305880,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CO-TSD120X70",
        brand: "COTTO",
        size: "1200x700x850",
        productCode: "CO-TSD120X70",
        uri: "table_with_hot_cupboard_co-tsd120x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 646,
        tigerCode: 342753,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CE-TSD130X70",
        brand: "CROM",
        size: "1300x700x850",
        productCode: "CE-TSD130X70",
        uri: "table_with_hot_cupboard_ce-tsd130x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 647,
        tigerCode: 347242,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CO-TSD130X70",
        brand: "COTTO",
        size: "1300x700x850",
        productCode: "CO-TSD130X70",
        uri: "table_with_hot_cupboard_co-tsd130x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 648,
        tigerCode: "308348",
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CE-TSD140X70",
        brand: "CROM",
        size: "1400x700x850",
        productCode: "CE-TSD140X70",
        uri: "table_with_hot_cupboard_ce-tsd140x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 649,
        tigerCode: 305881,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CO-TSD140X70",
        brand: "COTTO",
        size: "1400x700x850",
        productCode: "CO-TSD140X70",
        uri: "table_with_hot_cupboard_co-tsd140x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 650,
        tigerCode: 318888,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CE-TSD150X70",
        brand: "CROM",
        size: "1500x700x850",
        productCode: "CE-TSD130X70",
        uri: "table_with_hot_cupboard_ce-tsd150x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 651,
        tigerCode: 309778,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CO-TSD150X70",
        brand: "COTTO",
        size: "1500x700x850",
        productCode: "CO-TSD150X70",
        uri: "table_with_hot_cupboard_co-tsd150x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 652,
        tigerCode: "308349",
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CE-TSD160X70",
        brand: "CROM",
        size: "1600x700x850",
        productCode: "CE-TSD160X70",
        uri: "table_with_hot_cupboard_ce-tsd160x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 653,
        tigerCode: 305882,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CO-TSD160X70",
        brand: "COTTO",
        size: "1600x700x850",
        productCode: "CO-TSD160X70",
        uri: "table_with_hot_cupboard_co-tsd160x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 654,
        tigerCode: 347244,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CE-TSD170X70",
        brand: "CROM",
        size: "1700x700x850",
        productCode: "CE-TSD130X70",
        uri: "table_with_hot_cupboard_ce-tsd170x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 655,
        tigerCode: 347243,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CO-TSD170X70",
        brand: "COTTO",
        size: "1700x700x850",
        productCode: "CO-TSD170X70",
        uri: "table_with_hot_cupboard_co-tsd170x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 656,
        tigerCode: "308350",
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CE-TSD180X70",
        brand: "CROM",
        size: "1800x700x850",
        productCode: "CE-TSD180X70",
        uri: "table_with_hot_cupboard_ce-tsd180x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 657,
        tigerCode: 305883,
        name: "СТОЛ С ТЕПЛОВЫМ ШКАФОМ CO-TSD180X70",
        brand: "COTTO",
        size: "1800x700x850",
        productCode: "CO-TSD180X70",
        uri: "table_with_hot_cupboard_co-tsd180x70",
        category: "table_with_hot_cupboard"
       },
       {
        id: 658,
        tigerCode: "308351",
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CE-SR120X40",
        brand: "CROM",
        size: "1200x400x450",
        productCode: "CE-SR120X40",
        uri: "service_shelf_one_deck_ce-sr120x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 659,
        tigerCode: 305884,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CO-SR120X40",
        brand: "COTTO",
        size: "1200x400x450",
        productCode: "CO-SR120X40",
        uri: "service_shelf_one_deck_co-sr120x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 660,
        tigerCode: 347246,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CE-SR130X40",
        brand: "CROM",
        size: "1300x400x450",
        productCode: "CE-SR130X40",
        uri: "service_shelf_one_deck_ce-sr130x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 661,
        tigerCode: 347245,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CO-SR130X40",
        brand: "COTTO",
        size: "1300x400x450",
        productCode: "CO-SR130X40",
        uri: "service_shelf_one_deck_co-sr130x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 662,
        tigerCode: "308352",
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CE-SR140X40",
        brand: "CROM",
        size: "1400x400x450",
        productCode: "CE-SR140X40",
        uri: "service_shelf_one_deck_ce-sr140x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 663,
        tigerCode: 305885,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CO-SR140X40",
        brand: "COTTO",
        size: "1400x400x450",
        productCode: "CO-SR140X40",
        uri: "service_shelf_one_deck_co-sr140x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 664,
        tigerCode: 347247,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CE-SR150X40",
        brand: "CROM",
        size: "1500x400x450",
        productCode: "CE-SR150X40",
        uri: "service_shelf_one_deck_ce-sr150x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 665,
        tigerCode: 309828,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CO-SR150X40",
        brand: "COTTO",
        size: "1500x400x450",
        productCode: "CO-SR150X40",
        uri: "service_shelf_one_deck_co-sr150x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 666,
        tigerCode: "308353",
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CE-SR160X40",
        brand: "CROM",
        size: "1600x400x450",
        productCode: "CE-SR160X40",
        uri: "service_shelf_one_deck_ce-sr160x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 667,
        tigerCode: 305886,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CO-SR160X40",
        brand: "COTTO",
        size: "1600x400x450",
        productCode: "CO-SR160X40",
        uri: "service_shelf_one_deck_co-sr160x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 668,
        tigerCode: 347249,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CE-SR170X40",
        brand: "CROM",
        size: "1700x400x450",
        productCode: "CE-SR170X40",
        uri: "service_shelf_one_deck_ce-sr170x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 669,
        tigerCode: 347248,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CO-SR170X40",
        brand: "COTTO",
        size: "1700x400x450",
        productCode: "CO-SR170X40",
        uri: "service_shelf_one_deck_co-sr170x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 670,
        tigerCode: "308354",
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CE-SR180X40",
        brand: "CROM",
        size: "1800x400x450",
        productCode: "CE-SR180X40",
        uri: "service_shelf_one_deck_ce-sr180x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 671,
        tigerCode: 305887,
        name: "СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ CO-SR180X40",
        brand: "COTTO",
        size: "1800x400x450",
        productCode: "CO-SR180X40",
        uri: "service_shelf_one_deck_co-sr180x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 672,
        tigerCode: "308355",
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CE-SR2120X40",
        brand: "CROM",
        size: "1200x400x700",
        productCode: "CE-SR2120X40",
        uri: "service_shelf_double_deck_ce-sr2120x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 673,
        tigerCode: 305888,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CO-SR2120X40",
        brand: "COTTO",
        size: "1200x400x700",
        productCode: "CO-SR2120X40",
        uri: "service_shelf_double_deck_co-sr2120x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 674,
        tigerCode: 347250,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CE-SR2130X40",
        brand: "CROM",
        size: "1300x400x700",
        productCode: "CE-SR2130X40",
        uri: "service_shelf_double_deck_ce-sr2130x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 675,
        tigerCode: 317952,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CO-SR2130X40",
        brand: "COTTO",
        size: "1300x400x700",
        productCode: "CO-SR2130X40",
        uri: "service_shelf_double_deck_co-sr2130x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 676,
        tigerCode: "308356",
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CE-SR2140X40",
        brand: "CROM",
        size: "1400x400x700",
        productCode: "CE-SR2140X40",
        uri: "service_shelf_double_deck_ce-sr2140x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 677,
        tigerCode: 305889,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CO-SR2140X40",
        brand: "COTTO",
        size: "1400x400x700",
        productCode: "CO-SR2140X40",
        uri: "service_shelf_double_deck_co-sr2140x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 678,
        tigerCode: 326682,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CE-SR2150X40",
        brand: "CROM",
        size: "1500x400x700",
        productCode: "CE-SR2150X40",
        uri: "service_shelf_double_deck_ce-sr2150x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 679,
        tigerCode: 347251,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CO-SR2150X40",
        brand: "COTTO",
        size: "1500x400x700",
        productCode: "CO-SR2150X40",
        uri: "service_shelf_double_deck_co-sr2150x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 680,
        tigerCode: "308357",
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CE-SR2160X40",
        brand: "CROM",
        size: "1600x400x700",
        productCode: "CE-SR2160X40",
        uri: "service_shelf_double_deck_ce-sr2160x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 681,
        tigerCode: 305890,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CO-SR2160X40",
        brand: "COTTO",
        size: "1600x400x700",
        productCode: "CO-SR2160X40",
        uri: "service_shelf_double_deck_co-sr2160x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 682,
        tigerCode: 346370,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CE-SR2170X40",
        brand: "CROM",
        size: "1700x400x700",
        productCode: "CE-SR2170X40",
        uri: "service_shelf_double_deck_ce-sr2170x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 683,
        tigerCode: 347252,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CO-SR2170X40",
        brand: "COTTO",
        size: "1700x400x700",
        productCode: "CO-SR2170X40",
        uri: "service_shelf_double_deck_co-sr2170x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 684,
        tigerCode: "308358",
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CE-SR2180X40",
        brand: "CROM",
        size: "1800x400x700",
        productCode: "CE-SR2180X40",
        uri: "service_shelf_double_deck_ce-sr2180x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 685,
        tigerCode: 305891,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВНЕВАЯ CO-SR2180X40",
        brand: "COTTO",
        size: "1800x400x700",
        productCode: "CO-SR2180X40",
        uri: "service_shelf_double_deck_co-sr2180x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 686,
        tigerCode: "308359",
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВ.С НАГРЕВОМ CE-SR21I120X40",
        brand: "CROM",
        size: "1200x400x700",
        productCode: "CE-SR21I120X40",
        uri: "service_shelf_double_deck_with_heater_ce-sr21i120x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 687,
        tigerCode: 305892,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВН.С НАГРЕВОМ CO-SR21I120X40",
        brand: "COTTO",
        size: "1200x400x700",
        productCode: "CO-SR21I120X40",
        uri: "service_shelf_double_deck_with_heater_co-sr21i120x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 688,
        tigerCode: 347254,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВ.С НАГРЕВОМ CE-SR21I130X40",
        brand: "CROM",
        size: "1300x400x700",
        productCode: "CE-SR21I130X40",
        uri: "service_shelf_double_deck_with_heater_ce-sr21i130x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 689,
        tigerCode: 347253,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВН.С НАГРЕВОМ CO-SR21I130X40",
        brand: "COTTO",
        size: "1300x400x700",
        productCode: "CO-SR21I130X40",
        uri: "service_shelf_double_deck_with_heater_co-sr21i130x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 690,
        tigerCode: "308360",
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВ.С НАГРЕВОМ CE-SR21I140X40",
        brand: "CROM",
        size: "1400x400x700",
        productCode: "CE-SR21I140X40",
        uri: "service_shelf_double_deck_with_heater_ce-sr21i140x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 691,
        tigerCode: 305893,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВН.С НАГРЕВОМ CO-SR21I140X40",
        brand: "COTTO",
        size: "1400x400x700",
        productCode: "CO-SR21I140X40",
        uri: "service_shelf_double_deck_with_heater_co-sr21i140x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 692,
        tigerCode: 311682,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВ.С НАГРЕВОМ CE-SR21I150X40",
        brand: "CROM",
        size: "1500x400x700",
        productCode: "CE-SR21I150X40",
        uri: "service_shelf_double_deck_with_heater_ce-sr21i150x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 693,
        tigerCode: 347255,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВН.С НАГРЕВОМ CO-SR21I150X40",
        brand: "COTTO",
        size: "1500x400x700",
        productCode: "CO-SR21I150X40",
        uri: "service_shelf_double_deck_with_heater_co-sr21i150x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 694,
        tigerCode: "308361",
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВ.С НАГРЕВОМ CE-SR21I160X40",
        brand: "CROM",
        size: "1600x400x700",
        productCode: "CE-SR21I160X40",
        uri: "service_shelf_double_deck_with_heater_ce-sr21i160x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 695,
        tigerCode: 305894,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВН.С НАГРЕВОМ CO-SR21I160X40",
        brand: "COTTO",
        size: "1600x400x700",
        productCode: "CO-SR21I160X40",
        uri: "service_shelf_double_deck_with_heater_co-sr21i160x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 696,
        tigerCode: 347257,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВ.С НАГРЕВОМ CE-SR21I170X40",
        brand: "CROM",
        size: "1700x400x700",
        productCode: "CE-SR21I170X40",
        uri: "service_shelf_double_deck_with_heater_ce-sr21i170x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 697,
        tigerCode: 347256,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВН.С НАГРЕВОМ CO-SR21I170X40",
        brand: "COTTO",
        size: "1700x400x700",
        productCode: "CO-SR21I170X40",
        uri: "service_shelf_double_deck_with_heater_co-sr21i170x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 698,
        tigerCode: "308362",
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВ.С НАГРЕВОМ CE-SR21I180X40",
        brand: "CROM",
        size: "1800x400x700",
        productCode: "CE-SR21I180X40",
        uri: "service_shelf_double_deck_with_heater_ce-sr21i180x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 699,
        tigerCode: 305895,
        name: "СЕРВИСНАЯ ПОЛКА ДВУХУРОВН.С НАГРЕВОМ CO-SR21I180X40",
        brand: "COTTO",
        size: "1800x400x700",
        productCode: "CO-SR21I180X40",
        uri: "service_shelf_double_deck_with_heater_co-sr21i180x40",
        category: "service_shelf_one_deck"
       },
       {
        id: 700,
        tigerCode: "308363",
        name: "ПОДСТАВКА ДЛЯ ПЕЧИ GN 1-1 CE-SFS610",
        brand: "CROM",
        size: "865x740x650",
        productCode: "CE-SFS610",
        uri: "oven_stand_gn_1-1_ce-sfs610",
        category: "oven_stand_gn_1-1_c"
       },
       {
        id: 701,
        tigerCode: "308364",
        name: "ПОДСТАВКА ДЛЯ ПЕЧИ GN 2-1 CE-SFE20",
        brand: "CROM",
        size: "1050x740x650",
        productCode: "CE-SFE20",
        uri: "oven_stand_gn_2-1_ce-sfe20",
        category: "oven_stand_gn_2-1_c"
       },
       {
        id: 702,
        tigerCode: "308365",
        name: "ПОДСТАВКА ДЛЯ ПИЦЦА-ПЕЧИ CE-SPF50",
        brand: "CROM",
        size: "820x660x850",
        productCode: "CE-SPF50",
        uri: "pizza_oven_stand_ce-spf50",
        category: "pizza_oven_stand"
       },
       {
        id: 703,
        tigerCode: "308366",
        name: "ПОДСТАВКА ДЛЯ ПИЦЦА-ПЕЧИ CE-SPF62",
        brand: "CROM",
        size: "910x740x850",
        productCode: "CE-SPF62",
        uri: "pizza_oven_stand_ce-spf62",
        category: "pizza_oven_stand"
       },
       {
        id: 704,
        tigerCode: "308367",
        name: "ПОДСТАВКА ДЛЯ ПИЦЦА-ПЕЧИ CE-SPF962",
        brand: "CROM",
        size: "1210x740x850",
        productCode: "CE-SPF962",
        uri: "pizza_oven_stand_ce-spf962",
        category: "pizza_oven_stand"
       },
       {
        id: 705,
        tigerCode: "308368",
        name: "ПОДСТАВКА ДЛЯ ПИЦЦА-ПЕЧИ CE-SPF92",
        brand: "CROM",
        size: "1210x1050x850",
        productCode: "CE-SPF92",
        uri: "pizza_oven_stand_ce-spf92",
        category: "pizza_oven_stand"
       },
       {
        id: 706,
        tigerCode: "308369",
        name: "ПОДСТАВКА ДЛЯ ОБОРУДОВАНИЯ CE-SEB60X60",
        brand: "CROM",
        size: "600x600x500",
        productCode: "CE-SEB60X60",
        uri: "equipment_stand_ce-seb_60x60",
        category: "equipment_stand"
       },
       {
        id: 707,
        tigerCode: 306564,
        name: "ПОДСТАВКА ДЛЯ ОБОРУДОВАНИЯ CO-SEB60X60",
        brand: "COTTO",
        size: "600x600x500",
        productCode: "CO-SEB60X60",
        uri: "equipment_stand_co-seb60x60",
        category: "equipment_stand"
       },
       {
        id: 708,
        tigerCode: "308370",
        name: "ПОДСТАВКА ДЛЯ ОБОРУДОВАНИЯ CE-SEK50X50",
        brand: "CROM",
        size: "500x500x500",
        productCode: "CE-SEK50X50",
        uri: "equipment_stand_ce-sek50x50",
        category: "equipment_stand"
       },
       {
        id: 709,
        tigerCode: 306562,
        name: "ПОДСТАВКА ДЛЯ ОБОРУДОВАНИЯ CO-SEK50X50",
        brand: "COTTO",
        size: "500x500x500",
        productCode: "CO-SEK50X50",
        uri: "equipment_stand_co-sek50x50",
        category: "equipment_stand"
       },
       {
        id: 710,
        tigerCode: 311559,
        name: "СТОЛ 1 ПОЛКА GRILL MASTER CE-TC1GM40X80",
        brand: "CROM",
        size: "400X800X850",
        productCode: "CE-TC1GM40X80",
        uri: "table_with_1_shelf_grill_master_ce-tc1gm40x80",
        category: "table_with_1_shelf_grill_master"
       },
       {
        id: 711,
        tigerCode: 327627,
        name: "СТОЛ 1 ПОЛКА GRILL MASTER CE-TC1GM40X80",
        brand: "CROM",
        size: "600x800x850",
        productCode: "CE-TC1GM60X80",
        uri: "table_with_1_shelf_grill_master_ce-tc1gm40x80",
        category: "table_with_1_shelf_grill_master"
       },
       {
        id: 712,
        tigerCode: 316202,
        name: "СТОЛ 1 ПОЛКА GRILL MASTER CE-TC1GM40X80",
        brand: "CROM",
        size: "800x800x850",
        productCode: "CE-TC1GM80X80",
        uri: "table_with_1_shelf_grill_master_ce-tc1gm40x80",
        category: "table_with_1_shelf_grill_master"
       },
       {
        id: 713,
        tigerCode: "308371",
        name: "ВЫТЯЖКА НАСТЕННАЯ БЕЗ ФИЛЬТРА CE-DDT100X100",
        brand: "CROM",
        size: "1000x1000x500",
        productCode: "CE-DDT100X100",
        uri: "hood_wall_type_without_filter_ce-ddt100x100",
        category: "hood_wall_type_without_filter"
       },
       {
        id: 714,
        tigerCode: "308372",
        name: "ВЫТЯЖКА НАСТЕННАЯ БЕЗ ФИЛЬТРА CE-DDT120X120",
        brand: "CROM",
        size: "1200x1200x500",
        productCode: "CE-DDT120X120",
        uri: "hood_wall_type_without_filter_ce-ddt120x120",
        category: "hood_wall_type_without_filter"
       },
       {
        id: 715,
        tigerCode: "308373",
        name: "ВЫТЯЖКА НАСТЕННАЯ БЕЗ ФИЛЬТРА CE-DDT160X120",
        brand: "CROM",
        size: "1600x1200x500",
        productCode: "CE-DDT160X120",
        uri: "hood_wall_type_without_filter_ce-ddt160x120",
        category: "hood_wall_type_without_filter"
       },
       {
        id: 716,
        tigerCode: "308374",
        name: "ВЫТЯЖКА НАСТЕННАЯ БЕЗ ФИЛЬТРА CE-DDT200X120",
        brand: "CROM",
        size: "2000x1200x500",
        productCode: "CE-DDT200X120",
        uri: "hood_wall_type_without_filter_ce-ddt200x120",
        category: "hood_wall_type_without_filter"
       },
       {
        id: 717,
        tigerCode: 311560,
        name: "ВЫТЯЖКА НАСТЕННАЯ БЕЗ ФИЛЬТРА CE-DDT240X120",
        brand: "CROM",
        size: "2400x1200x500",
        productCode: "CE-DDT240X120",
        uri: "hood_wall_type_without_filter_ce-ddt240x120",
        category: "hood_wall_type_without_filter"
       },
       {
        id: 718,
        tigerCode: 311561,
        name: "ВЫТЯЖКА НАСТЕННАЯ БЕЗ ФИЛЬТРА CE-DDT280X120",
        brand: "CROM",
        size: "2800x1200x500",
        productCode: "CE-DDT280X120",
        uri: "hood_wall_type_without_filter_ce-ddt280x120",
        category: "hood_wall_type_without_filter"
       },
       {
        id: 719,
        tigerCode: 311562,
        name: "ВЫТЯЖКА НАСТЕННАЯ БЕЗ ФИЛЬТРА CE-DDT320X120",
        brand: "CROM",
        size: "3200x1200x500",
        productCode: "CE-DDT320X120",
        uri: "hood_wall_type_without_filter_ce-ddt320x120",
        category: "hood_wall_type_without_filter"
       },
       {
        id: 720,
        tigerCode: 311563,
        name: "ВЫТЯЖКА НАСТЕННАЯ БЕЗ ФИЛЬТРА CE-DDT360X120",
        brand: "CROM",
        size: "3600x1200x500",
        productCode: "CE-DDT360X120",
        uri: "hood_wall_type_without_filter_ce-ddt360x120",
        category: "hood_wall_type_without_filter"
       },
       {
        id: 721,
        tigerCode: 313292,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF100X100",
        brand: "CROM",
        size: "1000x1000x500",
        productCode: "CE-DDF100X100",
        uri: "hood_wall_type_with_filter_ce-ddf100x100",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 722,
        tigerCode: 309983,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF120X100",
        brand: "CROM",
        size: "1200x1000x500",
        productCode: "CE-DDF120X100",
        uri: "hood_wall_type_with_filter_ce-ddf120x100",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 723,
        tigerCode: 309300,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF140X100",
        brand: "CROM",
        size: "1400x1000x500",
        productCode: "CE-DDF140X100",
        uri: "hood_wall_type_with_filter_ce-ddf140x100",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 724,
        tigerCode: 310852,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF160X100",
        brand: "CROM",
        size: "1600x1000x500",
        productCode: "CE-DDF160X100",
        uri: "hood_wall_type_with_filter_ce-ddf160x100",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 725,
        tigerCode: 311988,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF180X100",
        brand: "CROM",
        size: "1800x1000x500",
        productCode: "CE-DDF180X100",
        uri: "hood_wall_type_with_filter_ce-ddf180x100",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 726,
        tigerCode: 342865,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF200X100",
        brand: "CROM",
        size: "2000x1000x500",
        productCode: "CE-DDF200X100",
        uri: "hood_wall_type_with_filter_ce-ddf200x100",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 727,
        tigerCode: "308375",
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF120X120",
        brand: "CROM",
        size: "1200x1200x500",
        productCode: "CE-DDF120X120",
        uri: "hood_wall_type_with_filter_ce-ddf120x120",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 728,
        tigerCode: 326158,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF140X120",
        brand: "CROM",
        size: "1400x1200x500",
        productCode: "CE-DDF140X120",
        uri: "hood_wall_type_with_filter_ce-ddf140x120",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 729,
        tigerCode: "308376",
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF160X120",
        brand: "CROM",
        size: "1600x1200x500",
        productCode: "CE-DDF160X120",
        uri: "hood_wall_type_with_filter_ce-ddf160x120",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 730,
        tigerCode: 328750,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF180X120",
        brand: "CROM",
        size: "1800x1200x500",
        productCode: "CE-DDF180X120",
        uri: "hood_wall_type_with_filter_ce-ddf180x120",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 731,
        tigerCode: "308377",
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF200X120",
        brand: "CROM",
        size: "2000x1200x500",
        productCode: "CE-DDF200X120",
        uri: "hood_wall_type_with_filter_ce-ddf200x120",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 732,
        tigerCode: "308378",
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF120X140",
        brand: "CROM",
        size: "1200x1400x500",
        productCode: "CE-DDF120X140",
        uri: "hood_wall_type_with_filter_ce-ddf120x140",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 733,
        tigerCode: 346278,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF140X140",
        brand: "CROM",
        size: "1400x1400x500",
        productCode: "CE-DDF140X140",
        uri: "hood_wall_type_with_filter_ce-ddf140x140",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 734,
        tigerCode: "308379",
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF160X140",
        brand: "CROM",
        size: "1600x1400x500",
        productCode: "CE-DDF160X140",
        uri: "hood_wall_type_with_filter_ce-ddf160x140",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 735,
        tigerCode: 347258,
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF180X140",
        brand: "CROM",
        size: "1800x1400x500",
        productCode: "CE-DDF180X140",
        uri: "hood_wall_type_with_filter_ce-ddf180x140",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 736,
        tigerCode: "308380",
        name: "ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ CE-DDF200X140",
        brand: "CROM",
        size: "2000x1400x500",
        productCode: "CE-DDF200X140",
        uri: "hood_wall_type_with_filter_ce-ddf200x140",
        category: "hood_wall_type_with_filter"
       },
       {
        id: 737,
        tigerCode: "308381",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF200X180",
        brand: "CROM",
        size: "2000x1800x500",
        productCode: "CE-DOF200X180",
        uri: "hood_central_type_with_filter_ce-dof200x180",
        category: "hood_central_type_with_filter"
       },
       {
        id: 738,
        tigerCode: "308382",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF240X180",
        brand: "CROM",
        size: "2400x1800x500",
        productCode: "CE-DOF240X180",
        uri: "hood_central_type_with_filter_ce-dof240x180",
        category: "hood_central_type_with_filter"
       },
       {
        id: 739,
        tigerCode: "308383",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF280X180",
        brand: "CROM",
        size: "2800x1800x500",
        productCode: "CE-DOF280X180",
        uri: "hood_central_type_with_filter_ce-dof280x180",
        category: "hood_central_type_with_filter"
       },
       {
        id: 740,
        tigerCode: "308384",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF320X180",
        brand: "CROM",
        size: "3200x1800x500",
        productCode: "CE-DOF320X180",
        uri: "hood_central_type_with_filter_ce-dof320x180",
        category: "hood_central_type_with_filter"
       },
       {
        id: 741,
        tigerCode: "308385",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF360X180",
        brand: "CROM",
        size: "3600x1800x500",
        productCode: "CE-DOF360X180",
        uri: "hood_central_type_with_filter_ce-dof360x180",
        category: "hood_central_type_with_filter"
       },
       {
        id: 742,
        tigerCode: "308386",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF200X220",
        brand: "CROM",
        size: "2000x2200x500",
        productCode: "CE-DOF200X220",
        uri: "hood_central_type_with_filter_ce-dof200x220",
        category: "hood_central_type_with_filter"
       },
       {
        id: 743,
        tigerCode: "308387",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF240X220",
        brand: "CROM",
        size: "2400x2200x500",
        productCode: "CE-DOF240X220",
        uri: "hood_central_type_with_filter_ce-dof240x220",
        category: "hood_central_type_with_filter"
       },
       {
        id: 744,
        tigerCode: "308388",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF280X220",
        brand: "CROM",
        size: "2800x2200x500",
        productCode: "CE-DOF280X220",
        uri: "hood_central_type_with_filter_ce-dof280x220",
        category: "hood_central_type_with_filter"
       },
       {
        id: 745,
        tigerCode: "308389",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF320X220",
        brand: "CROM",
        size: "3200x2200x500",
        productCode: "CE-DOF320X220",
        uri: "hood_central_type_with_filter_ce-dof320x220",
        category: "hood_central_type_with_filter"
       },
       {
        id: 746,
        tigerCode: "308390",
        name: "ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ CE-DOF360X220",
        brand: "CROM",
        size: "3600x2200x500",
        productCode: "CE-DOF360X220",
        uri: "hood_central_type_with_filter_ce-dof360x220",
        category: "hood_central_type_with_filter"
       },
       {
        id: 747,
        tigerCode: "311273",
        name: "ВЫТЯЖКА НАСТЕН.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DDFC120X120",
        brand: "CROM",
        size: "1200x1200x500",
        productCode: "CE-DDFC120X120",
        uri: "hood_wall_type_w-filter_double_walled_ce-ddfc120x120",
        category: "hood_wall_type_w-filter_double_walled"
       },
       {
        id: 748,
        tigerCode: "311274",
        name: "ВЫТЯЖКА НАСТЕН.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DDFC160X120",
        brand: "CROM",
        size: "1600x1200x500",
        productCode: "CE-DDFC160X120",
        uri: "hood_wall_type_w-filter_double_walled_ce-ddfc160x120",
        category: "hood_wall_type_w-filter_double_walled"
       },
       {
        id: 749,
        tigerCode: "311275",
        name: "ВЫТЯЖКА НАСТЕН.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DDFC200X120",
        brand: "CROM",
        size: "2000x1200x500",
        productCode: "CE-DDFC200X120",
        uri: "hood_wall_type_w-filter_double_walled_ce-ddfc200x120",
        category: "hood_wall_type_w-filter_double_walled"
       },
       {
        id: 750,
        tigerCode: "311276",
        name: "ВЫТЯЖКА НАСТЕН.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DDFC120X140",
        brand: "CROM",
        size: "1200x1400x500",
        productCode: "CE-DDFC120X140",
        uri: "hood_wall_type_w-filter_double_walled_ce-ddfc120x140",
        category: "hood_wall_type_w-filter_double_walled"
       },
       {
        id: 751,
        tigerCode: "311277",
        name: "ВЫТЯЖКА НАСТЕН.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DDFC160X140",
        brand: "CROM",
        size: "1600x1400x500",
        productCode: "CE-DDFC160X140",
        uri: "hood_wall_type_w-filter_double_walled_ce-ddfc160x140",
        category: "hood_wall_type_w-filter_double_walled"
       },
       {
        id: 752,
        tigerCode: "311278",
        name: "ВЫТЯЖКА НАСТЕН.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DDFC200X140",
        brand: "CROM",
        size: "2000x1400x500",
        productCode: "CE-DDFC200X140",
        uri: "hood_wall_type_w-filter_double_walled_ce-ddfc200x140",
        category: "hood_wall_type_w-filter_double_walled"
       },
       {
        id: 753,
        tigerCode: "311283",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC200X180",
        brand: "CROM",
        size: "2000x1800x500",
        productCode: "CE-DOFC200X180",
        uri: "hood_central_w-filter_double_walled_ce-dofc200x180",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 754,
        tigerCode: "311284",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC240X180",
        brand: "CROM",
        size: "2400x1800x500",
        productCode: "CE-DOFC240X180",
        uri: "hood_central_w-filter_double_walled_ce-dofc240x180",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 755,
        tigerCode: "311285",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC280X180",
        brand: "CROM",
        size: "2800x1800x500",
        productCode: "CE-DOFC280X180",
        uri: "hood_central_w-filter_double_walled_ce-dofc280x180",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 756,
        tigerCode: "311286",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC320X180",
        brand: "CROM",
        size: "3200x1800x500",
        productCode: "CE-DOFC320X180",
        uri: "hood_central_w-filter_double_walled_ce-dofc320x180",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 757,
        tigerCode: "311287",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC360X180",
        brand: "CROM",
        size: "3600x1800x500",
        productCode: "CE-DOFC360X180",
        uri: "hood_central_w-filter_double_walled_ce-dofc360x180",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 758,
        tigerCode: "311288",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC200X220",
        brand: "CROM",
        size: "2000x2200x500",
        productCode: "CE-DOFC200X220",
        uri: "hood_central_w-filter_double_walled_ce-dofc200x220",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 759,
        tigerCode: "311289",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC240X220",
        brand: "CROM",
        size: "2400x2200x500",
        productCode: "CE-DOFC240X220",
        uri: "hood_central_w-filter_double_walled_ce-dofc240x220",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 760,
        tigerCode: "311290",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC280X220",
        brand: "CROM",
        size: "2800x2200x500",
        productCode: "CE-DOFC280X220",
        uri: "hood_central_w-filter_double_walled_ce-dofc280x220",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 761,
        tigerCode: "311291",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC320X220",
        brand: "CROM",
        size: "3200x2200x500",
        productCode: "CE-DOFC320X220",
        uri: "hood_central_w-filter_double_walled_ce-dofc320x220",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 762,
        tigerCode: "311292",
        name: "ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.CE-DOFC360X220",
        brand: "CROM",
        size: "3600x2200x500",
        productCode: "CE-DOFC360X220",
        uri: "hood_central_w-filter_double_walled_ce-dofc360x220",
        category: "hood_central_w-filter_double_walled"
       },
       {
        id: 763,
        tigerCode: 347259,
        name: "ПОЛКА ДЛЯ ВЫТЯЖКИ CE-DOFR160X40",
        brand: "CROM",
        size: "1600x400x500",
        productCode: "CE-DOFR160X40",
        uri: "hood_shelf_ce-dofr160x40",
        category: "hood_shelf"
       },
       {
        id: 764,
        tigerCode: 347260,
        name: "ПОЛКА ДЛЯ ВЫТЯЖКИ CE-DOFR180X40",
        brand: "CROM",
        size: "1800x400x500",
        productCode: "CE-DOFR180X40",
        uri: "hood_shelf_ce-dofr180x40",
        category: "hood_shelf"
       },
       {
        id: 765,
        tigerCode: "311293",
        name: "ПОЛКА ДЛЯ ВЫТЯЖКИ CE-DOFR200X40",
        brand: "CROM",
        size: "2000x400x500",
        productCode: "CE-DOFR200X40",
        uri: "hood_shelf_ce-dofr200x40",
        category: "hood_shelf"
       },
       {
        id: 766,
        tigerCode: "311294",
        name: "ПОЛКА ДЛЯ ВЫТЯЖКИ CE-DOFR240X40",
        brand: "CROM",
        size: "2400x400x500",
        productCode: "CE-DOFR240X40",
        uri: "hood_shelf_ce-dofr240x40",
        category: "hood_shelf"
       },
       {
        id: 767,
        tigerCode: "311295",
        name: "ПОЛКА ДЛЯ ВЫТЯЖКИ CE-DOFR280X40",
        brand: "CROM",
        size: "2800x400x500",
        productCode: "CE-DOFR280X40",
        uri: "hood_shelf_ce-dofr280x40",
        category: "hood_shelf"
       },
       {
        id: 768,
        tigerCode: "311296",
        name: "ПОЛКА ДЛЯ ВЫТЯЖКИ CE-DOFR320X40",
        brand: "CROM",
        size: "3200x400x500",
        productCode: "CE-DOFR320X40",
        uri: "hood_shelf_ce-dofr320x40",
        category: "hood_shelf"
       },
       {
        id: 769,
        tigerCode: "311297",
        name: "ПОЛКА ДЛЯ ВЫТЯЖКИ CE-DOFR360X40",
        brand: "CROM",
        size: "3600x400x500",
        productCode: "CE-DOFR360X40",
        uri: "hood_shelf_ce-dofr360x40",
        category: "hood_shelf"
       },
       {
        id: 770,
        tigerCode: "311303",
        name: "ОСВЕЩЕНИЕ ДЛЯ ВЫТЯЖКИ CE-DLA60",
        brand: "CROM",
        size: "580X30X40",
        productCode: "CE-DLA60",
        uri: "hood_led_lighting_ce-dla60",
        category: "hood_led_lighting"
       },
       {
        id: 771,
        tigerCode: "311304",
        name: "ОСВЕЩЕНИЕ ДЛЯ ВЫТЯЖКИ CE-DLA90",
        brand: "CROM",
        size: "880X30X40",
        productCode: "CE-DLA90",
        uri: "hood_led_lighting_ce-dla90",
        category: "hood_led_lighting"
       },
       {
        id: 772,
        tigerCode: "311305",
        name: "ОСВЕЩЕНИЕ ДЛЯ ВЫТЯЖКИ CE-DLA120",
        brand: "CROM",
        size: "1200X30X40",
        productCode: "CE-DLA120",
        uri: "hood_led_lighting_ce-dla120",
        category: "hood_led_lighting"
       },
       {
        id: 773,
        tigerCode: 305848,
        name: "ТЕЛЕЖКА С ВЕШАЛКОЙ ДЛЯ МЯСА CO-AEA120X55",
        brand: "COTTO",
        size: "1200x550x1700",
        productCode: "CO-AEA120X55",
        uri: "meat_carcass_hanger_co-aea120x55",
        category: "meat_carcass_hanger"
       },
       {
        id: 774,
        tigerCode: 305849,
        name: "ТЕЛЕЖКА С ВЕШАЛКОЙ ДЛЯ МЯСА CO-AEA150X55",
        brand: "COTTO",
        size: "1500x550x1700",
        productCode: "CO-AEA150X55",
        uri: "meat_carcass_hanger_co-aea150x55",
        category: "meat_carcass_hanger"
       },
       {
        id: 775,
        tigerCode: 305850,
        name: "ТЕЛЕЖКА ДЛЯ МЯСА CO-AEC59X70",
        brand: "COTTO",
        size: "598x650x1650",
        productCode: "CO-AEC59X70",
        uri: "meat_thawing_trolley_co-aec59x70",
        category: "meat_thawing_trolley"
       },
       {
        id: 776,
        tigerCode: 349750,
        productCode: "CTE7-01",
        category: "fritoz_ct7e",
        name: "ФРИТЮРНИЦА_ЭЛЕКТРИЧЕСКАЯ_CTE7-01",
        brand: "14_lt_\/0,26_m³\/10,5_kW-400_V",
        size: "400x700x300"
       },
       {
        id: 777,
        tigerCode: 349751,
        productCode: "CTE7-02",
        category: "fritoz_ct7e",
        name: "ФРИТЮРНИЦА ЭЛЕКТРИЧЕСКАЯ  CTE7-02",
        brand: "14+14 lt \/0,55 m³\/21,0 kW-400 V",
        size: "800x700x300"
       },
       {
        id: 778,
        tigerCode: 349752,
        productCode: "CTE7-03",
        category: "fritoz_ct7e",
        name: "МАРМИТ ЭЛЕКТРИЧЕСКИЙ CTE7-03",
        brand: "GN 1\/1 \/ 0,26 m³\/1,5 kW-230 V",
        size: "400x700x300"
       },
       {
        id: 779,
        tigerCode: 349753,
        productCode: "CTE7-04",
        category: "fritoz_ct7e",
        name: "МАРМИТ ЭЛЕКТРИЧЕСКИЙ ДЛЯ КАРТОФЕЛЯ ФРИ CTE7-04",
        brand: "0,26 m³\/1,0 kW-230 V",
        size: "400x700x300"
       },
       {
        id: 780,
        tigerCode: 349754,
        productCode: "CTE7-05",
        category: "fritoz_ct7e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ CTE7-05",
        brand: "2 GOZ \/ 0,26 m³\/5,2 kW-400 V",
        size: "400x700x300"
       },
       {
        id: 781,
        tigerCode: 349755,
        productCode: "CTE7-06",
        category: "fritoz_ct7e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ CTE7-06",
        brand: "4 GOZ \/ 0,55 m³\/10,4 kW-400 V",
        size: "800x700x300"
       },
       {
        id: 782,
        tigerCode: 349756,
        productCode: "CTE7-07",
        category: "fritoz_ct7e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ CTE7-07",
        brand: "6 GOZ \/ 0,84 m³\/15,6 kW-400 V",
        size: "1200x700x300"
       },
       {
        id: 783,
        tigerCode: 349757,
        productCode: "CTE7-08",
        category: "fritoz_ct7e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ С ДУХОВКОЙ CTE7-08",
        brand: "4 GOZ\/ 0,55 m³\/15,4 kW-400 V-300C°",
        size: "800x700x850"
       },
       {
        id: 784,
        tigerCode: 349758,
        productCode: "CTE7-09",
        category: "fritoz_ct7e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ С ДУХОВКОЙ CTE7-09",
        brand: "6 GOZ \/ 0,84 m³\/20,6 kW-400 V-300C°",
        size: "1200x700x850"
       },
       {
        id: 785,
        tigerCode: 349759,
        productCode: "CTE7-10",
        category: "fritoz_ct7e",
        name: "ПЛИТА ИНДУКЦИОННАЯ CTE7-10",
        brand: "2 GOZ\/3.5kw+3.5kw-400 V",
        size: "400x700x300"
       },
       {
        id: 786,
        tigerCode: 349760,
        productCode: "CTE7-11",
        category: "fritoz_ct7e",
        name: "ПЛИТА ИНДУКЦИОННАЯ CTE7-11",
        brand: "4 GOZ\/3.5х4=14kw-400 V",
        size: "800x700x300"
       },
       {
        id: 787,
        tigerCode: 349761,
        productCode: "CTE7-12",
        category: "fritoz_ct7e",
        name: "ПЛИТА ИНДУКЦИОННАЯ CTE7-12",
        brand: "6 GOZ\/3.5х6=21kw-400 V",
        size: "1200x700x300"
       },
       {
        id: 788,
        tigerCode: 349762,
        productCode: "CTE7-13",
        category: "fritoz_ct7e",
        name: "МАКАРОНОВАРКА ЭЛЕКТРИЧЕСКАЯ CTE7-13",
        brand: "14 lt \/0,26 m³\/6,0 kW-400 V",
        size: "400x700x300"
       },
       {
        id: 789,
        tigerCode: 349763,
        productCode: "CTE7-14",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE7-14",
        brand: "0,26 m³\/3,6 kW-400 V",
        size: "400x700x300"
       },
       {
        id: 790,
        tigerCode: 349764,
        productCode: "CTE7-15",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE7-15",
        brand: "0,55 m³\/7,2 kW-400 V",
        size: "800x700x300"
       },
       {
        id: 791,
        tigerCode: 349765,
        productCode: "CTE7-16",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE7-16",
        brand: "0,26 m³\/3,6 kW-400 V",
        size: "400x700x300"
       },
       {
        id: 792,
        tigerCode: 349766,
        productCode: "CTE7-17",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE7-17",
        brand: "0,55 m³\/7,2 kW-400 V",
        size: "800x700x300"
       },
       {
        id: 793,
        tigerCode: 349767,
        productCode: "CTE7-18",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE7-18",
        brand: "0,55 m³\/7,2 kW-400 V",
        size: "800x700x300"
       },
       {
        id: 794,
        tigerCode: 349768,
        productCode: "CTE7-22",
        category: "fritoz_ct7e",
        name: "СКОВОРОДА ОПРОКИДЫВАЕМАЯ ЭЛЕКТРИЧЕСКАЯ CTE7-22",
        brand: "0,55 m³\/7,2 kW-400 V",
        size: "800X700X850"
       },
       {
        id: 795,
        tigerCode: 349769,
        productCode: "CTE7-23",
        category: "fritoz_ct7e",
        name: "КОТЕЛ ВАРОЧНЫЙ ЭЛЕКТРИЧЕСКИЙ CTE7-23",
        brand: "0,55 m³\/15 kW-400 V",
        size: "800X700X850"
       },
       {
        id: 796,
        tigerCode: 349770,
        productCode: "CTG7-01",
        category: "fritoz_ct7e",
        name: "ФРИТЮРНИЦА ГАЗОВАЯ CTG7-01",
        brand: "14 lt \/0,26 m³\/15,0 kW",
        size: "400x700x850"
       },
       {
        id: 797,
        tigerCode: 349771,
        productCode: "CTG7-02",
        category: "fritoz_ct7e",
        name: "ФРИТЮРНИЦА ГАЗОВАЯ CTG7-02",
        brand: "14+14 lt \/0,55 m³\/30,0 kW",
        size: "800x700x850"
       },
       {
        id: 798,
        tigerCode: 349772,
        productCode: "CTG7-04",
        category: "fritoz_ct7e",
        name: "ПЛИТА ГАЗОВАЯ CTG7-04",
        brand: "2 GOZ \/0,26 m³\/12,0 kW",
        size: "400x700x300"
       },
       {
        id: 799,
        tigerCode: 349773,
        productCode: "CTG7-05",
        category: "fritoz_ct7e",
        name: "ПЛИТА ГАЗОВАЯ CTG7-05",
        brand: "4 GOZ \/0,55 m³\/24,0 kW",
        size: "800x700x300"
       },
       {
        id: 800,
        tigerCode: 349774,
        productCode: "CTG7-06",
        category: "fritoz_ct7e",
        name: "ПЛИТА ГАЗОВАЯ CTG7-06",
        brand: "6 GOZ  \/0,84 m³\/36,0 kW",
        size: "1200x700x300"
       },
       {
        id: 801,
        tigerCode: 349775,
        productCode: "CTG7-07",
        category: "fritoz_ct7e",
        name: "ПЛИТА ГАЗОВАЯ С ДУХОВКОЙ CTG7-07",
        brand: "4 GOZ  \/0,55 m³\/32,0 kW",
        size: "800x700x850"
       },
       {
        id: 802,
        tigerCode: 349776,
        productCode: "CTG7-08",
        category: "fritoz_ct7e",
        name: "ПЛИТА ГАЗОВАЯ С ДУХОВКОЙ CTG7-08",
        brand: "6 GOZ  \/0,84 m³\/44,0 kW",
        size: "1200x700x850"
       },
       {
        id: 803,
        tigerCode: 349777,
        productCode: "CTG7-10",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG7-10",
        brand: "0,26 m³\/6,0 kW",
        size: "400x700x300"
       },
       {
        id: 804,
        tigerCode: 349778,
        productCode: "CTG7-11",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG7-11",
        brand: "0,55 m³\/12,0kW",
        size: "800x700x300"
       },
       {
        id: 805,
        tigerCode: 349779,
        productCode: "CTG7-12",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG7-12",
        brand: "0,26 m³\/6,0 kW",
        size: "400x700x300"
       },
       {
        id: 806,
        tigerCode: 349780,
        productCode: "CTG7-13",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG7-13",
        brand: "0,55 m³\/12,0kW",
        size: "800x700x300"
       },
       {
        id: 807,
        tigerCode: 349781,
        productCode: "CTG7-14",
        category: "fritoz_ct7e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG7-14",
        brand: "0,55 m³\/12,0kW",
        size: "800x700x300"
       },
       {
        id: 808,
        tigerCode: 349782,
        productCode: "CTG7-15",
        category: "fritoz_ct7e",
        name: "ГРИЛЬ-БАРБЕКЮ ГАЗОВЫЙ CTG7-15",
        brand: "0,26 m³\/6,0 kW",
        size: "400x700x300"
       },
       {
        id: 809,
        tigerCode: 349783,
        productCode: "CTG7-16",
        category: "fritoz_ct7e",
        name: "ГРИЛЬ-БАРБЕКЮ ГАЗОВЫЙ CTG7-16",
        brand: "0,55 m³\/12,0 kW",
        size: "800x700x300"
       },
       {
        id: 810,
        tigerCode: 349784,
        productCode: "CTG7-17",
        category: "fritoz_ct7e",
        name: "ПЛИТА ГАЗОВАЯ WOK CTG7-17",
        brand: "1 GOZ \/ 0,46 m³\/18,00 kW",
        size: "400x700X300"
       },
       {
        id: 811,
        tigerCode: 349785,
        productCode: "CTG7-18",
        category: "fritoz_ct7e",
        name: "ПЛИТА ГАЗОВАЯ WOK CTG7-18",
        brand: "2 GOZ \/ 0,73 m³\/36,00 kW",
        size: "800x700x300"
       },
       {
        id: 812,
        tigerCode: 349786,
        productCode: "CTG7-19",
        category: "fritoz_ct7e",
        name: "СКОВОРОДА ОПРОКИДЫВАЕМАЯ ГАЗОВАЯ CTG7-19",
        brand: "0,55 m³\/18kW",
        size: "800X700X850"
       },
       {
        id: 813,
        tigerCode: 349787,
        productCode: "CTN7-1",
        category: "fritoz_ct7e",
        name: "СТОЛ ПРОМЕЖУТОЧНЫЙ CTN7-1",
        size: "400x700x300"
       },
       {
        id: 814,
        tigerCode: 349788,
        productCode: "CTN7-2",
        category: "fritoz_ct7e",
        name: "СТОЛ ПРОМЕЖУТОЧНЫЙ CTN7-2",
        size: "800x700x300"
       },
       {
        id: 815,
        tigerCode: 349789,
        productCode: "CTN7-3",
        category: "fritoz_ct7e",
        name: "ПОДСТАВКА-ШКАФ CTN7-3",
        size: "400x700x550"
       },
       {
        id: 816,
        tigerCode: 349790,
        productCode: "CTN7-4",
        category: "fritoz_ct7e",
        name: "ПОДСТАВКА-ШКАФ CTN7-4",
        size: "800x700x550"
       },
       {
        id: 817,
        tigerCode: 349791,
        productCode: "CTN7-5",
        category: "fritoz_ct7e",
        name: "ПОДСТАВКА-ШКАФ CTN7-5",
        size: "1200x700x550"
       },
       {
        id: 818,
        tigerCode: 349792,
        productCode: "CTN7-9",
        category: "fritoz_ct7e",
        name: "КОЛЕСА В КОМПЛЕКТЕ 4ШТ CTN7-9"
       },
       {
        id: 819,
        tigerCode: 349793,
        productCode: "CTN7-10",
        category: "fritoz_ct7e",
        name: "ДВЕРЬ ПРАВАЯ CTN7-10"
       },
       {
        id: 820,
        tigerCode: 349794,
        productCode: "CTN7-11",
        category: "fritoz_ct7e",
        name: "ДВЕРЬ ЛЕВАЯ CTN7-11"
       },
       {
        id: 821,
        tigerCode: 349795,
        productCode: "CTE9-01",
        category: "fritoz_ct9e",
        name: "ФРИТЮРНИЦА ЭЛЕКТРИЧЕСКАЯ CTE9-01",
        brand: "30 lt \/0,58 m³\/15,0 kW-400 V",
        size: "400x900x850 "
       },
       {
        id: 822,
        tigerCode: 349796,
        productCode: "CTE9-02",
        category: "fritoz_ct9e",
        name: "ФРИТЮРНИЦА ЭЛЕКТРИЧЕСКАЯ CTE9-02",
        brand: "30+30 lt \/1,03 m³\/30,0 kW-400 V",
        size: "800x900x850"
       },
       {
        id: 823,
        tigerCode: 349797,
        productCode: "CTE9-03",
        category: "fritoz_ct9e",
        name: "МАРМИТ ЭЛЕКТРИЧЕСКИЙ CTE9-03",
        brand: "GN 1\/1 \/ 0,58 m³\/1,5 kW-230 V",
        size: "400x900x850"
       },
       {
        id: 824,
        tigerCode: 349798,
        productCode: "CTE9-04",
        category: "fritoz_ct9e",
        name: "МАРМИТ ЭЛЕКТРИЧЕСКИЙ ДЛЯ КАРТОФЕЛЯ ФРИ CTE9-04",
        brand: "0,58 m³\/1,0 kW-230 V",
        size: "400x900x850"
       },
       {
        id: 825,
        tigerCode: 349799,
        productCode: "CTE9-05",
        category: "fritoz_ct9e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ CTE9-05",
        brand: "2 GOZ \/ 0,58 m³\/8,0 kW-400 V",
        size: "400x900x850"
       },
       {
        id: 826,
        tigerCode: 349800,
        productCode: "CTE9-06",
        category: "fritoz_ct9e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ CTE9-06",
        brand: "4 GOZ \/ 1,03 m³\/16,0 kW-400 V",
        size: "800x900x850"
       },
       {
        id: 827,
        tigerCode: 349801,
        productCode: "CTE9-07",
        category: "fritoz_ct9e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ CTE9-07",
        brand: "6 GOZ  \/ 1,48 m³\/24,0 kW-400 V",
        size: "1200x900x850"
       },
       {
        id: 828,
        tigerCode: 349802,
        productCode: "CTE9-08",
        category: "fritoz_ct9e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ С ДУХОВКОЙ CTE9-08",
        brand: "4 GOZ  \/ 1,03 m³\/21,0 kW-400 V",
        size: "800x900x850"
       },
       {
        id: 829,
        tigerCode: 349803,
        productCode: "CTE9-09",
        category: "fritoz_ct9e",
        name: "ПЛИТА ЭЛЕКТРИЧЕСКАЯ С ДУХОВКОЙ CTE9-09",
        brand: "6 GOZ \/ 1,48 m³\/29,0 kW-400 V",
        size: "1200x900x850"
       },
       {
        id: 830,
        tigerCode: 349804,
        productCode: "CTE9-10",
        category: "fritoz_ct9e",
        name: "ПЛИТА ИНДУКЦИОННАЯ CTE9-10",
        brand: "2 GOZ\/5.5kw+5.5kw-400 V",
        size: "400x900x850"
       },
       {
        id: 831,
        tigerCode: 349805,
        productCode: "CTE9-11",
        category: "fritoz_ct9e",
        name: "ПЛИТА ИНДУКЦИОННАЯ CTE9-11",
        brand: "4 GOZ\/5.5х4=22kw-400 V",
        size: "800x900x850"
       },
       {
        id: 832,
        tigerCode: 349806,
        productCode: "CTE9-12",
        category: "fritoz_ct9e",
        name: "ПЛИТА ИНДУКЦИОННАЯ CTE9-12",
        brand: "6 GOZ\/5.5х6=33kw-400 V",
        size: "1200x900x850"
       },
       {
        id: 833,
        tigerCode: 349807,
        productCode: "CTE9-13",
        category: "fritoz_ct9e",
        name: "МАКАРОНОВАРКА ЭЛЕКТРИЧЕСКАЯ CTE9-13",
        brand: "30 lt \/0,58 m³\/9,0 kW-400 V",
        size: "400x900x850"
       },
       {
        id: 834,
        tigerCode: 349808,
        productCode: "CTE9-14",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE9-14",
        brand: "0,58 m³\/6,0 kW-400 V",
        size: "400x900x850"
       },
       {
        id: 835,
        tigerCode: 349809,
        productCode: "CTE9-15",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE9-15",
        brand: "1,03 m³\/12,0 kW-400 V",
        size: "800x900x850"
       },
       {
        id: 836,
        tigerCode: 349810,
        productCode: "CTE9-16",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE9-16",
        brand: "0,58 m³\/6,0 kW-400 V",
        size: "400x900x850"
       },
       {
        id: 837,
        tigerCode: 349811,
        productCode: "CTE9-17",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE9-17",
        brand: "1,03 m³\/12,0 kW-400 V",
        size: "800x900x850"
       },
       {
        id: 838,
        tigerCode: 349812,
        productCode: "CTE9-18",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ЭЛЕКТРИЧЕСКАЯ CTE9-18",
        brand: "1,03 m³\/12,0 kW-400 V",
        size: "800x900x850"
       },
       {
        id: 839,
        tigerCode: 349813,
        productCode: "CTE9-23",
        category: "fritoz_ct9e",
        name: "СКОВОРОДА ОПРОКИДЫВАЕМАЯ ЭЛЕКТРИЧЕСКАЯ CTE9-22",
        brand: "0,55 m³\/12 kW-400 V",
        size: "800x900x850"
       },
       {
        id: 840,
        tigerCode: 349814,
        productCode: "CTE9-24",
        category: "fritoz_ct9e",
        name: "СКОВОРОДА ОПРОКИДЫВАЕМАЯ ЭЛЕКТРИЧЕСКАЯ CTE9-23",
        brand: "0,55 m³\/12 kW-400 V",
        size: "900x900x850"
       },
       {
        id: 841,
        tigerCode: 349815,
        productCode: "CTE9-25",
        category: "fritoz_ct9e",
        name: "КОТЕЛ ВАРОЧНЫЙ ЭЛЕКТРИЧЕСКИЙ CTE9-24",
        brand: "0,55 m³\/21 kW-400 V",
        size: "800x900x850"
       },
       {
        id: 842,
        tigerCode: 349816,
        productCode: "CTE9-26",
        category: "fritoz_ct9e",
        name: "КОТЕЛ ВАРОЧНЫЙ ЭЛЕКТРИЧЕСКИЙ CTE9-25",
        brand: "0,55 m³\/21 kW-400 V",
        size: "800x900x850"
       },
       {
        id: 843,
        tigerCode: 349817,
        productCode: "CTG9-1",
        category: "fritoz_ct9e",
        name: "ФРИТЮРНИЦА ГАЗОВАЯ CTG9-1",
        brand: "30 lt \/0,57 m³\/18,0 kW",
        size: "400x900x850"
       },
       {
        id: 844,
        tigerCode: 349818,
        productCode: "CTG9-2",
        category: "fritoz_ct9e",
        name: "ФРИТЮРНИЦА ГАЗОВАЯ CTG9-2",
        brand: "30+30 lt \/1,03 m³\/36,0 kW",
        size: "800x900x850"
       },
       {
        id: 845,
        tigerCode: 349819,
        productCode: "CTG9-4",
        category: "fritoz_ct9e",
        name: "ПЛИТА ГАЗОВАЯ CTG9-4",
        brand: "2 GOZ  \/0,58 m³\/14,5 kW",
        size: "400x900x850"
       },
       {
        id: 846,
        tigerCode: 349820,
        productCode: "CTG9-5",
        category: "fritoz_ct9e",
        name: "ПЛИТА ГАЗОВАЯ CTG9-5",
        brand: "4 GOZ \/1,03 m³\/29,0 kW",
        size: "800x900x850"
       },
       {
        id: 847,
        tigerCode: 349821,
        productCode: "CTG9-6",
        category: "fritoz_ct9e",
        name: "ПЛИТА ГАЗОВАЯ CTG9-6",
        brand: "6 GOZ \/1,48 m³\/43,5 kW",
        size: "1200x900x850"
       },
       {
        id: 848,
        tigerCode: 349822,
        productCode: "CTG9-7",
        category: "fritoz_ct9e",
        name: "ПЛИТА ГАЗОВАЯ С ДУХОВКОЙ CTG9-7",
        brand: "4 GOZ \/1,03 m³\/37,0 kW",
        size: "800x900x850"
       },
       {
        id: 849,
        tigerCode: 349823,
        productCode: "CTG9-8",
        category: "fritoz_ct9e",
        name: "ПЛИТА ГАЗОВАЯ С ДУХОВКОЙ CTG9-8",
        brand: "6 GOZ \/1,03 m³\/51,5 kW",
        size: "1200x900x850"
       },
       {
        id: 850,
        tigerCode: 349824,
        productCode: "CTG9-9",
        category: "fritoz_ct9e",
        name: "ПЛИТА ГАЗОВАЯ WOK CTG9-9",
        brand: "1 GOZ \/0,46 m³\/18,00 kW",
        size: "400x900x850"
       },
       {
        id: 851,
        tigerCode: 349825,
        productCode: "CTG9-10",
        category: "fritoz_ct9e",
        name: "ПЛИТА ГАЗОВАЯ WOK CTG9-10",
        brand: "2 GOZ \/0,73 m³\/36,00 kW",
        size: "800x900x850"
       },
       {
        id: 852,
        tigerCode: 349826,
        productCode: "CTG9-11",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG9-11",
        brand: "0,58 m³\/9,0 kW",
        size: "400x900x850"
       },
       {
        id: 853,
        tigerCode: 349827,
        productCode: "CTG9-12",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG9-12",
        brand: "1,03 m³\/18,0 kW",
        size: "800x900x850"
       },
       {
        id: 854,
        tigerCode: 349828,
        productCode: "CTG9-13",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG9-13",
        brand: "0,58 m³\/9,0 kW",
        size: "400x900x850"
       },
       {
        id: 855,
        tigerCode: 349829,
        productCode: "CTG9-14",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG9-14",
        brand: "1,03 m³\/18,0 kW",
        size: "800x900x850"
       },
       {
        id: 856,
        tigerCode: 349830,
        productCode: "CTG9-15",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ CTG9-15",
        brand: "1,03 m³\/18,0 kW",
        size: "800x900x850"
       },
       {
        id: 857,
        tigerCode: 349831,
        productCode: "CTG9-17",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ ЛАВОВАЯ CTG9-16",
        brand: "0,58 m³\/9,0 kW",
        size: "400X900X850"
       },
       {
        id: 858,
        tigerCode: 349832,
        productCode: "CTG9-18",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ ЛАВОВАЯ CTG9-17",
        brand: "1,03 m³\/18,0 kW",
        size: "800X900X850"
       },
       {
        id: 859,
        tigerCode: 349833,
        productCode: "CTG9-19",
        category: "fritoz_ct9e",
        name: "ЖАРОЧНАЯ ПОВЕРХНОСТЬ ГАЗОВАЯ ЛАВОВАЯ CTG9-18",
        brand: "1,48 m³\/27,0 kW",
        size: "1200X900X850"
       },
       {
        id: 860,
        tigerCode: 349834,
        productCode: "CTN9-1",
        category: "fritoz_ct9e",
        name: "СТОЛ ПРОМЕЖУТОЧНЫЙ CTN9-1",
        size: "400x900x850"
       },
       {
        id: 861,
        tigerCode: 349835,
        productCode: "CTN9-2",
        category: "fritoz_ct9e",
        name: "СТОЛ ПРОМЕЖУТОЧНЫЙ CTN9-2",
        size: "800x900x850"
       },
       {
        id: 862,
        tigerCode: 349836,
        productCode: "CTN9-9",
        category: "fritoz_ct9e",
        name: "КОЛЕСА В КОМПЛЕКТЕ 4ШТ CTN9-9"
       },
       {
        id: 863,
        tigerCode: 349837,
        productCode: "CTN9-10",
        category: "fritoz_ct9e",
        name: "ДВЕРЬ ПРАВАЯ CTN9-10"
       },
       {
        id: 864,
        tigerCode: 349838,
        productCode: "CTN9-11",
        category: "fritoz_ct9e",
        name: "ДВЕРЬ ЛЕВАЯ CTN9-11"
       },
       {
        id: 865,
        tigerCode: 349851,
        productCode: "CFE-01",
        category: "firin_statik_3_kat_cfe",
        name: "ЖАРОЧНЫЙ ШКАФ ДВУХУРОВНЕВЫЙ CFE-01",
        brand: "9 kW-380 V",
        size: "810x613x1500"
       },
       {
        id: 866,
        tigerCode: 349852,
        productCode: "CFE-02",
        category: "firin_statik_3_kat_cfe",
        name: "ЖАРОЧНЫЙ ШКАФ ТРЕХУРОВНЕВЫЕ CFE-02",
        brand: "13.5 kW-380 V",
        size: "810x613x1500"
       },
       {
        id: 867,
        tigerCode: 349853,
        productCode: "CTF-01",
        category: "tekli_ctf",
        name: "ОДИНАРНАЯ ФРИТЮРНИЦА 5 Л CTF-01",
        size: "185x413x323"
       },
       {
        id: 868,
        tigerCode: 349854,
        productCode: "CTF-02",
        category: "tekli_ctf",
        name: "ОДИНАРНАЯ И ДВОЙНАЯ ФРИТЮРНИЦА 5+5 Л CTF-02",
        size: "400x414x323"
       },
       {
        id: 869,
        tigerCode: 349855,
        productCode: "CTF-03",
        category: "tekli_ctf",
        name: "ОДИНАРНАЯ ФРИТЮРНИЦА 8 Л CTF-03",
        size: "270x413x313"
       },
       {
        id: 870,
        tigerCode: 349856,
        productCode: "CTF-04",
        category: "tekli_ctf",
        name: "ОДИНАРНАЯ И ДВОЙНАЯ ФРИТЮРНИЦА 8+8 Л CTF-04",
        size: "568x414x313"
       },
       {
        id: 871,
        tigerCode: 349839,
        productCode: "CSY-2",
        category: "refrigerated_table",
        name: "ХОЛОДИЛЬНЫЙ СТОЛ 2 ДВЕРИ CSY-2",
        brand: "(-2\/+8 ) 0,3 KW \/ 230V 1+N 50\/60Hz",
        size: "1340x700x850"
       },
       {
        id: 872,
        tigerCode: 349840,
        productCode: "CSY-3",
        category: "refrigerated_table",
        name: "ХОЛОДИЛЬНЫЙ СТОЛ 3 ДВЕРИ CSY-3",
        brand: "(-2\/+8 ) 0,39 KW \/ 230V 1+N 50\/60Hz",
        size: "1800x700x850"
       },
       {
        id: 873,
        tigerCode: 349841,
        productCode: "CSYC-4",
        category: "refrigerated_table",
        name: "ХОЛОДИЛЬНЫЙ СТОЛ 4 ЯЩИКА CSYC-4",
        brand: "(-2\/+8 ) 0,3 KW \/ 230V 1+N 50\/60Hz",
        size: "1340x700x850"
       },
       {
        id: 874,
        tigerCode: 349842,
        productCode: "CSYC-6",
        category: "refrigerated_table",
        name: "ХОЛОДИЛЬНЫЙ СТОЛ 6 ЯЩИКА CSYC-6",
        brand: "(-2\/+8 ) 0,39 KW \/ 230V 1+N 50\/60Hz",
        size: "1800x700x850"
       },
       {
        id: 875,
        tigerCode: 349843,
        productCode: "CSYN-2",
        category: "refrigerated_table",
        name: "МОРОЗИЛЬНЫЙ СТОЛ 2 ДВЕРИ CSYN-2",
        brand: "( -10\/-20 ) 0,6 KW \/ 230V 1+N 50\/60Hz",
        size: "1340x700x850"
       },
       {
        id: 876,
        tigerCode: 349844,
        productCode: "CSYN-3",
        category: "refrigerated_table",
        name: "МОРОЗИЛЬНЫЙ СТОЛ 3 ДВЕРИ CSYN-3",
        brand: "( -10\/-20 ) 0,6 KW \/ 230V 1+N 50\/60Hz",
        size: "1800x700x850"
       },
       {
        id: 877,
        tigerCode: 349845,
        productCode: "CSYNC-4",
        category: "refrigerated_table",
        name: "МОРОЗИЛЬНЫЙ СТОЛ 4 ЯЩИКА CSYNC-4",
        brand: "( -10\/-20 ) 0,6 KW \/ 230V 1+N 50\/60Hz",
        size: "1340x700x850"
       },
       {
        id: 878,
        tigerCode: 349846,
        productCode: "CSYNC-6",
        category: "refrigerated_table",
        name: "МОРОЗИЛЬНЫЙ СТОЛ 6 ЯЩИКА CSYNC-6",
        brand: "( -10\/-20 ) 0,6 KW \/ 230V 1+N 50\/60Hz",
        size: "1800x700x850"
       },
       {
        id: 879,
        tigerCode: 349847,
        productCode: "CSP-1",
        category: "refrigerated_table",
        name: "ХОЛОДИЛЬНЫЙ ШКАФ 1 ДВЕРЬ CSP-1",
        brand: "(-2\/+8 ) 0,3 KW \/ 230V 1+N 50\/60Hz",
        size: "650x800x2050"
       },
       {
        id: 880,
        tigerCode: 349848,
        productCode: "CSP-2",
        category: "refrigerated_table",
        name: "ХОЛОДИЛЬНЫЙ ШКАФ 2 ДВЕРИ CSP-2",
        brand: "(-2\/+8 ) 0,5 KW \/ 230V 1+N 50\/60Hz",
        size: "1300x800x2050"
       },
       {
        id: 881,
        tigerCode: 349849,
        productCode: "CSN-1",
        category: "refrigerated_table",
        name: "МОРОЗИЛЬНЫЙ ШКАФ 1 ДВЕРЬ CSN-1",
        brand: "( -10\/-20 ) 0,5 KW \/ 230V 1+N 50\/60Hz",
        size: "650x800x2050"
       },
       {
        id: 882,
        tigerCode: 349850,
        productCode: "CSN-2",
        category: "refrigerated_table",
        name: "МОРОЗИЛЬНЫЙ ШКАФ 2 ДВЕРИ CSN-2",
        brand: "( -10\/-20 ) 0,7 KW \/ 230V 1+N 50\/60Hz",
        size: "1300x800x2050"
       }
];

export const Category = [
    {
        id: 1,
        name: 'СТОЛ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница выполнена из листа толщиной 1,20 мм, планки из листа 1,00 мм.
        Верхняя столешница прямая, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product1.png',
        url: 'table'

    },
    {
        id: 2,
        name: 'СТОЛ 1 ПОЛКА',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница выполнена из листа толщиной 1,20 мм, планки из листа 1,00 мм.
        Верхняя столешница прямая, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product2.png',
        url: 'table_with_1_shelf'

    },
    {
        id: 3,
        name: 'СТОЛ 2 ПОЛКИ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница выполнена из листа толщиной 1,20 мм, планки из листа 1,00 мм.
        Полки выполнены из листов толщиной 1,00 мм.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product3.png',
        url: 'table_with_2_shelfs'

    },
    {
        id: 4,
        name: 'СТОЛ 1 ЯЩИК',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница выполнена из листа толщиной 1,20 мм, планки из листа 1,00 мм.
        Полки выполненыиз листов толщиной 1,00 мм.
        Верхняя столешница прямая, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        С промышленным нейлоновым блоком (N66) с двойными раздвижными дверями, однослойными; в необходимых местах укреплены изнутри.
        Раздвижные двери снизу примонтированы к нижней столешнице.
        Двери и дверные ручки изготовлены из нержавеющей стали AISI304.`,
        image: '/images/product4.png',
        url: 'table_with_1_drawer'
    },
    {
        id: 5,
        name: 'СТОЛ С БЛОКОМ ЯЩИКОВ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница выполнена из листа толщиной 1,20 мм, планки из листа 1,00 мм.
        Полки выполненыиз листов толщиной 1,00 мм.
        Верхняя столешница прямая, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        С промышленным нейлоновым блоком (N66) с двойными раздвижными дверями, однослойными; в необходимых местах укреплены изнутри.
        Раздвижные двери снизу примонтированы к нижней столешнице.
        Двери и дверные ручки изготовлены из нержавеющей стали AISI304.`,
        image: '/images/product5.png',
        url: 'table_with_drawer_block'
    },
    {
        id: 6,
        name: 'СТОЛ C РАЗДВИЖНЫМ ШКАФОM',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Поддерживается с помощью 4 профилей из нержавеющей стали.
        Под верхней и нижней столешницей имеются поддерживающие листы из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей.
        С четырьмя роликами, из них два вращающиеся на 360 градусов с тормозом, два без тормоза.
        Материал роликов выполнен из пластика, препятствующего звук.`,
        image: '/images/product6.png',
        url: 'table_with_sliding_cupboard'
    },
    {
        id: 7,
        name: 'СТОЛ C РАСПАШНЫМ ШКАФОM',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Поддерживается с помощью 4 профилей из нержавеющей стали.
        Под верхней и нижней столешницей имеются поддерживающие листы из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей.
        С четырьмя роликами, из них два вращающиеся на 360 градусов с тормозом, два без тормоза.
        Материал роликов выполнен из пластика, препятствующего звук.`,
        image: '/images/product7.png',
        url: 'table_with_wing_cupboard'
    },
    {
        id: 8,
        name: 'СТОЛ ВЕРХ ИЗ МРАМОРА',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI, основа на которую монтируется мрамор изготовлена из профиля 1.20 мм нержавеющей стали AIS304.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница из сплошного белого мрамора 30 мм, имеется задний бортик 60 мм.
        Связательные планки между ножками из листов толщиной 1.20 мм, связка толщиной 1,00 мм.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product8.png',
        url: 'table_marble_top'
    },
    {
        id: 9,
        name: 'СТОЛ ВЕРХ ПЭ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI, основа на которую монтируется полиэтилен изготовлена из профиля 1.20 мм нержавеющей стали AIS304.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница из полиэтилена толщиной 40 и 10 мм, Связательные планки между ножками из листов толщиной 1.20 мм, связка толщиной 1,00 мм.
        Задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product1.png',
        url: 'table_pe_top'
    },
    {
        id: 10,
        name: 'СТОЛ ВЕРХ ПЭ - 1 ЯЩИК',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI, основа на которую монтируется полиэтилен изготовлена из профиля 1.20 мм нержавеющей стали AIS304.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница из полиэтилена толщиной 40 и 10 мм, Связательные планки между ножками из листов толщиной 1.20 мм, связка толщиной 1,00 мм.
        Задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product4.png',
        url: 'table_pe_top-1_drawer'
    },
    {
        id: 11,
        name: 'КОЛОДА ДЛЯ РУБКИ МЯСА ВЕРХ ПЭ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI, основа на которую монтируется полиэтилен изготовлена из профиля 1.20 мм нержавеющей стали AIS304.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница из полиэтилена толщиной 40 и 10 мм, Связательные планки между ножками из листов толщиной 1.20 мм, связка толщиной 1,00 мм.
        Задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product9.png',
        url: 'chopping_block_pe'
    },
    {
        id: 12,
        name: 'СТОЛ НА РОЛИКАХ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Поддерживается с помощью 4 профилей из нержавеющей стали.
        Под верхней и нижней столешницей имеются поддерживающие листы из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей.
        С четырьмя роликами, из них два вращающиеся на 360 градусов с тормозом, два без тормоза.
        Материал роликов выполнен из пластика, препятствующего звук.`,
        image: '/images/product10.png',
        url: 'table_mobile'
    },
    {
        id: 13,
        name: 'СТОЛ С 1 МОЙКОЙ И ДВЕРЬЮ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 1,00 мм.
        Полки изготовлены из листов толщиной 1,00 мм.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        По желанию возможно полное производство изделия из нержавеющей стали AISI201.
        Размеры моек 400*500*250 , 400*500*300 , 400*400*250 , 400*400*300, изготовлены полностью из листов нержавеющей стали AISI 304 18/8 Cr-Ni.
        Толщина моек 1,00 мм.
        По желанию изготавливаются модели и двумя, тремя, четырьмя мойками.`,
        image: '/images/product11.png',
        url: 'dish_pan_w-1_sink_and_door'
    },
    {
        id: 14,
        name: 'СТОЛ С 1 МОЙКОЙ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 1,00 мм.
        Полки изготовлены из листов толщиной 1,00 мм.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        По желанию возможно полное производство изделия из нержавеющей стали AISI201.
        Размеры моек 400*500*250 , 400*500*300 , 400*400*250 , 400*400*300, изготовлены полностью из листов нержавеющей стали AISI 304 18/8 Cr-Ni.
        Толщина моек 1,00 мм.
        По желанию изготавливаются модели и двумя, тремя, четырьмя мойками.`,
        image: '/images/product12.png',
        url: 'dish_pan_with_1_sink'
    },
    {
        id: 15,
        name: 'СТОЛ С 2 МОЙКАМИ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 1,00 мм.
        Полки изготовлены из листов толщиной 1,00 мм.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        По желанию возможно полное производство изделия из нержавеющей стали AISI201.
        Размеры моек 400*500*250 , 400*500*300 , 400*400*250 , 400*400*300, изготовлены полностью из листов нержавеющей стали AISI 304 18/8 Cr-Ni.
        Толщина моек 1,00 мм.
        По желанию изготавливаются модели и двумя, тремя, четырьмя мойками.`,
        image: '/images/product13.png',
        url: 'dish_pan_with_2_sinks'
    },
    {
        id: 16,
        name: 'СТОЛ С 3 МОЙКАМИ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 1,00 мм.
        Полки изготовлены из листов толщиной 1,00 мм.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        По желанию возможно полное производство изделия из нержавеющей стали AISI201.
        Размеры моек 400*500*250 , 400*500*300 , 400*400*250 , 400*400*300, изготовлены полностью из листов нержавеющей стали AISI 304 18/8 Cr-Ni.
        Толщина моек 1,00 мм.
        По желанию изготавливаются модели и двумя, тремя, четырьмя мойками.`,
        image: '/images/product14.png',
        url: 'dish_pan_with_3_sinks'
    },
    {
        id: 17,
        name: 'ТЕХНИЧЕСКАЯ РАКОВИНА' ,
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        На верхней столешнице имеется мойка с глубоким резервуаром, над резервуаром установлена демонтируемая решетка из перевернутого U профиля.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.`,
        image: '/images/product15.png',
        url: 'mop_sink'
    },
    {
        id: 18,
        name: 'РУКОМОЙНИК С КОЛЕННЫМ УПРАВЛЕНИЕМ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        На верхней столешнице имеется мойка с глубоким резервуаром, над резервуаром установлена демонтируемая решетка из перевернутого U профиля.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.`,
        image: '/images/product16.png',
        url: 'hand_washing_unit_knee_controlled'
    },
    {
        id: 19,
        name: 'СТОЛ-МОЙКА ДЛЯ МЫТЬЯ КАЗАНА',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        На верхней столешнице имеется мойка с глубоким резервуаром, над резервуаром установлена демонтируемая решетка из перевернутого U профиля.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.`,
        image: '/images/product17.png',
        url: 'pot_washing_unit'
    },
    {
        id: 20,
        name: 'СТОЛ ПОДАЧИ ДЛЯ МЫТЬЯ КАЗАНА',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        На верхней столешнице имеется мойка с глубоким резервуаром, над резервуаром установлена демонтируемая решетка из перевернутого U профиля.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.`,
        image: '/images/product18.png',
        url: 'loading_table_for_pot_washing'
    },
    {
        id: 21,
        name: 'СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        На столе имеется отверстие для мусора для чистки посуды от остатков пищи.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.`,
        image: '/images/product19.png',
        url: 'dish_sorting_table'
    },
    {
        id: 22,
        name: 'СТОЛ ДЛЯ ГРЯЗНОЙ ПОСУДЫ С БОРТИКОМ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        На столе имеется отверстие для мусора для чистки посуды от остатков пищи.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.`,
        image: '/images/product19.png',
        url: 'dish_sorting_table_w-board'
    },
    {
        id: 23,
        name: 'ПОЛКА ДЛЯ КОРЗИН',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        На столе имеется отверстие для мусора для чистки посуды от остатков пищи.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.`,
        image: '/images/product20.png',
        url: 'basket_shelf'
    },
    {
        id: 24,
        name: 'СТОЛ ПОДАЧИ ПОСУДОМОЙКИ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Подходит для загрузочной части посудомоечной машины, система вход/передача. (Подходит для моделей BYM и BYK).
        На верхней столешнице имеется 1 резервуар для предварительной мойки посуды.
        Верхняя столешница спроектирована специально для удобного передвижения корзины с посудой.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product21.png',
        url: 'loading_table_for_diswasher'
    },
    {
        id: 25,
        name: 'СТОЛ РАЗГРУЗКИ ПОСУДОМОЙКИ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Подходит для загрузочной части посудомоечной машины, система вход/передача. (Подходит для моделей BYM и BYK).
        Верхняя столешница спроектирована специально для удобного передвижения корзины с посудой.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product22.png',
        url: 'unloading_table_for_diswasher'
    },
    {
        id: 26,
        name: 'СТОЛ ДЛЯ МЫТЬЯ ОВОЩЕЙ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        На верхней столешнице имеется мойка с глубоким резервуаром, над резервуаром установлена демонтируемая решетка из перевернутого U профиля.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Верхняя столешница сплошная, имеется задний бортик 60 мм.`,
        image: '/images/product23.png',
        url: 'vegetable_washing_unit'
    },
    {
        id: 27,
        name: 'СТОЛ ДЛЯ ОБРАБОТКИ РЫБЫ',
        group: 'any_equipmentt',
        description: `Верхняя столешница выполнена в в виде полиэтилена 80 мм
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.
        Для обеспечения жесткости на верхних углах имеется поддержка из листов нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product24.png',
        url: 'fish_preparation_unit'
    },
    {
        id: 28,
        name: 'ШКАФ НАСТЕННЫЙ C РАСПАШНЫМИ ДВЕРЬМИ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 1,00 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        С промышленным нейлоновым блоком (N66) с двойными раздвижными дверями, с двойным подгибом, однослойные; в необходимых местах укреплены изнутри.
        Раздвижные двери снизу примонтированы к нижней столешнице.
        Двери и дверные ручки изготовлены из нержавеющей стали AISI304.`,
        image: '/images/product26.png',
        url: 'wall_cabinet_with_wing_cupboard'
    },
    {
        id: 29,
        name: 'ШКАФ НАСТЕННЫЙ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 1,00 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        С промышленным нейлоновым блоком (N66) с двойными раздвижными дверями, с двойным подгибом, однослойные; в необходимых местах укреплены изнутри.
        Раздвижные двери снизу примонтированы к нижней столешнице.
        Двери и дверные ручки изготовлены из нержавеющей стали AISI304.`,
        image: '/images/product25.png',
        url: 'wall_cabinet'
    },
    {
        id: 30,
        name: 'ПОЛКА НАСТЕННАЯ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 2,00 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.`,
        image: '/images/product27.png',
        url: 'wall_shelf'
    },
    {
        id: 31,
        name: 'СТОЛ ПРЕМИКС',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 1,00 мм.
        Верхняя столешница сплошная, с двойным подгибом, имеется задний бортик 60 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product28.png',
        url: 'premix_unit'
    },
    {
        id: 32,
        name: 'СTOЛ ДЛЯ ПРИГОТОВЛЕНИЯ КОКТЕЙЛЯ И КОФЕ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Для производства ножек и несущей конструкции использован квадратный профиль из нержавеющей стали.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 1,00 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product29.png',
        url: 'coctail_preparation_unit'
    },
    {
        id: 33,
        name: 'ШКАФ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, планки 1,00 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        С промышленным нейлоновым блоком (N66) с двойными раздвижными дверями, с двойным подгибом, однослойные; в необходимых местах укреплены изнутри.
        Раздвижные двери снизу примонтированы к нижней столешнице.
        Двери и дверные ручки изготовлены из нержавеющей стали AISI304.`,
        image: '/images/product30.png',
        url: 'cupboard'
    },
    {
        id: 34,
        name: 'СТЕЛЛАЖ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Легко демонтируется при желании.
        Изготавливается в двух вариантах, со сплошной и перфорированной столешницей.`,
        image: '/images/product31.png',
        url: 'shelving_unit'
    },
    {
        id: 35,
        name: 'СТЕЛЛАЖ ДЛЯ КАЗАНА',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм.
        В зависимости от высоты стола, укрепляется при необходимости профилями из нержавеющей стали.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.
        Легко демонтируется при желании.
        Изготавливается в двух вариантах, со сплошной и перфорированной столешницей.`,
        image: '/images/product32.png',
        url: 'shelving_unit_for_pots'
    },
    {
        id: 36,
        name: 'ПОДТОВАРНИК',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Поверхность транспортировки 50*50 см спроектирована специально для удобной транспортировки корзин для посудомоечной машины с достаточным зазором.
        Толкающая ручка изготовлена из трубы из нержавеющей стали для легкого толкания тележки.
        Имеется 4 ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза.`,
        image: '/images/product33.png',
        url: 'storage_table'
    },
    {
        id: 37,
        name: 'ТЕЛЕЖКА ДЛЯ ТАРЕЛОК',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        С двумя резервуарами глубиной 60 и 120 мм.
        4 ударопогашающих резиновых ролика против столкновений.
        Имеется 4 ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза.`,
        image: '/images/product34.png',
        url: 'plate_trolley'
    },
    {
        id: 38,
        name: 'ТЕЛЕЖКА СЕРВИСНАЯ 2-УР.',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Имеется 4 ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза.
        4 ударопогашающих круглых угловых бамперов против столкновений.
        Изготавливается двух и трехуровневые.`,
        image: '/images/product35.png',
        url: 'service_trolley_2_tier'
    },
    {
        id: 39,
        name: 'ТЕЛЕЖКА СЕРВИСНАЯ 3-УР.',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Имеется 4 ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза.
        4 ударопогашающих круглых угловых бамперов против столкновений.
        Изготавливается двух и трехуровневые.`,
        image: '/images/product36.png',
        url: 'service_trolley_3_tier'
    },
    {
        id: 40,
        name: 'ТЕЛЕЖКА ДЛЯ ПЛАТФОРМЫ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Листовая сталь корпуса поддерживается квадратными профилями 40*20*1,2 мм.
        Имеется 4 ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза.`,
        image: '/images/product37.png',
        url: 'platform_trolley'
    },
    {
        id: 41,
        name: 'ТЕЛЕЖКА ДЛЯ ГАСТРОЕМКОСТЕЙ 1-1',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листа направляющих противней 1,20 мм.
        Профиль каркаса из нержавеющей стали 30*30*1,2 мм, из закрытых квадратных профилей.
        Имеется 4 ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза.`,
        image: '/images/product39.png',
        url: 'gn_tray_trolley_1-1_c'
    },
    {
        id: 42,
        name: 'ТЕЛЕЖКА ДЛЯ ГАСТРОЕМКОСТЕЙ 2-1',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листа направляющих противней 1,20 мм.
        Профиль каркаса из нержавеющей стали 30*30*1,2 мм, из закрытых квадратных профилей.
        Имеется 4 ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза.`,
        image: '/images/product38.png',
        url: 'gn_tray_trolley_2-1_c'
    },
    {
        id: 43,
        name: 'ТЕЛЕЖКА ДЛЯ ПОДНОСОВ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листа направляющих противней 1,20 мм.
        Профиль каркаса из нержавеющей стали 30*30*1,2 мм, из закрытых квадратных профилей.
        Имеется 4 ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза.`,
        image: '/images/product40.png',
        url: 'tray_trolley'
    },
    {
        id: 44,
        name: 'ПРИЛАВОК ДЛЯ СТОЛОВЫХ ПРИБОРОВ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Верхняя столешница толщиной 1,20 мм, нижняя столешница и окружение лотка для столовых приборов толщиной 1,00 мм.
        Лотки для столовых приборов (для вилок, ножей, ложек) с защитной панелью из полистрена.
        Ножки из закрытых квадратных профилей 40*40*1,2 мм из нержавеющей стали, на конце имеются вращающиеся ножки.
        По желанию клиента возможно выполнение передних и боковых фасадов из различных ламинирований под дерево вместо стальных листов.
        По желанию клиента можно добавить ползунок для передвижения подносов.`,
        image: '/images/product41.png',
        url: 'utensil_dispencer'
    },
    {
        id: 45,
        name: 'ЛИНИЯ СЕРВИСА ПЕРВЫХ БЛЮД',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листа верхней столешницы 1,20 мм, нижняя столешница и основание 1,00 мм, планки и двери 0,80 мм, боковая облицовка 0,80 мм.
        По желанию возможно добавление сервисной полки с подсветкой и подставки для подносов.
        Ножки из закрытых квадратных профилей 40*40*1,2 мм из нержавеющей стали, на конце имеются вращающиеся ножки.
        По желанию клиента возможно выполнение передних и боковых фасадов из различных ламинирований под дерево вместо стальных листов.
        По желанию клиента можно добавить ползунок для передвижения подносов.`,
        image: '/images/product42.png',
        url: 'soup_service_unit'
    },
    {
        id: 46,
        name: 'ЛИНИЯ ГОРЯЧЕГО СЕРВИСА',
        group: 'hot_equipmentt',
        description: `Электрическая
        Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листа верхней столешницы 1,20 мм, нижняя столешница и основание 1,00 мм, планки и двери 0,80 мм, боковая облицовка 0,80 мм.
        По желанию клиента устанавливается 3, 4 или 5 гастроемкостей GN1/1 глубиной 150 мм.
        По желанию возможно добавление сервисной полки с подсветкой.
        Система нагрева емкостей с пищей от силиконовых нагревателей, установленных в нижнюю часть резервуара, а также воды и образовывающегося пара.
        Управляется термостатом 0-110°C.
        Для опорожнения воды имеется шаровой вентил 3/4.
        Ножки из закрытых квадратных профилей 40*40*1,2 мм из нержавеющей стали, на конце имеются вращающиеся ножки.
        По желанию клиента возможно выполнение передних и боковых фасадов из различных ламинирований под дерево вместо стальных листов.
        По желанию клиента можно добавить ползунок для передвижения подносов.`,
        image: '/images/product43.png',
        url: 'hot_service_unit'
    },
    {
        id: 47,
        name: 'ЛИНИЯ ХОЛОДНОГО СЕРВИСА',
        group: 'cold_equipmentt',
        description: `Электрическая
        Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        По желанию клиента устанавливается 3, 4 или 5 гастроемкостей GN1/1 глубиной 150 мм.
        Выполняет охлаждение -2/+2°C.
        Верхняя столешница изготовлена из стального листа 1,2 мм.
        Двигатель находится внутри линии холодного сервиса.
        Для предотвращения переливания, вода выпаривается размораживателем внутри испарителя.
        По желанию клиента возможно выполнение передних и боковых фасадов из различных ламинирований под дерево вместо стальных листов.
        По желанию клиента можно добавить ползунок для передвижения подносов.`,
        image: '/images/product44.png',
        url: 'cold_service_unit'
    },
    {
        id: 48,
        name: 'НЕЙТРАЛЬНАЯ СЕРВИСНАЯ ЛИНИЯ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листа верхней столешницы 1,20 мм, нижняя столешница и основание 1,00 мм, планки и двери 0,80 мм, боковая облицовка 0,80 мм.
        По желанию возможно добавление сервисной полки с подсветкой и подставки для подносов.
        Ножки из закрытых квадратных профилей 40*40*1,2 мм из нержавеющей стали, на конце имеются вращающиеся ножки.
        По желанию клиента возможно выполнение передних и боковых фасадов из различных ламинирований под дерево вместо стальных листов.
        По желанию клиента можно добавить ползунок для передвижения подносов.`,
        image: '/images/product45.png',
        url: 'neutral_service_unit'
    },
    {
        id: 49,
        name: 'СТОЛ НЕЙТРАЛЬНОЙ СЕРВИСНОЙ ЛИНИИ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листа верхней столешницы 1,20 мм, нижняя столешница и основание 1,00 мм, планки и двери 0,80 мм, боковая облицовка 0,80 мм.
        По желанию возможно добавление сервисной полки с подсветкой и подставки для подносов.
        Ножки из закрытых квадратных профилей 40*40*1,2 мм из нержавеющей стали, на конце имеются вращающиеся ножки.
        По желанию клиента возможно выполнение передних и боковых фасадов из различных ламинирований под дерево вместо стальных листов.
        По желанию клиента можно добавить ползунок для передвижения подносов.`,
        image: '/images/product46.png',
        url: 'neutral_service_unit_table'
    },
    {
        id: 50,
        name: 'ЛИНИЯ ХОЛОДНОГО СЕРВИСА',
        group: 'cold_equipmentt',
        description: `Электрическая
        Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        По желанию клиента устанавливается 3, 4 или 5 гастроемкостей GN1/1 глубиной 150 мм.
        Выполняет охлаждение -2/+2°C.
        Верхняя столешница изготовлена из стального листа 1,2 мм.
        Двигатель находится внутри линии холодного сервиса.
        Для предотвращения переливания, вода выпаривается размораживателем внутри испарителя.
        По желанию клиента возможно выполнение передних и боковых фасадов из различных ламинирований под дерево вместо стальных листов.
        По желанию клиента можно добавить ползунок для передвижения подносов.`,
        image: '/images/product47.png',
        url: 'refrigerated_show_case'
    },
    {
        id: 51,
        name: 'КАССИРНАЯ ЛИНИЯ',
        group: 'any_equipmentt',
        description: 'описание4',
        image: '/images/product48.png',
        url: 'cashier_unit'
    },
    {
        id: 52,
        name: 'СТОЛ С ТЕПЛОВЫМ ШКАФОМ',
        group: 'hot_equipmentt',
        description: `Электрический
        Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Верхняя столешница изготовлена из листов толщиной 1,20 мм, нижняя столешница 1,00 мм, планка и дверь 1,00 мм, боковые облицовочные листы толщиной 0,80 мм.
        По желанию можно установить сервисную полку с подсветкой и подставку для подносов.
        Для соответствования с другими столами сервисной линии выполнен закрытым с трех сторон и изолирован стекловатой.
        С промышленным нейлоновым блоком (N66) с двойными раздвижными дверями, однослойными; в необходимых местах укреплены изнутри.
        Раздвижные двери снизу примонтированы к нижней столешнице.
        Тепловой шкаф управляется с помощью термостата 0-90C.
        Дверные ручки из нержавеющей стали AISI304.
        Тепло в шкафу распределяется равномерно благодаря турбовентилятору.
        Ножки 40*40*1,2 мм из нержавеющей стали, выполнены из закрытых квадратных профилей, с регулируемыми вращающимися ножками на конце.`,
        image: '/images/product49.png',
        url: 'table_with_hot_cupboard'
    },
    {
        id: 53,
        name: 'СЕРВИСНАЯ ПОЛКА ОДНОУРОВНЕВАЯ',
        group: 'any_equipmentt',
        description: 'описание4',
        image: '/images/product50.png',
        url: 'service_shelf_one_deck'
    },
    {
        id: 54,
        name: 'ПОДСТАВКА ДЛЯ ПЕЧИ',
        group: 'hot_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Несущая конструкция выполнена из квадратных профилей 40*40*1,20 мм, ножки из закрытых квадратных профилей 40*20*1,2 мм из нержавеющей стали.
        На конце имеются вращающиеся ножки.
        По желанию можно добавить 4 ролика вращающихся на 360°, два с тормозом, два без тормоза.`,
        image: '/images/product51.png',
        url: 'oven_stand_gn_1-1_c'
    },
    {
        id: 55,
        name: 'ПОДСТАВКА ДЛЯ ПЕЧИ GN 2-1',
        group: 'hot_equipmentt',
        description: 'описание4',
        image: '/images/product51.png',
        url: 'oven_stand_gn_2-1_c'
    },
    {
        id: 56,
        name: 'ПОДСТАВКА ДЛЯ ПИЦЦА-ПЕЧИ',
        group: 'hot_equipmentt',
        description: 'описание4',
        image: '/images/product52.png',
        url: 'pizza_oven_stand'
    },
    {
        id: 57,
        name: 'ПОДСТАВКА ДЛЯ ОБОРУДОВАНИЯ',
        group: 'any_equipmentt',
        description: 'описание4',
        image: '/images/product53.png',
        url: 'equipment_stand'
    },
    {
        id: 58,
        name: 'СТОЛ 1 ПОЛКА GRILL MASTER',
        group: 'hot_equipmentt',
        description: 'описание4',
        image: '/images/product54.png',
        url: 'table_with_1_shelf_grill_master'
    },
    {
        id: 59,
        name: 'ВЫТЯЖКА НАСТЕННАЯ БЕЗ ФИЛЬТРА',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина 1,0 мм.
        Края листов скреплены путем накладки друг на друга с помощью точечной сварки для предотвращения утечки воздуха и понижения давления внутри трубы.
        Установка вытяжки к потолку выполняется с помощью стальных дюбелей и стальных подвесных тросов покрытых пластиком.
        Соединение между вытяжкой и тросом выполняется с помощью специальных высокопрочных крюков.
        Для опорожнения жирового канала 60 мм и жира скопившегося внутри него имеется шаровой вентиль.
        При желании есть возможность установки подсветки водонепроницаемого типа.
        Имеется пламя уловительный фильтр для улавливания пламени поднимающегося до вытяжки.`,
        image: '/images/product55.png',
        url: 'hood_wall_type_without_filter'
    },
    {
        id: 60,
        name: 'ВЫТЯЖКА НАСТЕННАЯ С ФИЛЬТРОМ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина 1,0 мм.
        Края листов скреплены путем накладки друг на друга с помощью точечной сварки для предотвращения утечки воздуха и понижения давления внутри трубы.
        Установка вытяжки к потолку выполняется с помощью стальных дюбелей и стальных подвесных тросов покрытых пластиком.
        Соединение между вытяжкой и тросом выполняется с помощью специальных высокопрочных крюков.
        Для опорожнения жирового канала 60 мм и жира скопившегося внутри него имеется шаровой вентиль.
        При желании есть возможность установки подсветки водонепроницаемого типа.
        Имеется пламя уловительный фильтр для улавливания пламени поднимающегося до вытяжки.`,
        image: '/images/product56.png',
        url: 'hood_wall_type_with_filter'
    },
    {
        id: 61,
        name: 'ВЫТЯЖКА ОСТРОВНАЯ С ФИЛЬТРОМ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина 1,0 мм.
        Края листов скреплены путем накладки друг на друга с помощью точечной сварки для предотвращения утечки воздуха и понижения давления внутри трубы.
        Установка вытяжки к потолку выполняется с помощью стальных дюбелей и стальных подвесных тросов покрытых пластиком.
        Соединение между вытяжкой и тросом выполняется с помощью специальных высокопрочных крюков.
        Для опорожнения жирового канала 60 мм и жира скопившегося внутри него имеется шаровой вентиль.
        При желании есть возможность установки подсветки водонепроницаемого типа.
        Имеется пламя уловительный фильтр для улавливания пламени поднимающегося до вытяжки.`,
        image: '/images/product57.png',
        url: 'hood_central_type_with_filter'
    },
    {
        id: 62,
        name: 'ВЫТЯЖКА НАСТЕН.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина 1,0 мм.
        Края листов скреплены путем накладки друг на друга с помощью точечной сварки для предотвращения утечки воздуха и понижения давления внутри трубы.
        Установка вытяжки к потолку выполняется с помощью стальных дюбелей и стальных подвесных тросов покрытых пластиком.
        Соединение между вытяжкой и тросом выполняется с помощью специальных высокопрочных крюков.
        Для опорожнения жирового канала 60 мм и жира скопившегося внутри него имеется шаровой вентиль.
        При желании есть возможность установки подсветки водонепроницаемого типа.
        Имеется пламя уловительный фильтр для улавливания пламени поднимающегося до вытяжки.`,
        image: '/images/product58.png',
        url: 'hood_wall_type_w-filter_double_walled'
    },
    {
        id: 63,
        name: 'ВЫТЯЖКА ОСТРОВ.С ФИЛЬТР.ПРИТОЧ.-ВЫТЯЖ.',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина 1,0 мм.
        Края листов скреплены путем накладки друг на друга с помощью точечной сварки для предотвращения утечки воздуха и понижения давления внутри трубы.
        Установка вытяжки к потолку выполняется с помощью стальных дюбелей и стальных подвесных тросов покрытых пластиком.
        Соединение между вытяжкой и тросом выполняется с помощью специальных высокопрочных крюков.
        Для опорожнения жирового канала 60 мм и жира скопившегося внутри него имеется шаровой вентиль.
        При желании есть возможность установки подсветки водонепроницаемого типа.
        Имеется пламя уловительный фильтр для улавливания пламени поднимающегося до вытяжки.`,
        image: '/images/product59.png',
        url: 'hood_central_w-filter_double_walled'
    },
    {
        id: 64,
        name: 'ПОЛКА ДЛЯ ВЫТЯЖКИ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина 1,0 мм.
        Края листов скреплены путем накладки друг на друга с помощью точечной сварки для предотвращения утечки воздуха и понижения давления внутри трубы.
        Установка вытяжки к потолку выполняется с помощью стальных дюбелей и стальных подвесных тросов покрытых пластиком.
        Соединение между вытяжкой и тросом выполняется с помощью специальных высокопрочных крюков.
        Для опорожнения жирового канала 60 мм и жира скопившегося внутри него имеется шаровой вентиль.
        При желании есть возможность установки подсветки водонепроницаемого типа.
        Имеется пламя уловительный фильтр для улавливания пламени поднимающегося до вытяжки.`,
        image: '/images/product60.png',
        url: 'hood_shelf'
    },
    {
        id: 65,
        name: 'ОСВЕЩЕНИЕ ДЛЯ ВЫТЯЖКИ',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина 1,0 мм.
        Края листов скреплены путем накладки друг на друга с помощью точечной сварки для предотвращения утечки воздуха и понижения давления внутри трубы.
        Установка вытяжки к потолку выполняется с помощью стальных дюбелей и стальных подвесных тросов покрытых пластиком.
        Соединение между вытяжкой и тросом выполняется с помощью специальных высокопрочных крюков.
        Для опорожнения жирового канала 60 мм и жира скопившегося внутри него имеется шаровой вентиль.
        При желании есть возможность установки подсветки водонепроницаемого типа.
        Имеется пламя уловительный фильтр для улавливания пламени поднимающегося до вытяжки.`,
        image: '/images/product61.png',
        url: 'hood_led_lighting'
    },
    {
        id: 66,
        name: 'ТЕЛЕЖКА С ВЕШАЛКОЙ ДЛЯ МЯСА',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Специально для тяжелой нагрузки угла спаяны под углом аргонной сваркой.
        Внизу имеется сниженый, при необходимости демонтируемый для мойки поднос для накапливания крови.
        Крюки-вешалки для мяса 0,6 мм из вала из нержавеющей стали.
        Имеется 4 полиамидных ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза. (Полиамидные ролики для предотвращения износа роликов во время нахождения в холодильной камере за счет изменения температуры окружающей среды.)`,
        image: '/images/telezhka_dlia_miasa.jpg',
        url: 'meat_carcass_hanger'
    },
    {
        id: 67,
        name: 'ТЕЛЕЖКА ДЛЯ МЯСА',
        group: 'any_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Специально для тяжелой нагрузки угла спаяны под углом аргонной сваркой.
        Внизу имеется сниженый, при необходимости демонтируемый для мойки поднос для накапливания крови.
        Крюки-вешалки для мяса 0,6 мм из вала из нержавеющей стали.
        Имеется 4 полиамидных ролика, вращающихся на 360°, из которых два с тормозом, два без тормоза. (Полиамидные ролики для предотвращения износа роликов во время нахождения в холодильной камере за счет изменения температуры окружающей среды.)`,
        image: '/images/telezhka_dlia_miasa.jpg',
        url: 'meat_thawing_trolley'
    },
    {
        id: 68,
        name: 'Оборудование 700 серии',
        group: 'hot_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Специально для тяжелой нагрузки угла спаяны под углом аргонной сваркой.
        Внизу имеется сниженый, при необходимости демонтируемый для мойки поднос для накапливания крови.
        Крюки-вешалки для мяса 0,6 мм из вала из нержавеющей стали.
        `,
        image: '/images/product62.jpg',
        url: 'fritoz_ct7e'
    },
    {
        id: 69,
        name: 'Оборудование 900 серии',
        group: 'hot_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Специально для тяжелой нагрузки угла спаяны под углом аргонной сваркой.
        Внизу имеется сниженый, при необходимости демонтируемый для мойки поднос для накапливания крови.
        Крюки-вешалки для мяса 0,6 мм из вала из нержавеющей стали.
        `,
        image: '/images/product63.jpg',
        url: 'fritoz_ct9e'
    },
    {
        id: 70,
        name: 'Жарочный шкаф',
        group: 'hot_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Специально для тяжелой нагрузки угла спаяны под углом аргонной сваркой.
        Внизу имеется сниженый, при необходимости демонтируемый для мойки поднос для накапливания крови.
        Крюки-вешалки для мяса 0,6 мм из вала из нержавеющей стали.
        `,
        image: '/images/product63.jpg',
        url: 'firin_statik_3_kat_cfe'
    },
    {
        id: 71,
        name: 'НА СТОЛЬНЫЕ ФРИТЮРНИЦЫ',
        group: 'hot_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Специально для тяжелой нагрузки угла спаяны под углом аргонной сваркой.
        Внизу имеется сниженый, при необходимости демонтируемый для мойки поднос для накапливания крови.
        Крюки-вешалки для мяса 0,6 мм из вала из нержавеющей стали.
        `,
        image: '/images/product62.jpg',
        url: 'tekli_ctf'
    },
    {
        id: 72,
        name: 'Морозильное оборудование',
        group: 'cold_equipmentt',
        description: `Полностью выполнено из листов нержавеющей стали AISI304 18/8 Cr-NI.
        Толщина листов 1,20 мм.
        Специально для тяжелой нагрузки угла спаяны под углом аргонной сваркой.
        Внизу имеется сниженый, при необходимости демонтируемый для мойки поднос для накапливания крови.
        Крюки-вешалки для мяса 0,6 мм из вала из нержавеющей стали.
        `,
        image: '/images/product64.png',
        url: 'refrigerated_table'
    }
];

export const Group = [
    {
        id: 1,
        url: 'any_equipmentt',
        name: 'Нержавейка',
        description: `Вся наша мебель – столы, шкафы, полки, посудомойки – создана из высококачественных листов нержавеющей
         стали AISI304 с содержанием хрома и никеля 18/8 Cr-NI. Толщина каждого листа составляет 1,20 мм, обеспечивая прочность и надежность нашей мебели.
         Углы каждого элемента соединены с использованием аргонной сварки под особым углом, что делает нашу мебель идеальным решением для тяжелых нагрузок.`,
        image: '/images/alll_kr.png',
        
    },
    {
        id: 2,
        url: 'hot_equipmentt',
        name: 'Тепловое оборудование',
        description: `Наши уникальные печи, фритюрницы и другие элементы горячей линии обеспечивают эффективность
         и долгий срок службы благодаря использованию прочных листов нержавеющей стали AISI304. Толщина каждого листа 1,20 мм
          гарантирует устойчивость к высокой температуре и сложным рабочим условиям.
         Углы аргонной сварки обеспечивают превосходную устойчивость к нагреву, что делает наш сервис горячей линии надежным выбором.`,
        image: '/images/hot_kr.jpg',
        
    },
    {
        id: 3,
        url: 'cold_equipmentt',
        name: 'Холодильное оборудование',
        description: `Наши холодильники и морозильники изготовлены из листов нержавеющей стали AISI304 толщиной 1,20 мм.
         Этот материал обеспечивает превосходную устойчивость к коррозии и обеспечивает идеальные условия для хранения продуктов. Углы, спаянные аргонной
         сваркой, обеспечивают прочное соединение и устойчивость к изменениям температуры, что делает наши устройства холодной линии незаменимыми для вашего бизнеса.`,
        image: '/images/cold_kr.png',
        
    }
]; 
